import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Inject, Component, Input, ViewChild, Output, NgModule } from '@angular/core';
import * as i1$2 from '@angular/forms';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/material/snack-bar';
import { MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import moment from 'moment';
import { Subscription } from 'rxjs';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/platform-browser';
import * as i4$2 from '@angular/router';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i6$1 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i10 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i8$1 from '@ngneat/input-mask';
import { createMask, InputMaskModule } from '@ngneat/input-mask';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i5 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i7 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i9 from '@angular/material/select';
import { MAT_SELECT_CONFIG, MatSelectModule } from '@angular/material/select';
import * as i4$1 from '@angular/material/core';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i8 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i11 from 'ngx-mask';
import { provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { startWith, map } from 'rxjs/operators';
import * as i4$3 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i13 from 'ngx-currency';
import { NgxCurrencyDirective } from 'ngx-currency';
import * as i5$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatCardModule } from '@angular/material/card';

class FormsService {
    _snackBar;
    alertConfirmService;
    mudaPerCaminhaofilEmiter = new EventEmitter();
    mudaPerCarrofilEmiter = new EventEmitter();
    tipoVeiculoEmiter = new EventEmitter();
    tipoPessoaEmiter = new EventEmitter();
    estadoCivilEmiter = new EventEmitter();
    userInfosEmiter = new EventEmitter();
    seguradoEmiter = new EventEmitter();
    buscaControlerEmiter = new EventEmitter();
    buscaCotacoesEmiter = new EventEmitter();
    preencheFormularioEmiter = new EventEmitter();
    preencheDraftEmiter = new EventEmitter();
    formularioValidoEmiter = new EventEmitter();
    vigenciaIniEmiter = new EventEmitter();
    solicitaVigenciaIniEmiter = new EventEmitter();
    resetaFormularioEmiter = new EventEmitter();
    coberturaEmiter = new EventEmitter();
    seguradoraAnteriorEmiter = new EventEmitter();
    setarInfosDefaultEmiter = new EventEmitter();
    atualizaDraftFinal = new EventEmitter();
    clienteIndisponivelEmiter = new EventEmitter();
    constructor(_snackBar, alertConfirmService) {
        this._snackBar = _snackBar;
        this.alertConfirmService = alertConfirmService;
    }
    buscarCotacoes(obj) {
        this.buscaCotacoesEmiter.emit(obj);
    }
    clienteIndisponivel(clienteIndisponivel) {
        this.clienteIndisponivelEmiter.emit(clienteIndisponivel);
    }
    limparString(srt) {
        try {
            return srt.replace(/[\.\-\/(\/)\s)]/g, '');
        }
        catch (error) {
            false;
        }
    }
    static limparString(srt) {
        try {
            return srt.replace(/[\.\-\/(\/)\s)]/g, '');
        }
        catch (error) {
            false;
        }
    }
    formatCnpjCpf(value) {
        try {
            const cnpjCpf = value.replace(/\D/g, '');
            if (cnpjCpf.length === 11) {
                return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
            }
            return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
        }
        catch (error) {
            return "";
        }
    }
    static formatCnpjCpf(value) {
        try {
            const cnpjCpf = value.replace(/\D/g, '');
            if (cnpjCpf.length === 11) {
                return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
            }
            return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
        }
        catch (error) {
            return "";
        }
    }
    static formatCep(value) {
        try {
            const cep = value.toString();
            return cep.replace(/(\d{5})(\d{3})/g, "\$1-\$2");
        }
        catch (error) {
            return "";
        }
    }
    static formatFone(value) {
        try {
            const fone = value.toString().replaceAll('-', '');
            return fone.replace(/(\d{2})(\d{4,5})(\d{4})/g, "(\$1) \$2-\$3");
        }
        catch (error) {
            return "";
        }
    }
    static formatPlaca(value) {
        if (value) {
            let placa = value;
            placa = placa.length == 7 ? placa.replace(/(^\w{3})(\w{4})/g, "\$1-\$2") : placa;
            return placa;
        }
        else {
            return '';
        }
    }
    static formatFipe(value) {
        if (value) {
            let fipe = value;
            if (typeof (fipe) === 'string')
                fipe = fipe.length == 7 ? fipe.replace(/(\d{6})(\d{1})/g, "\$1-\$2") : fipe;
            else if (typeof (fipe) === 'number') {
                fipe = String(fipe);
                if (fipe.length < 7) {
                    fipe = ('0'.repeat(7 - fipe.length) + fipe).replace(/(\d{6})(\d{1})/g, "\$1-\$2");
                }
                else {
                    fipe = fipe.length == 7 ? fipe.replace(/(\d{6})(\d{1})/g, "\$1-\$2") : fipe;
                }
            }
            return fipe;
        }
        else {
            return '';
        }
    }
    static formatPerguntasAdicionais(draftPerfil) {
        try {
            let arrayRetorno = [];
            ConstantFormAuto.perguntasAdicionais.forEach((item) => {
                if (draftPerfil?.[item.name])
                    arrayRetorno.push(item.value);
            });
            return arrayRetorno;
        }
        catch (error) {
            return false;
        }
    }
    static atualizaPerguntasAdicionais(formulario) {
        try {
            ConstantFormAuto.perguntasAdicionais.forEach(opcoes => formulario.controls[opcoes.name].setValue(null));
            if (formulario && formulario.controls.perguntasAdicionais) {
                formulario.controls.perguntasAdicionais.value.forEach(opcaoMarcada => {
                    let nomeCampo = ConstantFormAuto.perguntasAdicionais.find(pergunta => pergunta.value == opcaoMarcada)?.name;
                    formulario.controls[nomeCampo].setValue(true);
                });
            }
        }
        catch (error) {
            return false;
        }
    }
    static formatNome(value) {
        try {
            const valorFormatado = value.split(' ').filter(parte => /[a-zA-Z]/.test(parte) || !this.validaCpfCnpj(FormsService.formatCnpjCpf(parte))).join(' ');
            return valorFormatado;
        }
        catch (error) {
            return value;
        }
    }
    static formatCombustivel(value) {
        let valorNosOptions = ConstantFormAuto.combustivel.find(opt => opt.value === value);
        return valorNosOptions ? value : ConstantFormAuto.deParaCombustivel(value);
    }
    static formatEstadoCivil(value) {
        let valorNosOptions = ConstantFormAuto.estadoCivil.find(opt => opt.value === value);
        return valorNosOptions ? value : ConstantFormAuto.deParaEstadoCivil(value);
    }
    static formatTipoResidencia(value) {
        let valorNosOptions = ConstantFormAuto.tipoResidencia.find(opt => opt.value === value);
        return valorNosOptions ? value : ConstantFormAuto.deParaTipoResidencia(value);
    }
    static formatTpUso(value) {
        let valorNosOptions = ConstantFormAuto.tpUso.find(opt => opt.value === value);
        return valorNosOptions ? value : ConstantFormAuto.deParaUsoVeiculo(value);
    }
    static formatField(nomeCampo, value) {
        switch (nomeCampo) {
            case 'cpfCnpj':
                return FormsService.formatCnpjCpf(value);
            case 'dataNasc':
            case 'vigenciaIni':
            case 'vigenciaFim':
            case 'vigIniAnterior':
            case 'vigFimAnterior':
                return FormsService.converteDataAmerica(value);
            case 'fone':
                return FormsService.formatFone(value);
            case 'cep':
            case 'cepPernoite':
                return FormsService.formatCep(value);
            case 'placa':
                return FormsService.formatPlaca(value);
            case 'fipe':
                return FormsService.formatFipe(value);
            case 'anoMod':
                return Number(value);
            case 'seguradoraAnteriorId':
                return typeof (value) === 'number' ? String(value) : value;
            case 'isencaoFiscal':
                return value == 4 ? 0 : value; // correção para o corretor digital que envia 4 por padrão
            case 'kmMensal':
                // Posição 0 do array tem o valor enviado, a posição 1 do array tem o select kmMensal
                let valoresValidosKmMensal = value[1].map(option => option.value);
                let maiorValorSelect = FormsService.getMaiorValor(value[1]);
                // Correção para robocote que envia valores maiores que possuimos no nosso select
                value = Number(value[0] > (maiorValorSelect * 12) ? (maiorValorSelect * 12) : value[0]) / 12;
                // Verifica se valor está no nosso select, caso não estiver arredonda valor recebido para a primeira opção cima dele do select
                return valoresValidosKmMensal.includes(value) ? value : valoresValidosKmMensal.find(item => item >= value);
            case 'sinistrosAnterior':
                return typeof (value) === 'number' ? value : 0;
            case 'idaVoltaEstudo':
            case 'idaVoltaTrabalho':
                return value[0] ? (value[1] ? 1 : 2) : 0;
            case 'nome':
                return value ? FormsService.formatNome(value) : "";
            case 'combustivel':
                return FormsService.formatCombustivel(value);
            case 'tpUso':
                return FormsService.formatTpUso(value);
            case 'estadoCivil':
                return FormsService.formatEstadoCivil(value);
            case 'tpResidencia':
                return FormsService.formatTipoResidencia(value);
            case 'risco':
                return typeof value === 'string' ? value : ConstantFormAuto.deParaRisco(value);
            case 'areaCirculacao':
                return typeof value === 'string' ? value : ConstantFormAuto.deParaCirculacao(value);
            case 'tipoCarga':
                return typeof value === 'string' ? value : ConstantFormAuto.deParaCarga(value);
            case 'seguroCarga':
                return typeof value === 'string' ? value : (value === false ? '0' : null);
            default:
                return value;
        }
    }
    static formatFieldToDraft(nomeCampo, value) {
        switch (nomeCampo) {
            case 'dataNasc':
            case 'vigenciaIni':
            case 'vigenciaFim':
                return FormsService.converteDataAmerica(value);
            case 'vigIniAnterior':
            case 'vigFimAnterior':
                return value ? FormsService.converteDataAmerica(value) : null;
            case 'fone':
            case 'cep':
            case 'cpfCnpj':
            case 'placa':
            case 'fipe':
            case 'cepPernoite':
            case 'cepCirculacao':
                return this.limparString(value);
            case 'anoFab':
            case 'nrEixos':
            case 'codFabr':
                return value ? Number.parseInt(value) : null;
            case 'kmMensal':
                return Number(value) * 12;
            case 'estadoCivil':
                return value ? value : null;
            case 'valReferenciado':
                return value ? this.removeNumeroMonetario(value) : null;
            case 'valorCarroceria':
                return value ? (typeof (value) === 'number' ? value : (typeof (value) === 'string' ? FormsService.removeNumeroMonetario(value) : 0)) : 0;
            case 'sinistrosAnterior':
            case 'bonusAnterior':
                return typeof (value) === 'number' ? value : 0;
            case 'passageiros':
                return value ? (typeof (value) === 'number' ? value : ((typeof (value) === 'string' && !Number.isNaN(Number.parseInt(value))) ? Number.parseInt(value) : 0)) : 0;
            default:
                return value;
        }
    }
    identificaTipoDocumento(cpfCnpj) {
        try {
            return cpfCnpj ? (cpfCnpj.length == 11 ? "CPF" : cpfCnpj.length == 14 ? "CNPJ" : "INDEFINIDO") : "INDEFINIDO";
        }
        catch (error) {
            return "INDEFINIDO";
        }
    }
    tipoVeiculo(tipoVeiculo) {
        return tipoVeiculo === 'v' ? 'AUTOMÓVEL' : (tipoVeiculo === 'c' ? 'CAMINHÃO' : (tipoVeiculo === 'M' ? 'MOTO' : 'INDEFINIDO'));
    }
    podeTerConjuge(value) {
        const relacoes = ['Casado ou União Estável'];
        return relacoes.find((a) => a == value) ? true : false;
    }
    static validarDataNascimento() {
        return (control) => {
            let dataValid = this.dataValidaNascimento(control.value);
            return !dataValid ? { validaData: { value: control.value } } : null;
        };
    }
    static dataValidaNascimento(data) {
        if (data) {
            var anoVigente = new Date(Date.now()).getFullYear();
            var data = data.split('/');
            var dia = parseInt(data[0]);
            var mes = parseInt(data[1]);
            var ano = parseInt(data[2]);
            var meses = {
                "1": { descricao: "Janeiro", dias: 31 },
                "2": { descricao: "Fevereiro", dias: this.isBissexto(ano) },
                "3": { descricao: "Março", dias: 31 },
                "4": { descricao: "Abril", dias: 30 },
                "5": { descricao: "Maio", dias: 31 },
                "6": { descricao: "Junho", dias: 30 },
                "7": { descricao: "Julho", dias: 31 },
                "8": { descricao: "Agosto", dias: 31 },
                "9": { descricao: "Setembro", dias: 30 },
                "10": { descricao: "Outubro", dias: 31 },
                "11": { descricao: "Novembro", dias: 30 },
                "12": { descricao: "Dezembro", dias: 31 }
            };
            if (mes > 0 && mes <= 12) {
                if (ano > (anoVigente - 100) && (ano <= anoVigente - 18)) {
                    if (dia > 0 && dia <= meses[mes].dias) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
    }
    static validarData() {
        return (control) => {
            let dataValid = this.dataValida(control.value);
            return !dataValid ? { validaData: { value: control.value } } : null;
        };
    }
    static dataValida(data) {
        if (data) {
            var anoVigente = new Date(Date.now()).getFullYear();
            var data = data.split('/');
            var dia = parseInt(data[0]);
            var mes = parseInt(data[1]);
            var ano = parseInt(data[2]);
            var meses = {
                "1": { descricao: "Janeiro", dias: 31 },
                "2": { descricao: "Fevereiro", dias: this.isBissexto(ano) },
                "3": { descricao: "Março", dias: 31 },
                "4": { descricao: "Abril", dias: 30 },
                "5": { descricao: "Maio", dias: 31 },
                "6": { descricao: "Junho", dias: 30 },
                "7": { descricao: "Julho", dias: 31 },
                "8": { descricao: "Agosto", dias: 31 },
                "9": { descricao: "Setembro", dias: 30 },
                "10": { descricao: "Outubro", dias: 31 },
                "11": { descricao: "Novembro", dias: 30 },
                "12": { descricao: "Dezembro", dias: 31 }
            };
            if (mes > 0 && mes <= 12) {
                if (ano > (anoVigente - 100)) {
                    if (dia > 0 && dia <= meses[mes].dias) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
    }
    static validarDataMaximaVigencia() {
        return (control) => {
            let dataValid = this.validaAnoMaximoVigencia(control.value);
            return !dataValid ? { validaData: { value: control.value } } : null;
        };
    }
    static validaAnoMaximoVigencia(date) {
        if (date) {
            var data = date.split('/');
            var ano = parseInt(data[2]);
            var dateNow = new Date();
            var yearLimit = dateNow.getFullYear() + 2;
            if (ano <= yearLimit) {
                return true;
            }
            return false;
        }
    }
    static isBissexto(ano) {
        if (ano) {
            try {
                if ((ano % 4 == 0) && ((ano % 100 != 0) || (ano % 400 == 0))) {
                    return 29;
                }
                else {
                    return 28;
                }
            }
            catch (error) {
                return false;
            }
        }
    }
    isVendaCruzada(draft) {
        return draft && !draft.hasOwnProperty('automoveis');
    }
    generateOptionsAnoModelo(anoFabricacao) {
        return [
            { value: Number(anoFabricacao), viewValue: anoFabricacao },
            { value: Number(anoFabricacao) + 1, viewValue: String(Number(anoFabricacao) + 1) }
        ];
    }
    generateOptionsSeguradoraAnterior(arraySeguradoras) {
        let options = [];
        arraySeguradoras.forEach(seguradora => {
            options.push({ value: seguradora.id, viewValue: seguradora.nome });
        });
        return options;
    }
    static validIntervaloAnos(ini, fim) {
        return (control) => {
            let dataValid = this.calIntervalAnos(control.value, ini, fim);
            return !dataValid ? { intervalAnos: { value: control.value } } : null;
        };
    }
    static calIntervalAnos(ano, ini, fim) {
        try {
            if (ano < ini || ano > fim)
                return false;
            else
                return true;
        }
        catch (error) {
            return false;
        }
    }
    static generateIntervalOptions(min, max, interval) {
        let values = [];
        for (let i = min; i <= max; i += interval)
            values.push({ value: i, viewValue: i.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) });
        return values;
    }
    tempoHabilitacaoOptionsPelaIdade(dataNascimento, _tempoHabilitacaoTxt) {
        let dataNascimentoConvertida = this.converteDataAmerica(dataNascimento);
        let optionsIndexMax = this.idade(dataNascimentoConvertida) - 18;
        let options = [];
        if (dataNascimento) {
            if (this.maiorIdade(dataNascimento)) {
                for (const key in _tempoHabilitacaoTxt) {
                    if (parseInt(key) <= optionsIndexMax || key == '0') {
                        options.push(_tempoHabilitacaoTxt[key]);
                    }
                }
                return options;
            }
            else {
                return [];
            }
        }
    }
    converteDataAmerica(data) {
        let novadata;
        if (data !== "" && data !== undefined && data !== null) {
            try {
                const regex = /(\d\/)/gm;
                if (regex.exec(data) !== null) {
                    let split = data.split('/');
                    novadata = split[2] + "-" + split[1] + "-" + split[0] + "T17:47:20.353Z";
                }
                else {
                    let dataString = /(\d{4}-\d{2}-\d{2}$)/gm;
                    if (dataString.exec(data) !== null)
                        data = data + "T17:47:20.353Z";
                    let now = new Date(data);
                    let mes = now.getMonth() + 1;
                    if ((now.getMonth() + 1) < 10)
                        mes = "0" + mes;
                    let dia = now.getDate();
                    if (now.getDate() < 10)
                        dia = "0" + dia;
                    novadata = dia + "/" + mes + "/" + now.getFullYear();
                }
                return novadata;
            }
            catch (error) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    static idade(nascimento) {
        let hoje = new Date();
        nascimento = new Date(nascimento);
        var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
        if (new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
            new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate()))
            diferencaAnos--;
        return diferencaAnos;
    }
    static maiorIdade(data) {
        if (data) {
            let idade = this.idade(this.converteDataAmerica(data));
            if (idade >= 18)
                return true;
            else
                return false;
        }
    }
    static isMaiorIdade() {
        return (control) => {
            let dataValid = this.maiorIdade(control.value);
            return !dataValid ? { validaMaiorIdade: { value: control.value } } : null;
        };
    }
    idade(nascimento) {
        let hoje = new Date();
        nascimento = new Date(nascimento);
        var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
        if (new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) <
            new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate()))
            diferencaAnos--;
        return diferencaAnos;
    }
    maiorIdade(data) {
        if (data) {
            let idade = this.idade(this.converteDataAmerica(data));
            if (idade >= 18)
                return true;
            else
                return false;
        }
    }
    static formBuilderCpfCnpj() {
        return (control) => {
            let cpfCnpjValid = this.validaCpfCnpj(control.value);
            return !cpfCnpjValid ? { validaCpfCnpj: { value: control.value } } : null;
        };
    }
    static validaCpfCnpj(val) {
        try {
            if (val.length == 14) {
                var cpf = val.trim();
                cpf = cpf.replace(/\./g, '');
                cpf = cpf.replace('-', '');
                cpf = cpf.split('');
                var v1 = 0;
                var v2 = 0;
                var aux = false;
                for (var i = 1; cpf.length > i; i++) {
                    if (cpf[i - 1] != cpf[i]) {
                        aux = true;
                    }
                }
                if (aux == false) {
                    return false;
                }
                for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
                    v1 += cpf[i] * p;
                }
                v1 = ((v1 * 10) % 11);
                if (v1 == 10) {
                    v1 = 0;
                }
                if (v1 != cpf[9]) {
                    return false;
                }
                for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
                    v2 += cpf[i] * p;
                }
                v2 = ((v2 * 10) % 11);
                if (v2 == 10) {
                    v2 = 0;
                }
                if (v2 != cpf[10]) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else if (val.length == 18) {
                var cnpj = val.trim();
                cnpj = cnpj.replace(/\./g, '');
                cnpj = cnpj.replace('-', '');
                cnpj = cnpj.replace('/', '');
                cnpj = cnpj.split('');
                var v1 = 0;
                var v2 = 0;
                var aux = false;
                for (var i = 1; cnpj.length > i; i++) {
                    if (cnpj[i - 1] != cnpj[i]) {
                        aux = true;
                    }
                }
                if (aux == false) {
                    return false;
                }
                for (var i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
                    if (p1 >= 2) {
                        v1 += cnpj[i] * p1;
                    }
                    else {
                        v1 += cnpj[i] * p2;
                    }
                }
                v1 = (v1 % 11);
                if (v1 < 2) {
                    v1 = 0;
                }
                else {
                    v1 = (11 - v1);
                }
                if (v1 != cnpj[12]) {
                    return false;
                }
                for (var i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
                    if (p1 >= 2) {
                        v2 += cnpj[i] * p1;
                    }
                    else {
                        v2 += cnpj[i] * p2;
                    }
                }
                v2 = (v2 % 11);
                if (v2 < 2) {
                    v2 = 0;
                }
                else {
                    v2 = (11 - v2);
                }
                if (v2 != cnpj[13]) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }
        catch (error) {
            return false;
        }
    }
    static validarCamposRelacionadosCep(formulario) {
        return () => {
            try {
                const uf = formulario.get('uf');
                const cidade = formulario.get('cidade');
                const bairro = formulario.get('bairro');
                const logradouro = formulario.get('logradouro');
                if (uf.valid && cidade.valid && bairro.valid && logradouro.valid) {
                    return null;
                }
                else {
                    return { camposRelacionadosCepInvalidos: true };
                }
            }
            catch (error) {
                return null;
            }
        };
    }
    static converteDataAmerica(data) {
        let novadata;
        if (data !== "" && data !== undefined && data !== null) {
            try {
                const regex = /(\d\/)/gm;
                if (regex.exec(data) !== null) {
                    let split = data.split('/');
                    novadata = split[2] + "-" + split[1] + "-" + split[0] + "T17:47:20.353Z";
                }
                else {
                    let dataString = /(\d{4}-\d{2}-\d{2}$)/gm;
                    if (dataString.exec(data) !== null)
                        data = data + "T17:47:20.353Z";
                    let now = new Date(data);
                    let mes = now.getMonth() + 1;
                    if ((now.getMonth() + 1) < 10)
                        mes = "0" + mes;
                    let dia = now.getDate();
                    if (now.getDate() < 10)
                        dia = "0" + dia;
                    novadata = dia + "/" + mes + "/" + now.getFullYear();
                }
                return novadata;
            }
            catch (error) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    static geraDataVigencia(vigenciaName, dataVigencia) {
        let data;
        if (dataVigencia)
            data = new Date(this.converteDataAmerica(dataVigencia));
        else
            data = new Date();
        if (vigenciaName == 'vigenciaIni' || vigenciaName == 'vigFimAnterior')
            return this.converteDataAmerica(data);
        else if (vigenciaName == 'vigenciaFim') {
            data.setFullYear(data.getFullYear() + 1);
            if (data.getDate() === 1 && data.getMonth() === 2) {
                data.setDate(28);
                data.setMonth(1);
            }
            return this.converteDataAmerica(data);
        }
        else if (vigenciaName == 'vigIniAnterior') {
            data.setFullYear(data.getFullYear() - 1);
            return this.converteDataAmerica(data);
        }
        else
            return null;
    }
    getFipeAtualValores(fipeModelo) {
        if (Array.isArray(fipeModelo) && fipeModelo.length) {
            try {
                let data = new Date();
                let mes = data.getMonth();
                let ano = data.getFullYear();
                mes++;
                let fipeVal = fipeModelo[0].fipeValores;
                let fipeValAtual = fipeVal.filter(function (f) {
                    return f.mesVersaoTabela == mes && f.anoVersaoTabela == ano;
                });
                if (!fipeValAtual.length) {
                    data = this.editarData({ "data": data, operacao: "-", dia: 0, mes: 1, ano: 0 });
                    mes = data.getMonth();
                    ano = data.getFullYear();
                    mes++;
                    fipeValAtual = fipeVal.filter(function (f) {
                        return f.mesVersaoTabela == mes && f.anoVersaoTabela == ano;
                    });
                }
                return fipeValAtual.length ? fipeValAtual[0].valor : "";
            }
            catch (e) {
                console.log(e);
            }
        }
        return '';
    }
    editarData(objDate) {
        try {
            let dt = new Date(objDate.data);
            if (dt.getDate() === 29 && dt.getMonth() === 1) {
                dt.setDate(28);
            }
            if (objDate.operacao == "+") {
                dt.setFullYear(dt.getFullYear() + objDate.ano);
                dt.setDate(dt.getDate() + objDate.dia);
                dt.setMonth(dt.getMonth() + objDate.mes);
                objDate.hora && dt.setHours(dt.getHours() + objDate.hora);
            }
            else if (objDate.operacao == "-") {
                dt.setFullYear(dt.getFullYear() - objDate.ano);
                dt.setDate(dt.getDate() - objDate.dia);
                dt.setMonth(dt.getMonth() - objDate.mes);
                objDate.hora && dt.setHours(dt.getHours() - objDate.hora);
            }
            return dt;
        }
        catch (error) {
            return false;
        }
    }
    numberFormat(val, rs = false) {
        try {
            if (typeof val == "string")
                val = parseFloat(val);
            if (rs)
                return val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            else
                return val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "");
        }
        catch (e) {
            return '';
        }
    }
    geraDataPrimHabil(tempoCnh) {
        let dataAtual = new Date();
        dataAtual.setMilliseconds(0);
        dataAtual.setHours(0);
        dataAtual.setMinutes(0);
        dataAtual.setSeconds(0);
        let dataCnh = this.editarData({ data: dataAtual, operacao: '-', dia: 0, mes: 0, ano: tempoCnh });
        dataCnh = (new Date(dataCnh)).toISOString();
        return dataCnh;
    }
    openSnackbarModal(message) {
        const snackbarConfigs = {
            message,
            action: 'Fechar',
            cssClasses: ['snackbar', 'red-snackbar'],
            duration: 4000,
            horizontalPosition: 'center'
        };
        const config = new MatSnackBarConfig();
        config.panelClass = snackbarConfigs.cssClasses;
        config.duration = snackbarConfigs.duration;
        this._snackBar.open(snackbarConfigs.message, snackbarConfigs.action, config);
    }
    buscaValue(constant, viewValue) {
        let busca = constant.find(option => option.viewValue === viewValue);
        if (busca)
            return busca?.value;
        else
            return false;
    }
    buscaViewValue(constant, value) {
        let busca = constant.find(option => option.value === value);
        if (busca)
            return busca?.viewValue;
        else
            return false;
    }
    static getAnoAtual() {
        return new Date(Date.now()).getFullYear();
    }
    desabilitaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => {
            if (formulario.controls[campo])
                formulario.controls[campo].disable();
        });
    }
    desabilitaResetaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => {
            if (formulario.controls[campo]) {
                formulario.controls[campo].reset();
                formulario.controls[campo].disable();
            }
        });
    }
    habilitaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => {
            if (formulario.controls[campo])
                formulario.controls[campo].enable();
        });
    }
    atualizaCampos(objetoInfos, formulario) {
        Object.keys(objetoInfos).forEach(campo => {
            formulario.controls[campo] && formulario.controls[campo].setValue(FormsService.formatField(campo, objetoInfos[campo]));
        });
    }
    mudaPerfil(veic) {
        veic === 'v' ? this.mudaPerCarrofilEmiter.emit() : this.mudaPerCaminhaofilEmiter.emit();
    }
    enviaTipoVeiculo(tipoVeiculo) {
        this.tipoVeiculoEmiter.emit(tipoVeiculo);
    }
    enviaTipoPessoa(tipoPessoa) {
        if (tipoPessoa)
            this.tipoPessoaEmiter.emit(tipoPessoa);
    }
    enviaEstadoCivil(estadoCivil) {
        this.estadoCivilEmiter.emit(estadoCivil);
    }
    enviaSegurado(segurado) {
        this.seguradoEmiter.emit(segurado);
    }
    enviaBuscaControler(buscaControler) {
        this.buscaControlerEmiter.emit(buscaControler);
    }
    preencheFormulario(draft) {
        this.preencheFormularioEmiter.emit(draft);
    }
    preencheDraft(draft) {
        this.preencheDraftEmiter.emit(draft);
    }
    setarInfosDefault() {
        this.setarInfosDefaultEmiter.emit();
    }
    enviaValidadeFormulario(infos) {
        this.formularioValidoEmiter.emit(infos);
    }
    enviaVigenciaIni(vigencia) {
        this.vigenciaIniEmiter.emit(vigencia);
    }
    solicitaVigenciaIni() {
        this.solicitaVigenciaIniEmiter.emit();
    }
    salvarDraftFinal() {
        this.atualizaDraftFinal.emit({});
    }
    resetaFormulario() {
        this.resetaFormularioEmiter.emit();
    }
    enviaCobertura(cobertura) {
        this.coberturaEmiter.emit(cobertura);
    }
    enviaSeguradoraAnterior(seguradoAnterior) {
        this.seguradoraAnteriorEmiter.emit(seguradoAnterior);
    }
    static validarDataMaximaVigenciaAnterior(campo) {
        return (control) => {
            let dataValid = this.validaAnoMaximoVigenciaAnterior(control.value, campo);
            return !dataValid ? { validaData: { value: control.value } } : null;
        };
    }
    static validaAnoMaximoVigenciaAnterior(date, campo) {
        if (date) {
            var data = date.split('/');
            var ano = parseInt(data[2]);
            var dateNow = new Date();
            var yearLimit = dateNow.getFullYear();
            if (campo == "vigIniAnterior" && ano <= yearLimit)
                return true;
            if (campo == "vigFimAnterior")
                return true;
            return false;
        }
    }
    verifyDiffDays(dataVigenciaIni, dataVigenciaFim, dataVigenciaAnteriorIni, dataVigenciaAnteriorFim) {
        let isDiffDays;
        let isDiffDaysAnterior;
        let daysTotal;
        let renovDias;
        dataVigenciaIni = moment(dataVigenciaIni, "DDMMYYYY");
        dataVigenciaFim = moment(dataVigenciaFim, "DDMMYYYY").add(1, 'days');
        daysTotal = dataVigenciaFim.diff(dataVigenciaIni, 'days');
        isDiffDays = daysTotal != 366 ? true : false;
        // if (dataVigenciaAnteriorIni && dataVigenciaAnteriorFim) {
        //   dataVigenciaAnteriorIni = moment(dataVigenciaAnteriorIni, "DDMMYYYY");
        //   dataVigenciaAnteriorFim = moment(dataVigenciaAnteriorFim, "DDMMYYYY").add(1, 'days');
        //   renovDias = dataVigenciaAnteriorFim.diff(dataVigenciaAnteriorIni, 'days')
        // }
        // isDiffDaysAnterior = renovDias != 366 ? true : false;
        isDiffDaysAnterior = false;
        return { isDiffDays, isDiffDaysAnterior };
    }
    isAnoBissexto(ano) {
        return (ano % 4 == 0) && (ano % 100 != 0) || (ano % 400 == 0) ? true : false;
    }
    getDataVigenciaValida(vigenciaIni, vigenciaFim) {
        var dataVigenciaIniAnterior = vigenciaIni.split('/');
        var dataVigenciaFimAnterior = vigenciaFim.split('/');
        var anoIniAnterior = parseInt(dataVigenciaIniAnterior[2]);
        var anoFimAnterior = parseInt(dataVigenciaFimAnterior[2]);
        var dataAnteriorValida;
        if (anoIniAnterior > anoFimAnterior) {
            var anoFimAnteriorValido = anoIniAnterior + 1;
            dataVigenciaIniAnterior[2] = anoFimAnteriorValido;
            dataAnteriorValida = dataVigenciaIniAnterior.join('/');
        }
        else if (anoIniAnterior == anoFimAnterior) {
            var mesIniAnterior = parseInt(dataVigenciaIniAnterior[1]);
            var mesFimAnterior = parseInt(dataVigenciaFimAnterior[1]);
            if (mesIniAnterior > mesFimAnterior) {
                var anoFimAnteriorValido = anoIniAnterior + 1;
                dataVigenciaIniAnterior[2] = anoFimAnteriorValido;
                dataAnteriorValida = dataVigenciaIniAnterior.join('/');
            }
            else if (mesIniAnterior == mesFimAnterior) {
                var diaIniAnterior = parseInt(dataVigenciaIniAnterior[0]);
                var diaFimAnterior = parseInt(dataVigenciaFimAnterior[0]);
                if (diaIniAnterior >= diaFimAnterior) {
                    var anoFimAnteriorValido = anoIniAnterior + 1;
                    dataVigenciaIniAnterior[2] = anoFimAnteriorValido;
                    dataAnteriorValida = dataVigenciaIniAnterior.join('/');
                }
            }
        }
        return dataAnteriorValida;
    }
    setaInfosDefault(formulario, nomeFormulario) {
        try {
            if (formulario && nomeFormulario) {
                Object.keys(ConstantFormAuto.informacoesDefault[nomeFormulario]).forEach(campo => {
                    formulario.controls[campo].setValue(ConstantFormAuto.informacoesDefault[nomeFormulario][campo]);
                });
            }
        }
        catch (error) {
            return false;
        }
    }
    enviaUserInfos(userInfos, vazio) {
        this.userInfosEmiter.emit([userInfos, vazio]);
    }
    static formBuilderValidaFone() {
        return (control) => {
            let foneValid = this.validaFone(this.limparString(control.value));
            return !foneValid ? { foneValid: { value: control.value } } : null;
        };
    }
    static validaFone(val) {
        try {
            let nove = val.substr(2, 1);
            if (val.length === 11 && nove === '9') {
                return true;
            }
            else if (val.length === 10) {
                return true;
            }
            else if (val.length === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (error) {
            return false;
        }
    }
    /** converte para number ex: 1.000,00 > 1000 */
    static removeNumeroMonetario(value) {
        if (typeof value === 'number') {
            return value;
        }
        return parseFloat(value.replace(/[^0-9]/g, '').slice(0, -2));
    }
    async createConfirm(title, question, btnOk, btnCancel) {
        return await this.alertConfirmService.confirm(title, question, btnOk, btnCancel);
    }
    async createAlert(title, message) {
        return await this.alertConfirmService.alert(title, message);
    }
    async tipoVeiculoText(tipo) {
        let tipoText = [
            { value: 'c', form: 'CAMINHÃO', veiculo: 'CAMINHÃO', router: 'caminhao' },
            { value: 'v', form: 'AUTOMOVÉL', veiculo: 'CARRO', router: 'carro' },
            { value: 'm', form: 'MOTO', veiculo: 'MOTO', router: 'moto' },
        ];
        return tipoText.find(c => c.value === tipo);
    }
    verificaDataFormulario(data) {
        let today = new Date();
        today.setHours(8, 0, 0, 0);
        const regex = /(\d\/)/gm; //data com barras
        if (regex.exec(data) !== null) {
            let split = data.split('/');
            let novadata = split[2] + "-" + split[1] + "-" + split[0] + "T11:00:00.0Z";
            let vigenciaIni = new Date(novadata);
            return vigenciaIni < today ? false : true;
        }
        else {
            return false;
        }
    }
    static inArrayValidator(validOptions) {
        return (control) => {
            try {
                if (Array.isArray(validOptions)) {
                    const currentValue = control.value;
                    const validValues = validOptions.map(option => option.value);
                    if (!validValues.includes(currentValue)) {
                        return { 'valueNotInArrayOptions': { value: currentValue } };
                    }
                    return null;
                }
                return null;
            }
            catch (error) {
                return null;
            }
        };
    }
    static setaUltimaBusca(controler, valor) {
        controler.ultimaBusca = valor;
    }
    static ordenaArray(array) {
        return array.sort(function (a, b) {
            if (a.viewValue.normalize('NFD').replace(/[\u0300-\u036f]/g, "") > b.viewValue.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
                return 1;
            if (a.viewValue.normalize('NFD').replace(/[\u0300-\u036f]/g, "") < b.viewValue.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
                return -1;
            return 0;
        });
    }
    dataHoraSaidaLojaInvalida(dataHoraSaidaLoja) {
        try {
            if (dataHoraSaidaLoja) {
                let hoje = new Date();
                let timeUmMesAtras = new Date(hoje.getFullYear(), hoje.getMonth() - 1, hoje.getDate()).getTime();
                let timedataHoraSaidaLoja = new Date(dataHoraSaidaLoja).getTime();
                if (timedataHoraSaidaLoja < timeUmMesAtras)
                    return true;
                else
                    return false;
            }
            return false;
        }
        catch (error) {
            return false;
        }
    }
    static joinValues(simbolo, arrayValores) {
        try {
            return arrayValores.filter(Boolean).join(`${simbolo}`);
        }
        catch (error) {
            return '';
        }
    }
    static getMaiorValor(array) {
        const maiorValor = array.reduce((max, item) => (item.value > max ? item.value : max), 0);
        return maiorValor;
    }
    static validateAllFormFields(formGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.updateValueAndValidity();
                control.markAsTouched({ onlySelf: true });
                control.markAsDirty({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
    static calcTempCnh(dataChh) {
        try {
            if (!dataChh)
                return 0;
            var dataPrimHabil = new Date(dataChh);
            var timeDiff = dataPrimHabil.getTime() - new Date().getTime();
            const tempoHabilitacao = Math.abs(Math.ceil(timeDiff / (1000 * 3600 * 24) / 365));
            return tempoHabilitacao <= 11 ? tempoHabilitacao : 11;
        }
        catch (error) {
            return null;
        }
    }
    static intervalNumberToViewValue(val) {
        let generateInterval = function (obj) {
            let valAtual = obj.min;
            let limite = obj.max;
            let interval = obj.interval;
            let arr = [];
            while (valAtual <= limite) {
                arr.push({ value: valAtual, viewValue: valAtual.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) });
                valAtual = valAtual + interval;
            }
            return arr;
        };
        if (Array.isArray(val)) {
            let arr = [];
            val.map(function (v) {
                arr = [...arr, ...generateInterval(v)];
            });
            return arr;
        }
        else {
            return generateInterval(val);
        }
    }
    static objectToViewValue(val, ignorarOrdenacao) {
        let arr = [];
        for (let idx in val) {
            let formatIdx = parseInt(idx);
            formatIdx = isNaN(formatIdx) ? idx : isFinite(formatIdx) ? formatIdx : idx;
            arr.push({ value: formatIdx, viewValue: val[idx] });
        }
        return ignorarOrdenacao
            ? arr
            : arr.sort(function (a, b) {
                return a.viewValue > b.viewValue ? 1 : b.viewValue > a.viewValue ? -1 : 0;
            });
    }
    static ɵfac = function FormsService_Factory(t) { return new (t || FormsService)(i0.ɵɵinject(i1.MatSnackBar), i0.ɵɵinject('alert-confirm-service')); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormsService, factory: FormsService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.MatSnackBar }, { type: undefined, decorators: [{
                type: Inject,
                args: ['alert-confirm-service']
            }] }], null); })();

class ConstantFormAuto {
    // OPTIONS SELECTS
    static sexo = [
        { value: 'F', viewValue: 'Feminino' },
        { value: 'M', viewValue: 'Masculino' }
    ];
    static estadoCivil = [
        { value: 2, viewValue: 'Casado ou União Estável' },
        { value: 4, viewValue: 'Divorciado(a)' },
        { value: 3, viewValue: 'Separado(a)' },
        { value: 1, viewValue: 'Solteiro(a)' },
        { value: 5, viewValue: 'Viúvo(a)' }
    ];
    static uf = [
        { value: 'AC', viewValue: 'AC' },
        { value: 'AL', viewValue: 'AL' },
        { value: 'AP', viewValue: 'AP' },
        { value: 'AM', viewValue: 'AM' },
        { value: 'BA', viewValue: 'BA' },
        { value: 'CE', viewValue: 'CE' },
        { value: 'DF', viewValue: 'DF' },
        { value: 'ES', viewValue: 'ES' },
        { value: 'GO', viewValue: 'GO' },
        { value: 'MA', viewValue: 'MA' },
        { value: 'MT', viewValue: 'MT' },
        { value: 'MS', viewValue: 'MS' },
        { value: 'MG', viewValue: 'MG' },
        { value: 'PA', viewValue: 'PA' },
        { value: 'PB', viewValue: 'PB' },
        { value: 'PR', viewValue: 'PR' },
        { value: 'PE', viewValue: 'PE' },
        { value: 'PI', viewValue: 'PI' },
        { value: 'RJ', viewValue: 'RJ' },
        { value: 'RN', viewValue: 'RN' },
        { value: 'RS', viewValue: 'RS' },
        { value: 'RO', viewValue: 'RO' },
        { value: 'RR', viewValue: 'RR' },
        { value: 'SC', viewValue: 'SC' },
        { value: 'SP', viewValue: 'SP' },
        { value: 'SE', viewValue: 'SE' },
        { value: 'TO', viewValue: 'TO' }
    ];
    static zeroKm = [
        { value: true, viewValue: 'Sim' },
        { value: false, viewValue: 'Não' }
    ];
    static combustivel = [
        { value: 2, viewValue: 'ALCOOL' },
        { value: 3, viewValue: 'DIESEL' },
        { value: 5, viewValue: 'ELÉTRICO' },
        { value: 6, viewValue: 'FLEX' },
        { value: 1, viewValue: 'GASOLINA' },
        { value: 11, viewValue: 'HÍBRIDO' },
        { value: 10, viewValue: 'TETRAFUEL' }
    ];
    static isencaoFiscal = [
        { value: 1, viewValue: 'ICMS' },
        { value: 2, viewValue: 'IPI' },
        { value: 3, viewValue: 'IPI / ICMS' },
        { value: 0, viewValue: 'Não Possui' }
    ];
    static simOuNao = [
        { value: true, viewValue: 'Sim' },
        { value: false, viewValue: 'Não' }
    ];
    static dispAntiFurto = [
        { value: '0', viewValue: 'Não possui' },
        { value: '1', viewValue: 'Alarme' },
        { value: '2', viewValue: 'Bloqueador de Ignição' },
        { value: '3', viewValue: 'Trava Carneiro' },
        { value: '4', viewValue: 'Trava Mul-T-Lock' },
        { value: '5', viewValue: 'Outros' }
    ];
    static rastreador = [
        { value: "0", viewValue: "Não Possui" },
        { value: "1", viewValue: "AutoTrac" },
        { value: "2", viewValue: "Car System" },
        { value: "3", viewValue: "Celtec" },
        { value: "4", viewValue: "Cielo" },
        { value: "5", viewValue: "Graber" },
        { value: "6", viewValue: "Ituran" },
        { value: "7", viewValue: "Tracker" },
        { value: "8", viewValue: "Omnilink" },
        { value: "9", viewValue: "Positron" },
        { value: "10", viewValue: "Sascar" },
        { value: "11", viewValue: "DAF-V" },
        { value: "12", viewValue: "CEABS" },
        { value: "13", viewValue: "OnStar" },
        { value: "14", viewValue: "Lo Jack" },
        { value: "15", viewValue: "Original de Fábrica" },
        { value: "16", viewValue: "SEGSAT" }
    ];
    static relacaoSegurado = [
        { value: 0, viewValue: 'Sem perfil' },
        { value: 1, viewValue: 'Próprio' },
        { value: 2, viewValue: 'Cônjuge' },
        { value: 3, viewValue: 'Filho(a)' },
        { value: 4, viewValue: 'Outros' },
        { value: 5, viewValue: 'Empregado(a)' },
        { value: 12, viewValue: 'Pai/Mãe' },
        { value: 13, viewValue: 'Irmão(a)' },
        { value: 14, viewValue: 'Proprietário' },
    ];
    static tempoHabilitacao = [
        { value: 0, viewValue: 'Recem Habilitado' },
        { value: 1, viewValue: 'Até 1 ano' },
        { value: 2, viewValue: 'Até 2 anos' },
        { value: 3, viewValue: 'Até 3 anos' },
        { value: 4, viewValue: 'Até 4 anos' },
        { value: 5, viewValue: 'Até 5 anos' },
        { value: 6, viewValue: 'Até 6 anos' },
        { value: 7, viewValue: 'Até 7 anos' },
        { value: 8, viewValue: 'Até 8 anos' },
        { value: 9, viewValue: 'Até 9 anos' },
        { value: 10, viewValue: 'Até 10 anos' },
        { value: 11, viewValue: 'Mais de 10 anos' }
    ];
    static tipoVeiculo = {
        carro: 'v',
        motocicleta: 'm',
        caminhao: 'c',
        auto: 'v'
    };
    static tpUso = [
        { value: 1, viewValue: 'Particular', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.carro, ConstantFormAuto.tipoVeiculo.motocicleta] },
        { value: 3, viewValue: 'Profissional', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.carro, ConstantFormAuto.tipoVeiculo.motocicleta] },
        { value: 5, viewValue: 'Motorista de App', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.carro] },
        { value: 12, viewValue: 'Táxi', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.carro] },
        { value: 7, viewValue: 'Carga Própria', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.caminhao] },
        { value: 13, viewValue: 'Transportadora', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.caminhao] },
        { value: 14, viewValue: 'Outros', tipoVeiculos: [ConstantFormAuto.tipoVeiculo.caminhao] }
    ];
    static kmMensal = [
        { value: 500, viewValue: 'Até 500 km' },
        { value: 800, viewValue: 'De 501 km até 800 km' },
        { value: 1500, viewValue: 'De 801 km até 1.500 km' },
        { value: 1700, viewValue: 'Mais de 1.500 km' }
    ];
    static jovemCondutor = [
        { value: true, viewValue: 'Sim' },
        { value: false, viewValue: 'Não' }
    ];
    static idadeJovem = [
        { value: 17, viewValue: '17 anos' },
        { value: 18, viewValue: '18 anos' },
        { value: 19, viewValue: '19 anos' },
        { value: 20, viewValue: '20 anos' },
        { value: 21, viewValue: '21 anos' },
        { value: 22, viewValue: '22 anos' },
        { value: 23, viewValue: '23 anos' },
        { value: 24, viewValue: '24 anos' },
        { value: 25, viewValue: '25 anos' }
    ];
    static jovemSexo = [
        { value: 'A', viewValue: 'Ambos' },
        { value: 'F', viewValue: 'Feminino' },
        { value: 'M', viewValue: 'Masculino' },
    ];
    static tipoResidencia = [
        { value: 1, viewValue: 'Casa' },
        { value: 3, viewValue: 'Apartamento' },
        { value: 2, viewValue: 'Condomínio' },
        { value: 5, viewValue: 'Outros' }
    ];
    static garagemResidencia = [
        { value: "1", viewValue: 'Com portão eletrônico' },
        { value: "2", viewValue: 'Com portão manual' },
        { value: "3", viewValue: 'Não possui garagem' }
    ];
    static garagemTrabalho = [
        { value: "0", viewValue: 'Não utiliza para este fim' },
        { value: "1", viewValue: 'Não' },
        { value: "2", viewValue: 'Sim' },
        { value: "3", viewValue: 'Não trabalha' },
    ];
    static garagemEstudo = [
        { value: "0", viewValue: 'Não utiliza para este fim' },
        { value: "1", viewValue: 'Não' },
        { value: "2", viewValue: 'Sim' },
        { value: "3", viewValue: 'Não estuda' },
    ];
    static periodoUso = [
        { value: "0", viewValue: 'Todos os dias' },
        { value: "1", viewValue: 'Finais de semana e feriados' },
        { value: "2", viewValue: 'Até duas vezes por semana' }
    ];
    static tpCobertura = [
        { value: 1, viewValue: 'Compreensiva' },
        { value: 2, viewValue: 'Roubo/Furto' },
        { value: 3, viewValue: 'RCF' }
    ];
    static get deParaSeguradorasCorp() {
        const seguradorasRenovacaoPDocs = {
            ALLIANZ: "517",
            BRADESCO: "531",
            COSESP: "568",
            TOKIO: "619",
            SOMPO: "641",
            ZURICH: "549"
        };
        return {
            "515": seguradorasRenovacaoPDocs.TOKIO,
            "544": seguradorasRenovacaoPDocs.BRADESCO,
            "548": seguradorasRenovacaoPDocs.ZURICH,
            "620": seguradorasRenovacaoPDocs.ZURICH,
            "572": seguradorasRenovacaoPDocs.SOMPO,
            "668": seguradorasRenovacaoPDocs.COSESP,
            "678": seguradorasRenovacaoPDocs.ALLIANZ
        };
    }
    static sinistrosAnterior = [
        { value: 0, viewValue: 'Sem Sinistros' },
        { value: 1, viewValue: '1' },
        { value: 2, viewValue: '2' },
        { value: 3, viewValue: '3' },
        { value: 4, viewValue: '4' },
        { value: 5, viewValue: '5' },
        { value: 6, viewValue: '6' },
        { value: 7, viewValue: '7' },
        { value: 8, viewValue: '8' },
        { value: 9, viewValue: '9' },
        { value: 10, viewValue: '10' }
    ];
    static bonusAnterior = [
        { value: 0, viewValue: 'Sem bônus' },
        { value: 1, viewValue: '1' },
        { value: 2, viewValue: '2' },
        { value: 3, viewValue: '3' },
        { value: 4, viewValue: '4' },
        { value: 5, viewValue: '5' },
        { value: 6, viewValue: '6' },
        { value: 7, viewValue: '7' },
        { value: 8, viewValue: '8' },
        { value: 9, viewValue: '9' },
        { value: 10, viewValue: '10' }
    ];
    static valoresEquipamentos = [
        { value: 0, viewValue: 'R$ 0' },
        { value: 3000, viewValue: 'R$ 3.000,00' },
        { value: 5000, viewValue: 'R$ 5.000,00' },
        { value: 8000, viewValue: 'R$ 8.000,00' },
        { value: 10000, viewValue: 'R$ 10.000,00' },
        { value: 12000, viewValue: 'R$ 12.000,00' },
        { value: 15000, viewValue: 'R$ 15.000,00' },
        { value: 18000, viewValue: 'R$ 18.000,00' },
        { value: 20000, viewValue: 'R$ 20.000,00' },
        { value: 25000, viewValue: 'R$ 25.000,00' },
        { value: 30000, viewValue: 'R$ 30.000,00' },
        { value: 35000, viewValue: 'R$ 35.000,00' },
        { value: 40000, viewValue: 'R$ 40.000,00' },
        { value: 45000, viewValue: 'R$ 45.000,00' },
        { value: 50000, viewValue: 'R$ 50.000,00' },
        { value: 80000, viewValue: 'R$ 80.000,00' },
        { value: 100000, viewValue: 'R$ 100.000,00' }
    ];
    static tipoCarroceria = [
        { value: 1, viewValue: 'Aberta' },
        { value: 3, viewValue: 'Basculante' },
        { value: 2, viewValue: 'Baú' },
        { value: 11, viewValue: 'Baú Frigorífico' },
        { value: 10, viewValue: 'Baú Isotérmico' },
        { value: 4, viewValue: 'Betoneira' },
        { value: 5, viewValue: 'Cegonha' },
        { value: 6, viewValue: 'Coletor de Lixo' },
        { value: 7, viewValue: 'Graneleira' },
        { value: 14, viewValue: 'Guincho/Plataforma' },
        { value: 15, viewValue: 'Nenhum' },
        { value: 9, viewValue: 'Outros' },
        { value: 8, viewValue: 'Tanque' },
    ];
    static periodoUsoCaminhao = [
        { value: 3, viewValue: 'Indeterminado' },
        { value: 1, viewValue: 'Diurno' },
        { value: 2, viewValue: 'Noturno' },
    ];
    static gerenciamentoRisco = [
        { value: "0", viewValue: 'Não' },
        { value: "1", viewValue: 'Cadastro do Motorista' },
        { value: "2", viewValue: 'Escolta de Cargas' },
        { value: "3", viewValue: 'Direção Defensiva' },
        { value: "4", viewValue: 'Direção Preventiva' },
        { value: "5", viewValue: 'Inteligência Embarcada' },
    ];
    static areaDeCirculacao = [
        { value: "1", viewValue: 'Município e Arredores' },
        { value: "2", viewValue: 'Região Norte' },
        { value: "3", viewValue: 'Região Nordeste' },
        { value: "4", viewValue: 'Região Centro-Oeste' },
        { value: "5", viewValue: 'Região Sul' },
        { value: "6", viewValue: 'Região Sudeste' },
        { value: "7", viewValue: 'Mercosul' },
        { value: "8", viewValue: 'América do Sul' },
        { value: "9", viewValue: 'Estado de São Paulo' },
        { value: "10", viewValue: 'Estado do Rio de Janeiro' },
        { value: "11", viewValue: 'Território Nacional' }
    ];
    static tiposCarga = [
        { value: "0", viewValue: 'Outros' },
        { value: "1", viewValue: 'Auto Peças' },
        { value: "2", viewValue: 'Automóveis' },
        { value: "3", viewValue: 'Bebidas' },
        { value: "4", viewValue: 'Brinquedos' },
        { value: "5", viewValue: 'Calçados' },
        { value: "6", viewValue: 'Carga Mista' },
        { value: "7", viewValue: 'Carga Viva' },
        { value: "8", viewValue: 'Cigarros' },
        { value: "9", viewValue: 'Combustíveis ou Inflamáveis' },
        { value: "10", viewValue: 'Confecções' },
        { value: "11", viewValue: 'Eletroeletrônicos' },
        { value: "12", viewValue: 'Gases' },
        { value: "13", viewValue: 'Genero Alimentício - Perecível' },
        { value: "14", viewValue: 'Hortifrutigranjeiros' },
        { value: "15", viewValue: 'Laticínios' },
        { value: "16", viewValue: 'Lixo' },
        { value: "17", viewValue: 'Madeira' },
        { value: "18", viewValue: 'Material de Construção' },
        { value: "19", viewValue: 'Medicamentos' },
        { value: "20", viewValue: 'Móveis' },
        { value: "21", viewValue: 'Mudanças' },
        { value: "22", viewValue: 'Papéis' },
        { value: "23", viewValue: 'Plásticos' },
        { value: "24", viewValue: 'Pneu ou Câmara de ar' },
        { value: "25", viewValue: 'Produto Perecível' },
        { value: "26", viewValue: 'Produto Químico' },
        { value: "27", viewValue: 'Suco' },
        { value: "28", viewValue: 'Tecido' },
        { value: "29", viewValue: 'Valores' },
        { value: "30", viewValue: 'Vidros' },
        { value: "31", viewValue: 'Flores' },
        { value: "32", viewValue: 'Metais' },
        { value: "33", viewValue: 'Ferro' },
        { value: "34", viewValue: 'Genero Alimentício - Não Perecível' },
        { value: "35", viewValue: 'Adubo' },
        { value: "36", viewValue: 'Grãos' }
    ];
    static utilizacaoCaminhao = [
        { value: 0, viewValue: 'Circula somente no estado do CEP informado' },
        { value: 1, viewValue: 'Permanece em garagem/estacionamento quando não está em uso' }
    ];
    static seguroCarga = [
        { value: "0", viewValue: 'Não' },
        { value: "2", viewValue: 'Com outra seguradora' },
        { value: "3", viewValue: 'Porto Seguro' },
        { value: "4", viewValue: 'Sompo' }
    ];
    static equipamento = [
        { value: "0", viewValue: 'Não possui' },
        { value: "1", viewValue: 'Compactador de Lixo' },
        { value: "2", viewValue: 'Guindaste' },
        { value: "3", viewValue: 'Munck' },
        { value: "4", viewValue: 'Plataforma Elevatória' },
        { value: "5", viewValue: 'Poliguindaste' },
        { value: "6", viewValue: 'Outros' },
        { value: "7", viewValue: 'Frigorífico' },
        { value: "8", viewValue: 'Roll On / Roll Off' },
    ];
    static perguntasAdicionais = [
        { value: 0, name: 'proprioEstado' },
        { value: 1, name: 'garagemForaServico' }
    ];
    static camposSegurado = [
        'nome',
        'fone',
        'email',
        'sexo',
        'estadoCivil',
        'cep',
        'dataNasc'
    ];
    static camposEndereco = [
        'cep',
        'uf',
        'cidade',
        'bairro',
        'logradouro'
    ];
    static camposVeiculoDesabilitadosDefault = [
        'gasInstalValor',
        'anoMod',
        'valReferenciado',
        'modelo'
    ];
    static camposCondutorDesabilitadosDefault = [
        'tempoHabilitacao',
        'idadeJovem',
        'jovemSexo'
    ];
    static camposCondutor = [
        'nome',
        'sexo',
        'estadoCivil',
        'dataNasc'
    ];
    static camposJovemCondutor = [
        'idadeJovem',
        'jovemSexo'
    ];
    static camposRenovacao = [
        'vigIniAnterior',
        'vigFimAnterior',
        'numeroRenovacao',
        'seguradoraAnteriorId',
        'CI',
        'sinistrosAnterior',
        'bonusAnterior'
    ];
    static setValidatorsRenovacao = {
        "vigIniAnterior": [
            Validators.required,
            FormsService.validarData(),
            FormsService.validarDataMaximaVigenciaAnterior('vigIniAnterior')
        ],
        "vigFimAnterior": [
            Validators.required,
            FormsService.validarData(),
            FormsService.validarDataMaximaVigenciaAnterior('vigFimAnterior')
        ],
        'seguradoraAnteriorId': [Validators.required],
        'numeroRenovacao': [Validators.required],
        'sinistrosAnterior': [Validators.required],
        'bonusAnterior': [Validators.required],
        'CI': []
    };
    static camposModelo = {
        modelo: 'modelo',
        fipe: 'id',
        tipoVeic: 'tipo',
        codFabr: 'fipeFabricanteId'
    };
    static camposSeguradoDraft = {
        cpfCnpj: 'cpfCnpj',
        nome: 'nome',
        dataNasc: 'dataNasc',
        sexo: 'sexo',
        estadoCivil: 'estadoCivil',
        cep: 'cep',
        uf: 'uf',
        cidade: 'cidade',
        bairro: 'bairro',
        logradouro: 'logradouro',
        fone: 'fone1',
        email: 'email',
        tipoPessoa: 'tipoPessoa'
    };
    static camposVeiculoDraft = {
        zeroKm: 'zeroKm',
        placa: 'placa',
        chassi: 'chassi',
        anoFab: 'anoFabricacao',
        anoMod: 'anoModelo',
        fipe: 'fipe',
        blindado: 'blindado',
        alienado: 'alienado',
        kitGas: 'kitGas',
        isencaoFiscal: 'tipoIsencao',
        rastreador: 'rastreador',
        dispAntiFurto: 'antiFurto',
        combustivel: 'combustivel',
        modelo: 'descricao',
        codFabr: 'fabricante',
        tipoVeic: 'tipo',
        nrEixos: 'nrEixos',
        gasInstalValor: 'gasInstalValor'
    };
    static camposCondutorDraft = {
        relacaoSegurado: 'relacComSegurado',
        cpfCnpj: 'cpfCnpj',
        nome: 'nome',
        dataNasc: 'dataNasc',
        sexo: 'sexo',
        estadoCivil: 'estadoCivil',
        tempoHabilitacao: 'tempoHabilitacao',
        tipoResidencia: 'tpResidencia',
        dataPrimHabil: 'dataPrimHabil'
    };
    static camposPerfilDraft = {
        relacaoSegurado: 'relacComSegurado',
        cpfCnpj: 'cpfCnpj',
        nome: 'nome',
        dataNasc: 'dataNasc',
        sexo: 'sexo',
        estadoCivil: 'estadoCivil',
        tempoHabilitacao: 'tempoHabilitacao',
        tipoResidencia: 'tpResidencia',
        dataPrimHabil: 'dataPrimHabil',
        tpUso: 'tpUso',
        cepPernoite: 'cepPernoite',
        kmMensal: 'kmAnual',
        jovemCondutor: 'jovemCondutor',
        jovemSexo: 'jovemSexo',
        idadeJovem: 'jovemIdade',
        garagemResidencia: 'garagemResidencia',
        garagemTrabalho: 'garagemTrabalho',
        garagemEstudo: 'garagemEstudo',
        associado: 'associado',
        tpCarroceria: 'tpCarroceria',
        valorCarroceria: 'valorCarroceria',
        periodoUso: 'periodoUso',
        risco: 'risco',
        areaCirculacao: 'areaCirculacao',
        seguroCarga: 'seguroCarga',
        tipoCarga: 'tipoCarga',
        equipamento: 'equipamento',
        proprioEstado: 'proprioEstado',
        garagemForaServico: 'garagemForaServico'
    };
    static camposSeguroDraft = {
        vigenciaIni: 'vigenciaIni',
        vigenciaFim: 'vigenciaFim',
        tpCobertura: 'tpCobertura',
        renovacao: 'renovacao',
        bonusAnterior: 'bonusAnterior',
        sinistrosAnterior: 'sinistrosAnterior',
        numeroRenovacao: 'numeroRenovacao',
        seguradoraAnteriorId: 'seguradoraAnteriorId',
        vigIniAnterior: 'vigIniAnterior',
        vigFimAnterior: 'vigFimAnterior',
        CI: 'CI'
    };
    static camposLimparVeiculo = [
        'placa',
        'chassi',
        'anoFab',
        'anoMod',
        'zeroKm',
        'fipe',
        'modelo',
        'valReferenciado'
    ];
    static desabilitaRelacaoSegurado = {
        "F": [
            'Sem perfil',
            'Proprietário'
        ],
        "J": [
            'Próprio',
            'Cônjuge',
            'Filho(a)',
            'Pai/Mãe'
        ]
    };
    static desabilitaRelacaoSeguradoCaminhao = {
        "F": [
            'Proprietário'
        ],
        "J": [
            'Próprio',
            'Cônjuge',
            'Filho(a)',
            'Pai/Mãe'
        ]
    };
    static camposAtualizaCondutor = {
        demaisRelacoes: [
            'cpfCnpj',
            'nome',
            'dataNasc',
            'sexo',
            'estadoCivil'
        ],
        semPerfil: [
            'cpfCnpj',
            'nome',
            'dataNasc',
            'sexo',
            'estadoCivil',
            'tipoResidencia',
            'tempoHabilitacao'
        ]
    };
    static deParaCombustivel(combustivel) {
        let dePara = {
            7: 6, // Gasolina/Álcool - Flex 
            8: 6, // Gasolina/GNV - Flex
            9: 6, // Álcool/GNV - Flex
        };
        return dePara[combustivel] ? dePara[combustivel] : 6;
    }
    static deParaEstadoCivil(estadoCivil) {
        let dePara = {
            6: 2
        };
        return dePara[estadoCivil];
    }
    static deParaGaragemResidencia(tpLocalPernoite) {
        // Mapeamento de chaves entre os dois objetos (INFOCAP|AGGER)
        let dePara = {
            1: '2', // Com portão manual - Com portão manual
            2: '1', // Com portão automático - Com portão eletrônico
            3: '1', // Em local pago (de terceiros) - Com portão eletrônico
            4: '3', // Não tem garagem - Não possui garagem
        };
        return dePara[tpLocalPernoite] ? dePara[tpLocalPernoite] : '3';
    }
    static deParaGaragemTrabalho(idaVoltaTrabalho, garTrabManha) {
        return idaVoltaTrabalho ? (garTrabManha ? "2" : "1") : "0";
    }
    static deParaGaragemEstudo(idaVoltaEstudo, garEstudoManha) {
        return idaVoltaEstudo ? (garEstudoManha ? "2" : "1") : "0";
    }
    static deParaUsoVeiculo(tpUso) {
        let dePara = {
            2: 1, // Locomoção Diária - Particular
            4: 3, // Representação comercial - Profissional
            6: 3, // Outros ramos de atividade - Profissional
            8: 14, // Guincho - Outros
            9: 14, // Auto Escola - Outros
            10: 14, // Coletor de Lixo - Outros
            11: 14, // Socorro - Outros
        };
        return dePara[tpUso];
    }
    static deParaAntifurto(cdAntiFurto) {
        // Mapeamento de chaves entre os dois objetos (INFOCAP|AGGER)
        let dePara = {
            0: '0', // Não possui - Não possui
            1: '0', // Ituran - Outros
            2: '4', // Mul-T-Lock - Mul-T-Lock
            3: '0', // Sascar - Outros
            4: '0', // Tracker - Outros
            5: '3', // Travas Carneiro - Travas Carneiro
            6: '5', // Outros - Outros
            7: '1', // Alarme Sonoro - Alarme
            8: '5', // Chave Codificada - Outros
            9: '0', // DAF-V - Outros
        };
        return dePara[cdAntiFurto] ? dePara[cdAntiFurto] : '0';
    }
    static deParaRastreador(cdAntiFurto) {
        // Mapeamento de chaves entre os dois objetos (INFOCAP|AGGER)
        let dePara = {
            0: '0', // Não possui
            1: '6', // Ituran
            3: '10', // Sascar
            4: '7', // Tracker
            9: '11', // DAF-V
        };
        return dePara[cdAntiFurto] ? dePara[cdAntiFurto] : '0';
    }
    static deParaTipoResidencia(tpResidencia) {
        let dePara = {
            4: 5, // Chácara/Fazenda/Sítio - Outros
            6: 5, // Não informado - Outros
        };
        return dePara[tpResidencia] ? dePara[tpResidencia] : 5;
    }
    static deParaRisco(risco) {
        let dePara = {
            1: '1', // Cadastro Motorista
            2: '2', // Escolta Armada
            3: '0', // Monitoramento Satélite
            4: '0', // Rotograma
            5: '0', // Iscas Eletrônicas
            6: '0', // Certificação Motorista
            7: '0', // Não se Aplica
            8: '3', // Direção Defensiva 
            9: '4', // Direção Preventiva
            10: '5', // Inteligência Embarcada
        };
        return dePara[risco] ? dePara[risco] : '0'; // 0 => Não se Aplica 
    }
    static deParaCirculacao(areaCirculacao) {
        if (areaCirculacao instanceof Array) {
            areaCirculacao = areaCirculacao[0];
        }
        let dePara = {
            1: '1', // Município e Arredores até 80 KM
            2: '1', // Dentro do Próprio Estado da Sede
            3: '8', // América do Sul
            4: '4', // Região Centro-Oeste
            5: '5', // Região Sul
            6: '6', // Região Sudeste
            7: '7', // Mercosul
            8: '2', // Região Norte
            9: '3', // Região Nordeste
            10: '9', // Estado de São Paulo
            11: '10', // Estado do Rio de Janeiro
            12: '11' // Território Nacional
        };
        return dePara[areaCirculacao] ? dePara[areaCirculacao] : '0'; // 0 => Não se Aplica 
    }
    static deParaCarga(carga) {
        if (carga instanceof Array) {
            carga = carga[0];
        }
        let dePara = {
            1: '0', // Agua
            2: '1', // Auto Peças
            3: '4', // Brinquedos
            4: '0', // Canavieiro
            5: '7', // Carga Viva
            6: '8', // Cigarro
            7: '9', // Combustíveis/Inflamáveis 
            8: '11', // Eletrodoméstico
            9: '0', // Alimentício
            10: '25', // Alimentício Frigorífico
            11: '17', // Madeira
            12: '18', // Material Construção
            13: '33', // Minério
            14: '0', // Munição/Armas
            15: '24', // Pneus
            16: '2', // Veículo
            17: '10', // Vestuário
            18: '30', // Vidros
            19: '0', // Indivisível
            20: '0', // Outros
            21: '6', // Carga Mista
            22: '21', // Mudanças
            23: '22', // Papel
            24: '23', // Plástico
            25: '20', // Móveis
            26: '26', // Produto Químico
            27: '13', // Alimentos Perecíveis
            28: '34', // Alimentos Não Perecíveis
            29: '3', // Bebidas
            30: '0', // Mel
            31: '32', // Metal
            32: '5', // Calçados
            33: '0', // Couro
            34: '15', // Laticínios
            35: '13', // Carne
            36: '0', // Defensivo Agrícula
            37: '0', // Jardinagem
            38: '16', // Lixo
            39: '0', // Máquinas Agrículas
            40: '36', // Grãos
            41: '0', // Ração Animal
            42: '34', // Supermercado
            43: '19', // Medicamentos
            44: '35', // Adubo
            45: '31', // Flores
            46: '29', // Valores
            47: '28', // Tecido
            48: '27', // Suco
            49: '25', // Produto Perecível
            50: '12', // Gases
            51: '14', // Hortifrutigranjeiros
        };
        return dePara[carga] ? dePara[carga] : '0'; // 0 => Outros
    }
    static deParaEquipamento(equipamentos) {
        let equipamento;
        if (equipamentos instanceof Array) {
            const maiorValor = equipamentos.reduce(function (value, current) {
                return value.valor > current.valor ? value : current;
            });
            equipamento = maiorValor.valor > 0 ? maiorValor.tipo : 0;
        }
        let dePara = {
            1: '3', // Munck
            2: '2', // Guincho
            3: '6', // 3º Eixo Apoio
            4: '6', // 4° Eixo Direcional
            5: '7', // Frigorífico
            6: '6', // Outros
            7: '1', // Compactador de Lixo
            8: '2', // Guindaste
            9: '4', // Plataforma Elevatória
            10: '5', // Poliguindaste
            11: '8', // Roll On / Roll Off
        };
        return dePara[equipamento] ? dePara[equipamento] : '0'; // Não Possui
    }
    static get valoresGasInstalTxt() {
        return [
            {
                min: 0,
                max: 1000,
                interval: 1000,
            },
            {
                min: 1100,
                max: 6000,
                interval: 100,
            }
        ];
    }
    ;
    static objSelects = {
        sexo: ConstantFormAuto.sexo,
        estadoCivil: ConstantFormAuto.estadoCivil,
        uf: ConstantFormAuto.uf,
        anoMod: undefined,
        zeroKm: ConstantFormAuto.zeroKm,
        combustivel: ConstantFormAuto.combustivel,
        gasInstalValor: FormsService.intervalNumberToViewValue(ConstantFormAuto.valoresGasInstalTxt),
        simOuNao: ConstantFormAuto.simOuNao,
        isencaoFiscal: ConstantFormAuto.isencaoFiscal,
        rastreador: ConstantFormAuto.rastreador,
        dispAntiFurto: ConstantFormAuto.dispAntiFurto,
        relacaoSegurado: ConstantFormAuto.relacaoSegurado,
        relacaoSeguradoCaminhao: JSON.parse(JSON.stringify(ConstantFormAuto.relacaoSegurado)),
        tempoHabilitacao: undefined,
        tpUso: (tipoVeiculo) => { return ConstantFormAuto.tpUso.filter(opt => opt.tipoVeiculos.includes(tipoVeiculo)); },
        kmMensal: ConstantFormAuto.kmMensal,
        idadeJovem: ConstantFormAuto.idadeJovem,
        jovemSexo: ConstantFormAuto.jovemSexo,
        tipoResidencia: ConstantFormAuto.tipoResidencia,
        garagemResidencia: ConstantFormAuto.garagemResidencia,
        garagemTrabalho: ConstantFormAuto.garagemTrabalho,
        garagemEstudo: ConstantFormAuto.garagemEstudo,
        tpCobertura: ConstantFormAuto.tpCobertura,
        seguroCarga: ConstantFormAuto.seguroCarga,
        equipamento: ConstantFormAuto.equipamento,
        sinistrosAnterior: ConstantFormAuto.sinistrosAnterior,
        bonusAnterior: ConstantFormAuto.bonusAnterior,
        valoresEquipamentos: ConstantFormAuto.valoresEquipamentos,
        tipoCarroceria: ConstantFormAuto.tipoCarroceria,
        periodoUso: ConstantFormAuto.periodoUso,
        periodoUsoCaminhao: ConstantFormAuto.periodoUsoCaminhao,
        gerenciamentoRisco: ConstantFormAuto.gerenciamentoRisco,
        areaDeCirculacao: ConstantFormAuto.areaDeCirculacao,
        tiposCarga: FormsService.ordenaArray(ConstantFormAuto.tiposCarga),
        utilizacaoCaminhao: ConstantFormAuto.utilizacaoCaminhao,
        seguradoraAnteriorId: undefined
    };
    // ICONES
    static icons = [
        'briefcase-edit',
        'alert-circle-outline',
        'check-circle-outline',
        'truck',
        'car-side',
        'delete',
    ];
    // MASCARAS
    static get maskValidate() {
        return {
            ALTURA: '0.00',
            ANO: '0000',
            CEP: '00000-000',
            CHASSI: 'AAAAAAAAAAAAAAAAA',
            CI: '09999999999999999999999999999999999999999999999999999999999999999',
            CNPJ: '00.000.000/0000-00',
            CPF: '000.000.000-00',
            DATA: '00/00/0000',
            DOUBLE: '09',
            ELEVADORES: '09',
            FIPE: '000000-0',
            FONE: '(00) 0000-00009',
            FONE_2: '(00) 00000-0000',
            INDEFINIDO: '00000000000000',
            MAIL: 'A+@\.A+',
            NUMEROIMOVEL: '09999',
            PESO: '009',
            PESSOAS: '0999999999999',
            PLACA: 'SSS-0A00',
            TRIPLE: '099'
        };
    }
    static get currency() {
        return {
            prefix: 'R$ ',
            thousands: '.',
            precision: 2,
            decimal: ',',
            allowNegative: false,
            nullable: false,
            align: 'left'
        };
    }
    // PATTERNS
    static get patternValidade() {
        return {
            CNPJ: '\\d{2}.\\d{3}.\\d{3}\\/\\d{4}\\-\\d{2}',
            CPF: '[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}',
            INDEFINIDO: '[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}|\\d{2}.\\d{3}.\\d{3}\\/\\d{4}\\-\\d{2}',
            NOME: '[A-Za-z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ.\-\/&_-]+\\s+[A-Za-z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ.\-\/&\\s]{2,}',
            DATA: '[0-9]{1,2}/[0-9]{1,2}/[0-9]{4}',
            CEP: '[0-9]{5}-[0-9]{3}',
            FONE: '\\([0-9]{2}\\)\\s[0-9]{4,5}-[0-9]{4,6}',
            PLACA: '[a-zA-Z]{3}-[0-9][0-9A-Za-z][0-9]{2}',
            CHASSI: '[a-zA-Z0-9]{17}',
            FIPE: '[0-9]{6}-[0-9]{1}',
            ANO: '[0-9]{4}'
        };
    }
    // CONTROLER
    static controlerTipoDocumento = {
        INDEFINIDO: {
            label: 'CPF / CNPJ',
            validators: [
                Validators.required,
                Validators.pattern(ConstantFormAuto.patternValidade.INDEFINIDO),
                FormsService.formBuilderCpfCnpj()
            ]
        },
        CPF: {
            label: 'CPF',
            validators: [
                Validators.required,
                Validators.pattern(ConstantFormAuto.patternValidade.CPF),
                FormsService.formBuilderCpfCnpj()
            ]
        },
        CNPJ: {
            label: 'CNPJ',
            validators: [
                Validators.required,
                Validators.pattern(ConstantFormAuto.patternValidade.CNPJ),
                FormsService.formBuilderCpfCnpj()
            ]
        }
    };
    static get controlerBusca() {
        return {
            segurado: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            },
            endereco: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined,
                tooltip: ''
            },
            placa: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            },
            chassi: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            },
            fipe: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            },
            condutor: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            },
            veiculo: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            }
        };
    }
    static titulosFormulario = {
        v: 'Automóvel',
        m: 'Motocicleta',
        c: 'Caminhão'
    };
    static informacoesDefault = {
        veiculo: {
            zeroKm: false,
            blindado: false,
            alienado: false,
            kitGas: false,
            gasInstalValor: 0,
            isencaoFiscal: 0,
            isPCD: false,
            rastreador: '0',
            dispAntiFurto: '0'
        },
        perfilCarro: {
            tpUso: 1,
            jovemCondutor: false,
            tipoResidencia: 1,
            garagemResidencia: "2",
            garagemTrabalho: "0",
            garagemEstudo: "0",
            associado: false,
            periodoUso: "0",
        },
        perfilCaminhao: {
            seguroCarga: '0',
            tipoCarga: '0',
            risco: '0',
            equipamento: '0',
        },
        seguro: {
            vigenciaIni: FormsService.geraDataVigencia('vigenciaIni'),
            vigenciaFim: FormsService.geraDataVigencia('vigenciaFim'),
            tpCobertura: 1,
            renovacao: false,
        }
    };
    static botoesSubmit = [
        'submitFormSegurado',
        'submitFormVeiculo',
        'submitFormPerfilCarro',
        'submitFormPerfilCaminhao',
        'submitFormSeguro'
    ];
    static get errosPorStepAuto() {
        return {
            segurado: [
                'SEGURADO_CPFCNPJ',
                'SEGURADO_NOME',
                'SEGURADO_DATANASC',
                'SEGURADO_SEXO',
                'SEGURADO_ESTADOCIVIL',
                'SEGURADO_CEP',
                'SEGURADO_FONE',
                'SEGURADO_EMAIL'
            ],
            automovel: [
                'AUTOMOVEIS_PLACA',
                'AUTOMOVEIS_CHASSI',
                'AUTOMOVEIS_ANOFABRICACAO',
                'AUTOMOVEIS_ANOMODELO',
                'AUTOMOVEIS_ZEROKM',
                'AUTOMOVEIS_FIPE',
                'AUTOMOVEIS_DESCRICAO',
                'AUTOMOVEIS_VALREFERENCIADO',
                'AUTOMOVEIS_COMBUSTIVEL',
                'AUTOMOVEIS_PCD',
                'AUTOMOVEIS_TIPOISENCAO',
                'AUTOMOVEIS_ANTIFURTO',
                'AUTOMOVEIS_GASINSTALVALOR',
                'AUTOMOVEIS_EIXOS'
            ],
            perfil: [
                'AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO',
                'AUTOMOVEIS_CONDUTORES_CPFCNPJ',
                'AUTOMOVEIS_CONDUTORES_NOME',
                'AUTOMOVEIS_CONDUTORES_DATANASC',
                'AUTOMOVEIS_CONDUTORES_SEXO',
                'AUTOMOVEIS_CONDUTORES_ESTADOCIVIL',
                'AUTOMOVEIS_CONDUTORES_TEMPOHABILITACAO',
                'AUTOMOVEIS_CONDUTORES',
                'AUTOMOVEIS_TPUSO',
                'AUTOMOVEIS_CEPPERNOITE',
                'AUTOMOVEIS_KMANUAL',
                'AUTOMOVEIS_JOVEMCONDUTOR',
                'AUTOMOVEIS_JOVEMIDADE',
                'AUTOMOVEIS_JOVEMSEXO',
                'AUTOMOVEIS_TIPO',
                'AUTOMOVEIS_LOCALPERNOITE',
                'AUTOMOVEIS_IDA_VOLTA_TRABALHO',
                'AUTOMOVEIS_IDA_VOLTA_ESTUDO',
                'AUTOMOVEIS_TPCARROCERIA',
                'AUTOMOVEIS_TIPOCARGA',
                'AUTOMOVEIS_VALORCARROCERIA'
            ],
            seguro: [
                'TPCOBERTURA',
                'VIGENCIAINI',
                'VIGENCIAFIM',
                'ANTERIOR_VIGENCIAINI',
                'ANTERIOR_VIGENCIAFIM',
                'SEGURADORAANTERIORID',
                'NUMERORENOVACAO',
                'SINISTROSANTERIOR',
                'BONUSANTERIOR'
            ]
        };
    }
}

class IconsService {
    matIconRegistry;
    domSanitizer;
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
    }
    registerIcons(icons) {
        this.loadIcons(icons, 'assets/icons');
    }
    loadIcons(iconKeys, iconUrl) {
        iconKeys.forEach(key => {
            this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
        });
    }
    static ɵfac = function IconsService_Factory(t) { return new (t || IconsService)(i0.ɵɵinject(i6.MatIconRegistry), i0.ɵɵinject(i2.DomSanitizer)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IconsService, factory: IconsService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i6.MatIconRegistry }, { type: i2.DomSanitizer }], null); })();

function ModalCepComponent_mat_option_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", i_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r1.viewValue, " ");
} }
function ModalCepComponent_mat_error_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um estado.");
    i0.ɵɵelementEnd();
} }
function ModalCepComponent_mat_error_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira uma cidade.");
    i0.ɵɵelementEnd();
} }
function ModalCepComponent_mat_error_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um bairro.");
    i0.ɵɵelementEnd();
} }
function ModalCepComponent_mat_error_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um logradouro.");
    i0.ɵɵelementEnd();
} }
class ModalCepComponent {
    dialogRef;
    data;
    formBuilder;
    formEndereco;
    selects = ConstantFormAuto.objSelects;
    constructor(dialogRef, data, formBuilder) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.formEndereco = this.formBuilder.group({
            cep: new FormControl({ value: '', disabled: true }, [Validators.required]),
            uf: new FormControl('', [Validators.required]),
            cidade: new FormControl('', [Validators.required]),
            bairro: new FormControl('', [Validators.required]),
            logradouro: new FormControl('', [Validators.required]),
        });
    }
    ngOnInit() {
        this.carregaValores();
    }
    carregaValores() {
        ConstantFormAuto.camposEndereco.forEach(campo => { this.formEndereco.controls[campo].setValue(this.data.formulario.controls[campo].value); });
    }
    fechaModal() {
        this.dialogRef.close(false);
    }
    salvar() {
        this.dialogRef.close(this.formEndereco.getRawValue());
    }
    static ɵfac = function ModalCepComponent_Factory(t) { return new (t || ModalCepComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$2.FormBuilder)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalCepComponent, selectors: [["modal-cep"]], decls: 43, vars: 7, consts: [[1, "header-modal"], ["mat-dialog-title", ""], [1, "container-icon-close"], ["mat-icon-button", "", 3, "click"], ["mat-dialog-container", "", 1, "content-modal"], [3, "formGroup"], [1, "col-xl-4"], ["matInput", "", "formControlName", "cep", "name", "cepInformado", "autocomplete", "off"], ["formControlName", "uf", "name", "uf"], [3, "value", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["matInput", "", "formControlName", "cidade", "name", "cidade", "autocomplete", "off"], ["matInput", "", "formControlName", "bairro", "name", "bairro", "autocomplete", "off"], [1, "col-xl-8"], ["matInput", "", "formControlName", "logradouro", "name", "logradouro", "autocomplete", "off"], [1, "btns-modal-cep"], ["mat-raised-button", "", 1, "btn-cancelar", 3, "click"], ["mat-raised-button", "", 1, "btn-salvar", "bg-white", "botao-formulario", 3, "click", "disabled"], [3, "value"]], template: function ModalCepComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
            i0.ɵɵtext(2, " CEP n\u00E3o encontrado ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "button", 3);
            i0.ɵɵlistener("click", function ModalCepComponent_Template_button_click_4_listener() { return ctx.fechaModal(); });
            i0.ɵɵelementStart(5, "mat-icon");
            i0.ɵɵtext(6, "close");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(7, "hr");
            i0.ɵɵelementStart(8, "div", 4)(9, "h4");
            i0.ɵɵtext(10, "Por favor preencha os dados do endere\u00E7o manualmente.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "form", 5)(12, "mat-form-field", 6)(13, "mat-label");
            i0.ɵɵtext(14, "CEP Informado");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "input", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "mat-form-field", 6)(17, "mat-label");
            i0.ɵɵtext(18, "UF");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "mat-select", 8);
            i0.ɵɵtemplate(20, ModalCepComponent_mat_option_20_Template, 2, 2, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(21, ModalCepComponent_mat_error_21_Template, 2, 0, "mat-error", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "mat-form-field", 6)(23, "mat-label");
            i0.ɵɵtext(24, "Cidade");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(25, "input", 11);
            i0.ɵɵtemplate(26, ModalCepComponent_mat_error_26_Template, 2, 0, "mat-error", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "mat-form-field", 6)(28, "mat-label");
            i0.ɵɵtext(29, "Bairro");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(30, "input", 12);
            i0.ɵɵtemplate(31, ModalCepComponent_mat_error_31_Template, 2, 0, "mat-error", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "mat-form-field", 13)(33, "mat-label");
            i0.ɵɵtext(34, "Logradouro");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(35, "input", 14);
            i0.ɵɵtemplate(36, ModalCepComponent_mat_error_36_Template, 2, 0, "mat-error", 10);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(37, "hr");
            i0.ɵɵelementStart(38, "div", 15)(39, "button", 16);
            i0.ɵɵlistener("click", function ModalCepComponent_Template_button_click_39_listener() { return ctx.fechaModal(); });
            i0.ɵɵtext(40, "CANCELAR");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(41, "button", 17);
            i0.ɵɵlistener("click", function ModalCepComponent_Template_button_click_41_listener() { return ctx.salvar(); });
            i0.ɵɵtext(42, "SALVAR");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(11);
            i0.ɵɵproperty("formGroup", ctx.formEndereco);
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("ngForOf", ctx.selects.uf);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formEndereco.get("uf").hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.formEndereco.get("cidade").hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.formEndereco.get("bairro").hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.formEndereco.get("logradouro").hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", ctx.formEndereco.invalid);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i4.MatButton, i4.MatIconButton, i1$1.MatDialogTitle, i5.MatFormField, i5.MatLabel, i5.MatError, i6.MatIcon, i7.MatInput, i9.MatSelect, i4$1.MatOption, i1$2.FormGroupDirective, i1$2.FormControlName], styles: [".header-modal[_ngcontent-%COMP%]{display:flex;width:90%;margin:10px auto;height:36px}.header-modal[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin:5px auto;width:calc(100% - 48px);font-size:18px;color:var(--color-dark);font-weight:400;text-transform:none;text-align:center;padding:0 0 0 20px;display:flex;justify-content:center;align-items:center}.header-modal[_ngcontent-%COMP%]   .container-icon-close[_ngcontent-%COMP%]{display:flex;align-items:center}.content-modal[_ngcontent-%COMP%]{width:90%;margin:auto}.content-modal[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{text-align:center;margin-bottom:30px}.btns-modal-cep[_ngcontent-%COMP%]{width:95%;margin:0 auto 10px;display:flex;justify-content:right}.btns-modal-cep[_ngcontent-%COMP%]   .btn-cancelar[_ngcontent-%COMP%]{margin-right:10px;background-color:#fff;color:var(--color-dark);box-shadow:none;border-radius:20px;letter-spacing:normal}.btns-modal-cep[_ngcontent-%COMP%]   .btn-salvar[_ngcontent-%COMP%]{background-color:#fff;box-shadow:none;border-radius:20px;letter-spacing:normal}.btns-modal-cep[_ngcontent-%COMP%]   .btn-salvar[_ngcontent-%COMP%]:not(:disabled){color:var(--color-primary)}  .modal-cep{font-family:Roboto,sans-serif}  .modal-cep .mat-dialog-container{padding:0}@media screen and (max-width: 500px){  .modal-cep{justify-content:center}  .modal-cep .mat-dialog-container{width:90%}}  .modal-cep .mat-select-value-text{font-weight:400;color:var(--color-dark)}  .modal-cep .mat-select-value{color:#0000008a}  .modal-cep .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}  .modal-cep .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px}  .modal-cep .mat-mdc-form-field-hint-wrapper,   .modal-cep .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}  .modal-cep .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}  .modal-cep .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}  .modal-cep .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px}  .modal-cep .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}  .modal-cep .mdc-text-field--disabled .mdc-line-ripple{display:none}  .modal-cep .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}  .modal-cep .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}  .modal-cep .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}  .modal-cep .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,   .modal-cep .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}  .modal-cep .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}  .modal-cep .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}  .modal-cep .mat-mdc-select-trigger{font-size:14px}  .modal-cep .mdc-text-field--filled{background-color:transparent;padding:0;height:38px}  .modal-cep .mat-mdc-form-field-focus-overlay{background-color:transparent}  .modal-cep .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}  .modal-cep .mat-mdc-form-field-infix{min-height:38px}  .modal-cep .mat-mdc-select-trigger{height:48px}  .modal-cep .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}  .modal-cep .mdc-floating-label{font-size:14px;color:var(--color-dark)}  .modal-cep .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}  .modal-cep .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}  .modal-cep .mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}  .modal-cep .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}  .modal-cep .mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--invalid):hover .mdc-line-ripple:before{border-bottom-color:#0000006b}  .modal-cep .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}  .modal-cep .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}  .modal-cep .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}  .modal-cep .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalCepComponent, [{
        type: Component,
        args: [{ selector: 'modal-cep', template: "<div class=\"header-modal\">\r\n    <h2 mat-dialog-title>\r\n        CEP n\u00E3o encontrado\r\n    </h2>\r\n    <div class=\"container-icon-close\">\r\n        <button mat-icon-button (click)=\"fechaModal()\">\r\n            <mat-icon>close</mat-icon>\r\n        </button>\r\n    </div>\r\n</div>\r\n<hr>\r\n<div class=\"content-modal\" mat-dialog-container>\r\n    <h4>Por favor preencha os dados do endere\u00E7o manualmente.</h4>\r\n    <form [formGroup]=\"formEndereco\">\r\n        <mat-form-field class=\"col-xl-4\">\r\n            <mat-label>CEP Informado</mat-label>\r\n            <input matInput formControlName=\"cep\" name=\"cepInformado\" autocomplete=\"off\">\r\n        </mat-form-field>\r\n\r\n        <mat-form-field class=\"col-xl-4\">\r\n            <mat-label>UF</mat-label>\r\n            <mat-select formControlName=\"uf\" name=\"uf\">\r\n                <mat-option *ngFor=\"let i of selects.uf\" [value]=\"i.value\">\r\n                    {{i.viewValue}}\r\n                </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formEndereco.get('uf').hasError('required')\">Por favor, insira um estado.</mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field class=\"col-xl-4\">\r\n            <mat-label>Cidade</mat-label>\r\n            <input matInput formControlName=\"cidade\" name=\"cidade\" autocomplete=\"off\"/>\r\n            <mat-error *ngIf=\"formEndereco.get('cidade').hasError('required')\">Por favor, insira uma cidade.</mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field class=\"col-xl-4\">\r\n            <mat-label>Bairro</mat-label>\r\n            <input matInput formControlName=\"bairro\" name=\"bairro\" autocomplete=\"off\"/>\r\n            <mat-error *ngIf=\"formEndereco.get('bairro').hasError('required')\">Por favor, insira um bairro.</mat-error>\r\n        </mat-form-field>\r\n\r\n        <mat-form-field class=\"col-xl-8\">\r\n            <mat-label>Logradouro</mat-label>\r\n            <input matInput formControlName=\"logradouro\" name=\"logradouro\" autocomplete=\"off\"/>\r\n            <mat-error *ngIf=\"formEndereco.get('logradouro').hasError('required')\">Por favor, insira um logradouro.</mat-error>\r\n        </mat-form-field>\r\n    </form>\r\n</div>\r\n<hr>\r\n<div class=\"btns-modal-cep\">\r\n    <button mat-raised-button class=\"btn-cancelar\" (click)=\"fechaModal()\">CANCELAR</button>\r\n    <button mat-raised-button class=\"btn-salvar bg-white botao-formulario \" (click)=\"salvar()\" [disabled]=\"formEndereco.invalid\">SALVAR</button>\r\n</div>", styles: [".header-modal{display:flex;width:90%;margin:10px auto;height:36px}.header-modal h2{margin:5px auto;width:calc(100% - 48px);font-size:18px;color:var(--color-dark);font-weight:400;text-transform:none;text-align:center;padding:0 0 0 20px;display:flex;justify-content:center;align-items:center}.header-modal .container-icon-close{display:flex;align-items:center}.content-modal{width:90%;margin:auto}.content-modal h4{text-align:center;margin-bottom:30px}.btns-modal-cep{width:95%;margin:0 auto 10px;display:flex;justify-content:right}.btns-modal-cep .btn-cancelar{margin-right:10px;background-color:#fff;color:var(--color-dark);box-shadow:none;border-radius:20px;letter-spacing:normal}.btns-modal-cep .btn-salvar{background-color:#fff;box-shadow:none;border-radius:20px;letter-spacing:normal}.btns-modal-cep .btn-salvar:not(:disabled){color:var(--color-primary)}::ng-deep .modal-cep{font-family:Roboto,sans-serif}::ng-deep .modal-cep .mat-dialog-container{padding:0}@media screen and (max-width: 500px){::ng-deep .modal-cep{justify-content:center}::ng-deep .modal-cep .mat-dialog-container{width:90%}}::ng-deep .modal-cep .mat-select-value-text{font-weight:400;color:var(--color-dark)}::ng-deep .modal-cep .mat-select-value{color:#0000008a}::ng-deep .modal-cep .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}::ng-deep .modal-cep .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px}::ng-deep .modal-cep .mat-mdc-form-field-hint-wrapper,::ng-deep .modal-cep .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}::ng-deep .modal-cep .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}::ng-deep .modal-cep .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}::ng-deep .modal-cep .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px}::ng-deep .modal-cep .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}::ng-deep .modal-cep .mdc-text-field--disabled .mdc-line-ripple{display:none}::ng-deep .modal-cep .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}::ng-deep .modal-cep .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}::ng-deep .modal-cep .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .modal-cep .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,::ng-deep .modal-cep .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .modal-cep .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}::ng-deep .modal-cep .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}::ng-deep .modal-cep .mat-mdc-select-trigger{font-size:14px}::ng-deep .modal-cep .mdc-text-field--filled{background-color:transparent;padding:0;height:38px}::ng-deep .modal-cep .mat-mdc-form-field-focus-overlay{background-color:transparent}::ng-deep .modal-cep .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}::ng-deep .modal-cep .mat-mdc-form-field-infix{min-height:38px}::ng-deep .modal-cep .mat-mdc-select-trigger{height:48px}::ng-deep .modal-cep .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}::ng-deep .modal-cep .mdc-floating-label{font-size:14px;color:var(--color-dark)}::ng-deep .modal-cep .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}::ng-deep .modal-cep .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .modal-cep .mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .modal-cep .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}::ng-deep .modal-cep .mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--invalid):hover .mdc-line-ripple:before{border-bottom-color:#0000006b}::ng-deep .modal-cep .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}::ng-deep .modal-cep .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}::ng-deep .modal-cep .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}::ng-deep .modal-cep .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}\n"] }]
    }], () => [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$2.FormBuilder }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ModalCepComponent, { className: "ModalCepComponent", filePath: "components\\formulario-auto-segurado\\components\\modal-cep\\modal-cep.component.ts", lineNumber: 11 }); })();

function FormularioAutoSeguradoComponent_mat_spinner_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 18);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoSeguradoComponent_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "N\u00FAmero do documento inv\u00E1lido.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira o nome completo.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira o nome completo.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_option_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r2.value);
    i0.ɵɵattribute("custom-reflect-value", s_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(s_r2.viewValue);
} }
function FormularioAutoSeguradoComponent_mat_error_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_option_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", e_r3.value);
    i0.ɵɵattribute("custom-reflect-value", e_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(e_r3.viewValue);
} }
function FormularioAutoSeguradoComponent_mat_error_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_spinner_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 18);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoSeguradoComponent_mat_icon_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 20);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r3.buscaControler.endereco.tooltip);
} }
function FormularioAutoSeguradoComponent_mat_icon_37_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 21);
    i0.ɵɵlistener("click", function FormularioAutoSeguradoComponent_mat_icon_37_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.abrirModalCep()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r3.buscaControler.endereco.tooltip);
} }
function FormularioAutoSeguradoComponent_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um CEP v\u00E1lido.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um CEP.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, " Por favor, insira um telefone v\u00E1lido. ");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, " Por favor, insira um telefone. ");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um e-mail v\u00E1lido");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguradoComponent_mat_error_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "O e-mail deve ter no m\u00E1ximo 60 caracteres");
    i0.ɵɵelementEnd();
} }
class FormularioAutoSeguradoComponent {
    api;
    dialog;
    formBuilder;
    formsService;
    router;
    buscaControler = ConstantFormAuto.controlerBusca;
    controlerTipoDocumento = ConstantFormAuto.controlerTipoDocumento;
    masks = ConstantFormAuto.maskValidate;
    maskTelefone = this.masks.FONE;
    patterns = ConstantFormAuto.patternValidade;
    selects = ConstantFormAuto.objSelects;
    subscriptions = new Subscription();
    clienteDisponivel = true;
    formAutoSegurado;
    informacoesUsuario;
    tipoDocumento = 'INDEFINIDO';
    //recalculo
    isRecalculo;
    habCampos = {};
    set recalculo(value) {
        this.isRecalculo = value;
    }
    set listaCampo(value) {
        this.habCampos = value;
    }
    constructor(api, dialog, formBuilder, formsService, router) {
        this.api = api;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.router = router;
        this.formAutoSegurado = this.formBuilder.group({
            cpfCnpj: new FormControl('', [Validators.required, Validators.pattern(this.patterns.INDEFINIDO), FormsService.formBuilderCpfCnpj()]),
            nome: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.patterns.NOME)]),
            dataNasc: new FormControl('', [Validators.required, Validators.pattern(this.patterns.DATA), FormsService.validarDataNascimento()]),
            sexo: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.sexo)]),
            estadoCivil: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.estadoCivil)]),
            cep: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CEP)]),
            uf: new FormControl('', [Validators.required]),
            cidade: new FormControl('', []),
            bairro: new FormControl('', []),
            logradouro: new FormControl('', []),
            fone: new FormControl('', [Validators.required, Validators.pattern(this.patterns.FONE), FormsService.formBuilderValidaFone()]),
            email: new FormControl('', [Validators.email, Validators.maxLength(60)]),
            tipoPessoa: new FormControl('', []),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
    }
    ngOnDestroy() {
        this.formsService.salvarDraftFinal();
        this.subscriptions.unsubscribe();
    }
    abrirModalCep() {
        const dialogRef = this.dialog.open(ModalCepComponent, {
            data: { formulario: this.formAutoSegurado },
            autoFocus: false,
            maxWidth: 500,
            restoreFocus: false,
            panelClass: 'modal-cep'
        });
        dialogRef.afterClosed().subscribe(retorno => {
            if (retorno) {
                ConstantFormAuto.camposEndereco.forEach(campo => { this.formAutoSegurado.controls[campo].setValue(retorno[campo]); });
                this.formAutoSegurado.controls.cep.updateValueAndValidity();
            }
        });
    }
    alteraMascaraTelefone(telefone) {
        try {
            this.formAutoSegurado.controls.fone.clearValidators();
            this.maskTelefone = telefone && telefone.length > 14 ? this.masks.FONE_2 : this.masks.FONE;
            telefone && telefone.length > 14
                ? this.formAutoSegurado.controls.fone.setValidators([FormsService.formBuilderValidaFone()])
                : this.formAutoSegurado.controls.fone.setValidators([FormsService.formBuilderValidaFone()]);
        }
        catch (error) {
            return false;
        }
    }
    async atualizaMascaraCpfCnpj(manual) {
        this.setaTipoDocumento();
        this.setaTipoPessoa(this.tipoDocumento);
        this.formAutoSegurado.controls.cpfCnpj.setValue(this.formsService.formatCnpjCpf(this.formAutoSegurado.controls.cpfCnpj.value));
        this.formsService.enviaTipoPessoa(this.formAutoSegurado.controls.tipoPessoa.value);
        this.formAutoSegurado.controls.cpfCnpj.clearValidators();
        this.formAutoSegurado.controls.cpfCnpj.setValidators(this.controlerTipoDocumento[this.tipoDocumento].validators);
        await this.buscaInfosSegurado(this.formsService.limparString(this.formAutoSegurado.controls.cpfCnpj.value), this.tipoDocumento, manual);
        await this.buscaInfosEndereco();
        this.mudaCamposPeloTipoDocumento();
        this.formAutoSegurado.controls.cpfCnpj.updateValueAndValidity();
        this.verificaCamposPreenchidos(this.tipoDocumento, manual);
    }
    async buscaInfosEndereco() {
        let cepValido = this.formAutoSegurado.controls.cep.valid;
        let erroCamposRelacionadosCep = this.formAutoSegurado.controls.cep.invalid && this.formAutoSegurado.controls.cep.hasError('camposRelacionadosCepInvalidos');
        let buscaAnteriorDiferenteAtual = this.buscaControler.endereco.ultimaBusca != this.formsService.limparString(this.formAutoSegurado.controls.cep.value);
        if ((cepValido || erroCamposRelacionadosCep) && buscaAnteriorDiferenteAtual) {
            this.buscaControler.endereco.buscando = true;
            let infosEndereco = await this.api.getEndereco(this.formsService.limparString(this.formAutoSegurado.controls.cep.value));
            if (Array.isArray(infosEndereco))
                infosEndereco = infosEndereco.filter(e => e?.cep === this.formsService.limparString(this.formAutoSegurado.controls.cep.value));
            if (infosEndereco && infosEndereco.length > 0 && infosEndereco[0]) {
                this.formsService.atualizaCampos(infosEndereco[0], this.formAutoSegurado);
                this.buscaControler.endereco.status = 'ENCONTROU';
                this.buscaControler.endereco.tooltip = `CEP válido: ${FormsService.joinValues(', ', [this.formAutoSegurado.value.logradouro, this.formAutoSegurado.value.cidade])}`;
                this.formAutoSegurado.controls.cep.removeValidators(FormsService.validarCamposRelacionadosCep(this.formAutoSegurado));
                this.formAutoSegurado.controls.cep.updateValueAndValidity();
                this.buscaControler.endereco.cidade = this.formAutoSegurado.controls.cidade.value;
            }
            else {
                this.buscaControler.endereco.status = 'NAO-ENCONTROU';
                this.buscaControler.endereco.tooltip = 'Adicionar dados do endereço manualmente';
                this.formAutoSegurado.controls.cep.addValidators(FormsService.validarCamposRelacionadosCep(this.formAutoSegurado));
                this.formAutoSegurado.controls.cep.updateValueAndValidity();
                if (this.router.snapshot.params.page === 'formulario' && this.formAutoSegurado.controls.cep.hasError('camposRelacionadosCepInvalidos'))
                    this.abrirModalCep();
            }
            FormsService.setaUltimaBusca(this.buscaControler.endereco, this.formsService.limparString(this.formAutoSegurado.controls.cep.value));
            this.buscaControler.endereco.buscando = false;
            this.formsService.enviaBuscaControler(this.buscaControler);
        }
    }
    async buscaInfosSegurado(cpfCnpj, tipoDocumento, manual) {
        let tipoDocumentoValido = tipoDocumento != 'INDEFINIDO';
        let cpfCnpjValido = this.formAutoSegurado.controls.cpfCnpj.valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler.segurado.ultimaBusca != cpfCnpj;
        if (tipoDocumentoValido && cpfCnpjValido && buscaAnteriorDiferenteAtual && manual) {
            this.buscaControler.segurado.buscando = true;
            this.formsService.desabilitaCampos(ConstantFormAuto.camposSegurado, this.formAutoSegurado);
            let infosSegurado = await this.api.getSegurado(cpfCnpj).catch(error => { console.log(error); return error; });
            if (Array.isArray(infosSegurado)) {
                //buscando o valor que corresponde ao cpf encontrado
                infosSegurado = infosSegurado.filter(p => p?.cpfCnpj === cpfCnpj);
            }
            if (infosSegurado && infosSegurado?.length > 0 && infosSegurado[0]) {
                let cepBuscadoDiferente = FormsService.formatCep(infosSegurado[0].cep) !== this.formAutoSegurado.controls.cep.value;
                let substituirEndereco = true;
                if (this.formAutoSegurado.controls.cep.value && infosSegurado[0].cep && cepBuscadoDiferente && this.buscaControler.endereco.status == 'ENCONTROU') {
                    if (this.isRecalculo)
                        substituirEndereco = false;
                    else
                        substituirEndereco = await this.formsService.createConfirm("Alteração de Endereço", `O CEP atual da cotação é ${this.formAutoSegurado.controls.cep.value}, mas o CEP buscado foi ${FormsService.formatCep(infosSegurado[0].cep)}. Deseja atualizá-lo?`, "Atualizar", "Manter");
                }
                if (!substituirEndereco) {
                    const camposEndereco = ['cep', 'uf', 'cidade', 'bairro', 'logradouro'];
                    camposEndereco.forEach(nomeCampo => delete infosSegurado[0][nomeCampo]);
                }
                this.formsService.atualizaCampos(infosSegurado[0], this.formAutoSegurado);
                if (manual && !this.isRecalculo)
                    this.formsService.buscarCotacoes({ cpfCnpj: this.formAutoSegurado.controls.cpfCnpj.value, ramo: 31, segurado: infosSegurado[0]?.nome });
            }
            this.formsService.habilitaCampos(ConstantFormAuto.camposSegurado, this.formAutoSegurado);
            FormsService.setaUltimaBusca(this.buscaControler.segurado, cpfCnpj);
            this.buscaControler.segurado.buscando = false;
            this.formsService.enviaValidadeFormulario({ formularioNome: 'segurado', valido: this.formAutoSegurado.valid });
        }
        this.verificaEstadoCivil();
    }
    carregaInfosDraft(draft) {
        if (!draft?.isClearDraft && Object.keys(this.formAutoSegurado?.controls).length) {
            Object.keys(ConstantFormAuto.camposSeguradoDraft).forEach(campo => {
                this.formAutoSegurado.controls[campo] &&
                    this.formAutoSegurado.controls[campo].setValue(FormsService.formatField(campo, draft?.segurado[ConstantFormAuto.camposSeguradoDraft[campo]]));
            });
        }
    }
    enviaEstadoCivil(estadoCivil) {
        this.formsService.enviaEstadoCivil(estadoCivil);
    }
    executaFuncoesIniciais() {
        FormsService.setaUltimaBusca(this.buscaControler.segurado, this.formsService.limparString(this.formAutoSegurado.controls.cpfCnpj.value));
        this.atualizaMascaraCpfCnpj(false);
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formAutoSegurado?.valueChanges.subscribe(segurado => {
            this.formsService.enviaSegurado(segurado);
            if (this.formAutoSegurado.valid)
                this.formsService.enviaValidadeFormulario({ formularioNome: 'segurado', valido: this.formAutoSegurado.valid });
        }));
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            this.carregaInfosDraft(draft);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formAutoSegurado.reset();
            this.tipoDocumento = 'INDEFINIDO';
            this.buscaControler = ConstantFormAuto.controlerBusca;
        }));
        this.subscriptions.add(this.formsService.userInfosEmiter.subscribe(arrayInfos => {
            this.informacoesUsuario = arrayInfos[0];
            let vazio = arrayInfos[1];
            this.verificaClienteDisponivel(this.formsService.limparString(this.formAutoSegurado.controls.cpfCnpj.value), false);
            if (this.informacoesUsuario && this.informacoesUsuario?.dadosCorretoraPadrao && vazio)
                this.usarDadosCorretoraPadrao();
        }));
    }
    limpaMascaraCpfCnpj() {
        this.tipoDocumento = 'INDEFINIDO';
        this.formAutoSegurado.controls.cpfCnpj.clearValidators();
        this.formAutoSegurado.controls.cpfCnpj.setValue(this.formsService.limparString(this.formAutoSegurado.controls.cpfCnpj.value));
    }
    mudaCamposPeloTipoDocumento() {
        const campos = ['dataNasc', 'sexo', 'estadoCivil'];
        this.tipoDocumento == 'CNPJ' ? this.formsService.desabilitaResetaCampos(campos, this.formAutoSegurado) : this.formsService.habilitaCampos(campos, this.formAutoSegurado);
    }
    setaTipoPessoa(documento) {
        this.formAutoSegurado.controls.tipoPessoa.setValue(documento == 'CPF' ? 'F' : (documento == 'CNPJ' ? 'J' : null));
    }
    setaTipoDocumento() {
        this.tipoDocumento = this.formsService.identificaTipoDocumento(this.formsService.limparString(this.formAutoSegurado.controls.cpfCnpj.value));
    }
    usarDadosCorretoraPadrao() {
        this.usarEmailCorretora();
        this.usarFoneCorretora();
    }
    usarEmailCorretora() {
        this.formAutoSegurado.controls.email.setValue(this.informacoesUsuario?.emailCorretoraPadrao);
    }
    usarFoneCorretora() {
        this.formAutoSegurado.controls.fone.setValue(FormsService.formatFone(this.informacoesUsuario?.foneCorretoraPadrao));
    }
    verificaCamposPreenchidos(tipoDocumento, manual) {
        let tipoDocumentoValido = tipoDocumento != 'INDEFINIDO';
        let cpfCnpjValido = this.formAutoSegurado.controls.cpfCnpj.valid;
        if (tipoDocumentoValido && cpfCnpjValido && manual) {
            FormsService.validateAllFormFields(this.formAutoSegurado);
        }
    }
    verificaEstadoCivil() {
        if (this.formAutoSegurado.controls.estadoCivil.value)
            this.enviaEstadoCivil(this.formsService.buscaViewValue(ConstantFormAuto.estadoCivil, this.formAutoSegurado.controls.estadoCivil.value));
    }
    async verificaClienteDisponivel(cpfCnpj, manual) {
        if (this.api?.verificarClienteDisponivel && this.informacoesUsuario && cpfCnpj) {
            try {
                let ret = await this.api.clienteDisponivel(cpfCnpj);
                this.clienteDisponivel = ret?.cpf_cnpj_autorizado;
                this.formsService.clienteIndisponivel(!this.clienteDisponivel);
                if (!this.clienteDisponivel && manual) {
                    await this.formsService.createAlert("Atenção", "Este cálculo pertence a outro corretor, não será possível prosseguir com a cotação.");
                    return false;
                }
            }
            catch (error) {
                this.clienteDisponivel = true;
                this.formsService.clienteIndisponivel(!this.clienteDisponivel);
                return false;
            }
        }
    }
    static ɵfac = function FormularioAutoSeguradoComponent_Factory(t) { return new (t || FormularioAutoSeguradoComponent)(i0.ɵɵdirectiveInject('api'), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(FormsService), i0.ɵɵdirectiveInject(i4$2.ActivatedRoute)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormularioAutoSeguradoComponent, selectors: [["formulario-auto-segurado"]], inputs: { recalculo: "recalculo", listaCampo: "listaCampo" }, decls: 55, vars: 45, consts: [["cpfCnpj", ""], [3, "ngClass", "formGroup"], [3, "hidden", "ngClass"], ["matInput", "", "name", "cpfCnpj", "formControlName", "cpfCnpj", "placeholder", "Ex. 000.000.000-00", "autocomplete", "off", 3, "focus", "blur", "mask", "dropSpecialCharacters"], ["class", "spinnerLoading", "mat-spinner", "", "diameter", "20", 4, "ngIf"], [4, "ngIf"], ["matInput", "", "name", "nomeSegurado", "formControlName", "nome", "autocomplete", "off", 1, "text-capitalize"], ["matInput", "", "name", "dataNascimento", "formControlName", "dataNasc", "autocomplete", "off", 3, "mask", "dropSpecialCharacters"], ["name", "sexo", "formControlName", "sexo"], [3, "value", 4, "ngFor", "ngForOf"], ["name", "estadoCivil", "formControlName", "estadoCivil", 3, "selectionChange"], ["matInput", "", "name", "cepImovel", "formControlName", "cep", "placeholder", "Ex. 00000-000", "autocomplete", "off", 3, "change", "mask", "dropSpecialCharacters"], ["class", "campo-icone", "svgIcon", "check-circle-outline", 3, "matTooltip", 4, "ngIf"], ["class", "campo-icone", "svgIcon", "alert-circle-outline", 3, "matTooltip", "click", 4, "ngIf"], ["matInput", "", "name", "fone", "formControlName", "fone", "type", "tel", "placeholder", "Ex. (00) 0000-0000", "autocomplete", "off", 3, "ngModelChange", "mask", "dropSpecialCharacters"], ["matTooltip", "Usar o da corretora", "svgIcon", "briefcase-edit", 1, "campo-icone", 3, "click"], ["name", "emailSegurado", "matInput", "", "formControlName", "email", "placeholder", "Ex. pat@example.com", "autocomplete", "off"], ["tabindex", "-1", "id", "submitFormSegurado", 2, "opacity", "0", "position", "absolute", "z-index", "-1000"], ["mat-spinner", "", "diameter", "20", 1, "spinnerLoading"], [3, "value"], ["svgIcon", "check-circle-outline", 1, "campo-icone", 3, "matTooltip"], ["svgIcon", "alert-circle-outline", 1, "campo-icone", 3, "click", "matTooltip"]], template: function FormularioAutoSeguradoComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 1)(1, "mat-form-field", 2)(2, "mat-label");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "input", 3, 0);
            i0.ɵɵlistener("focus", function FormularioAutoSeguradoComponent_Template_input_focus_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.limpaMascaraCpfCnpj()); })("blur", function FormularioAutoSeguradoComponent_Template_input_blur_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.atualizaMascaraCpfCnpj(true)); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, FormularioAutoSeguradoComponent_mat_spinner_6_Template, 1, 1, "mat-spinner", 4)(7, FormularioAutoSeguradoComponent_mat_error_7_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mat-form-field", 2)(9, "mat-label");
            i0.ɵɵtext(10, "Nome Completo");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "input", 6);
            i0.ɵɵtemplate(12, FormularioAutoSeguradoComponent_mat_error_12_Template, 2, 0, "mat-error", 5)(13, FormularioAutoSeguradoComponent_mat_error_13_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-form-field", 2)(15, "mat-label");
            i0.ɵɵtext(16, "Data de Nascimento");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(17, "input", 7);
            i0.ɵɵtemplate(18, FormularioAutoSeguradoComponent_mat_error_18_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "mat-form-field", 2)(20, "mat-label");
            i0.ɵɵtext(21, "Sexo");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "mat-select", 8);
            i0.ɵɵtemplate(23, FormularioAutoSeguradoComponent_mat_option_23_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, FormularioAutoSeguradoComponent_mat_error_24_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "mat-form-field", 2)(26, "mat-label");
            i0.ɵɵtext(27, "Estado Civil");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(28, "mat-select", 10);
            i0.ɵɵlistener("selectionChange", function FormularioAutoSeguradoComponent_Template_mat_select_selectionChange_28_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.enviaEstadoCivil(ctx.formsService.buscaViewValue(ctx.selects.estadoCivil, $event.value))); });
            i0.ɵɵtemplate(29, FormularioAutoSeguradoComponent_mat_option_29_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(30, FormularioAutoSeguradoComponent_mat_error_30_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "mat-form-field", 2)(32, "mat-label");
            i0.ɵɵtext(33, "CEP Residencial");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "input", 11);
            i0.ɵɵlistener("change", function FormularioAutoSeguradoComponent_Template_input_change_34_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaInfosEndereco()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(35, FormularioAutoSeguradoComponent_mat_spinner_35_Template, 1, 1, "mat-spinner", 4)(36, FormularioAutoSeguradoComponent_mat_icon_36_Template, 1, 1, "mat-icon", 12)(37, FormularioAutoSeguradoComponent_mat_icon_37_Template, 1, 1, "mat-icon", 13)(38, FormularioAutoSeguradoComponent_mat_error_38_Template, 2, 0, "mat-error", 5)(39, FormularioAutoSeguradoComponent_mat_error_39_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(40, "mat-form-field", 2)(41, "mat-label");
            i0.ɵɵtext(42, "Telefone");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "input", 14);
            i0.ɵɵlistener("ngModelChange", function FormularioAutoSeguradoComponent_Template_input_ngModelChange_43_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.alteraMascaraTelefone($event)); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(44, FormularioAutoSeguradoComponent_mat_error_44_Template, 2, 0, "mat-error", 5)(45, FormularioAutoSeguradoComponent_mat_error_45_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementStart(46, "mat-icon", 15);
            i0.ɵɵlistener("click", function FormularioAutoSeguradoComponent_Template_mat_icon_click_46_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.usarFoneCorretora()); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(47, "mat-form-field", 2)(48, "mat-label");
            i0.ɵɵtext(49, "Email");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(50, "input", 16);
            i0.ɵɵtemplate(51, FormularioAutoSeguradoComponent_mat_error_51_Template, 2, 0, "mat-error", 5)(52, FormularioAutoSeguradoComponent_mat_error_52_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementStart(53, "mat-icon", 15);
            i0.ɵɵlistener("click", function FormularioAutoSeguradoComponent_Template_mat_icon_click_53_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.usarEmailCorretora()); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(54, "button", 17);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            let tmp_9_0;
            let tmp_12_0;
            let tmp_13_0;
            let tmp_18_0;
            let tmp_22_0;
            let tmp_26_0;
            let tmp_34_0;
            let tmp_35_0;
            i0.ɵɵproperty("ngClass", !ctx.isRecalculo ? "col-12 form-auto-step" : "col-12 form-auto-step recalculo")("formGroup", ctx.formAutoSegurado);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_CPFCNPJ))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.controlerTipoDocumento[ctx.tipoDocumento].label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("mask", ctx.masks[ctx.tipoDocumento])("dropSpecialCharacters", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.buscaControler.segurado.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_9_0 = ctx.formAutoSegurado.get("cpfCnpj")) == null ? null : tmp_9_0.hasError("validaCpfCnpj"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_NOME))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-9" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", (tmp_12_0 = ctx.formAutoSegurado.get("nome")) == null ? null : tmp_12_0.hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_13_0 = ctx.formAutoSegurado.get("nome")) == null ? null : tmp_13_0.hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_DATANASC))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.DATA)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_18_0 = ctx.formAutoSegurado.get("dataNasc")) == null ? null : tmp_18_0.hasError("validaData"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_SEXO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects == null ? null : ctx.selects.sexo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_22_0 = ctx.formAutoSegurado.get("sexo")) == null ? null : tmp_22_0.hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_ESTADOCIVIL))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.estadoCivil);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_26_0 = ctx.formAutoSegurado.get("estadoCivil")) == null ? null : tmp_26_0.hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_CEP))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.CEP)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buscaControler.endereco.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.buscaControler.endereco.buscando && ctx.buscaControler.endereco.status == "ENCONTROU");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.buscaControler.endereco.buscando && (ctx.buscaControler.endereco == null ? null : ctx.buscaControler.endereco.status) == "NAO-ENCONTROU");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_34_0 = ctx.formAutoSegurado.get("cep")) == null ? null : tmp_34_0.hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_35_0 = ctx.formAutoSegurado.get("cep")) == null ? null : tmp_35_0.hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_FONE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.maskTelefone)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSegurado.get("fone").hasError("pattern") || ctx.formAutoSegurado.get("fone").hasError("foneValid"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSegurado.get("fone").hasError("required"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADO_EMAIL))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-9" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.formAutoSegurado.get("email").hasError("email"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSegurado.get("email").hasError("maxlength"));
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i4$1.MatOption, i5.MatFormField, i5.MatLabel, i5.MatError, i6.MatIcon, i7.MatInput, i8.MatProgressSpinner, i9.MatSelect, i10.MatTooltip, i11.NgxMaskDirective, i1$2.FormGroupDirective, i1$2.FormControlName], styles: [".mdc-text-field--disabled.mdc-text-field--filled[_ngcontent-%COMP%]{background-color:transparent}.form-auto-step[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:var(--color-tertiary-first);font-weight:500;text-transform:uppercase;font-size:15px;letter-spacing:.5px;padding:0 15px;margin-top:10px}.form-auto-step[_ngcontent-%COMP%]   .campo-icone[_ngcontent-%COMP%]{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step[_ngcontent-%COMP%]   .spinnerLoading[_ngcontent-%COMP%]{position:absolute;right:0;top:10px}.form-auto-step[_ngcontent-%COMP%]:not(.recalculo){padding:0 15px}.recalculo[_ngcontent-%COMP%]{padding:0}"], data: { animation: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])] } });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormularioAutoSeguradoComponent, [{
        type: Component,
        args: [{ selector: 'formulario-auto-segurado', animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])], template: "<form [ngClass]=\"!isRecalculo ? 'col-12 form-auto-step' : 'col-12 form-auto-step recalculo'\" [formGroup]=\"formAutoSegurado\">\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_CPFCNPJ \" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>{{ controlerTipoDocumento[tipoDocumento].label }}</mat-label>\r\n        <input matInput name=\"cpfCnpj\" formControlName=\"cpfCnpj\" placeholder=\"Ex. 000.000.000-00\" [mask]=\"masks[tipoDocumento]\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (focus)=\"limpaMascaraCpfCnpj()\" (blur)=\"atualizaMascaraCpfCnpj(true)\" #cpfCnpj/>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.segurado.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formAutoSegurado.get('cpfCnpj')?.hasError('validaCpfCnpj')\">N\u00FAmero do documento inv\u00E1lido.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_NOME\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-9' : 'col-12'\">\r\n      <mat-label>Nome Completo</mat-label>\r\n      <input matInput name=\"nomeSegurado\" formControlName=\"nome\" class=\"text-capitalize\" autocomplete=\"off\"/>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('nome')?.hasError('pattern')\">Por favor, insira o nome completo.</mat-error>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('nome')?.hasError('required')\">Por favor, insira o nome completo.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_DATANASC\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Data de Nascimento</mat-label>\r\n      <input matInput name=\"dataNascimento\" formControlName=\"dataNasc\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('dataNasc')?.hasError('validaData')\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_SEXO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Sexo</mat-label>\r\n      <mat-select name=\"sexo\" formControlName=\"sexo\">\r\n        <mat-option *ngFor=\"let s of selects?.sexo\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">{{ s.viewValue }}</mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('sexo')?.hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_ESTADOCIVIL\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Estado Civil</mat-label>\r\n      <mat-select name=\"estadoCivil\" formControlName=\"estadoCivil\" (selectionChange)=\"enviaEstadoCivil(formsService.buscaViewValue(selects.estadoCivil, $event.value))\">\r\n        <mat-option *ngFor=\"let e of selects.estadoCivil\" [value]=\"e.value\" [attr.custom-reflect-value]=\"e.value\">{{ e.viewValue }}</mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('estadoCivil')?.hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_CEP\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n      <mat-label>CEP Residencial</mat-label>\r\n      <input matInput name=\"cepImovel\" formControlName=\"cep\" placeholder=\"Ex. 00000-000\" [mask]=\"masks.CEP\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaInfosEndereco()\"/>\r\n      <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.endereco.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n      <mat-icon class=\"campo-icone\" svgIcon=\"check-circle-outline\" [matTooltip]=\"buscaControler.endereco.tooltip\"\r\n      *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'ENCONTROU'\"></mat-icon>\r\n      <mat-icon class=\"campo-icone\" svgIcon=\"alert-circle-outline\" [matTooltip]=\"buscaControler.endereco.tooltip\"\r\n      *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco?.status == 'NAO-ENCONTROU'\" (click)=\"abrirModalCep()\"></mat-icon>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('cep')?.hasError('pattern')\">Por favor, insira um CEP v\u00E1lido.</mat-error>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('cep')?.hasError('required')\">Por favor, insira um CEP.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_FONE\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Telefone</mat-label>\r\n      <input matInput name=\"fone\" formControlName=\"fone\" type=\"tel\" placeholder=\"Ex. (00) 0000-0000\" [mask]=\"maskTelefone\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (ngModelChange)=\"alteraMascaraTelefone($event)\"/>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('fone').hasError('pattern') || formAutoSegurado.get('fone').hasError('foneValid')\">\r\n          Por favor, insira um telefone v\u00E1lido.\r\n      </mat-error>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('fone').hasError('required')\">\r\n          Por favor, insira um telefone.\r\n      </mat-error>\r\n      <mat-icon matTooltip=\"Usar o da corretora\" class=\"campo-icone\" svgIcon=\"briefcase-edit\" (click)=\"usarFoneCorretora()\"></mat-icon>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADO_EMAIL\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-9' : 'col-12'\">\r\n      <mat-label>Email</mat-label>\r\n      <input name=\"emailSegurado\" matInput formControlName=\"email\" placeholder=\"Ex. pat@example.com\" autocomplete=\"off\"/>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('email').hasError('email')\">Por favor, insira um e-mail v\u00E1lido</mat-error>\r\n      <mat-error *ngIf=\"formAutoSegurado.get('email').hasError('maxlength')\">O e-mail deve ter no m\u00E1ximo 60 caracteres</mat-error>\r\n      <mat-icon matTooltip=\"Usar o da corretora\" class=\"campo-icone\" svgIcon=\"briefcase-edit\" (click)=\"usarEmailCorretora()\"></mat-icon>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormSegurado\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}.form-auto-step h3{color:var(--color-tertiary-first);font-weight:500;text-transform:uppercase;font-size:15px;letter-spacing:.5px;padding:0 15px;margin-top:10px}.form-auto-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step .spinnerLoading{position:absolute;right:0;top:10px}.form-auto-step:not(.recalculo){padding:0 15px}.recalculo{padding:0}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['api']
            }] }, { type: i1$1.MatDialog }, { type: i1$2.FormBuilder }, { type: FormsService }, { type: i4$2.ActivatedRoute }], { recalculo: [{
            type: Input
        }], listaCampo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormularioAutoSeguradoComponent, { className: "FormularioAutoSeguradoComponent", filePath: "components\\formulario-auto-segurado\\formulario-auto-segurado.component.ts", lineNumber: 16 }); })();

function FormularioAutoVeiculoComponent_mat_spinner_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 34);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoVeiculoComponent_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira uma placa v\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_spinner_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 34);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoVeiculoComponent_mat_error_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um chassi v\u00E1lido.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_error_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Ano de fabrica\u00E7\u00E3o n\u00E3o permitido.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_option_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", a_r2.value);
    i0.ɵɵattribute("custom-reflect-value", a_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", a_r2.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const k_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", k_r3.value)("disabled", k_r3.disabled);
    i0.ɵɵattribute("custom-reflect-value", k_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", k_r3.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_spinner_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 34);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoVeiculoComponent_mat_error_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, digite a FIPE.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_error_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, digite uma FIPE v\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_option_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", opt_r4)("matTooltip", opt_r4.modelo);
    i0.ɵɵattribute("custom-reflect-value", opt_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", opt_r4.modelo, " ");
} }
function FormularioAutoVeiculoComponent_mat_icon_43_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 38);
    i0.ɵɵlistener("click", function FormularioAutoVeiculoComponent_mat_icon_43_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.enquadrarVeiculo(ctx_r5.formAutoVeiculo.value.tipoVeic)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("svgIcon", ctx_r5.formAutoVeiculo.value.tipoVeic == "c" ? "car-side" : "truck")("matTooltip", ctx_r5.formAutoVeiculo.value.tipoVeic == "v" ? "Enquadrar como ve\u00EDculo utilit\u00E1rio de pequeno porte ou caminh\u00E3o" : "Enquadrar ve\u00EDculo como autom\u00F3vel de passeio");
} }
function FormularioAutoVeiculoComponent_mat_error_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, digite o modelo.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_option_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r7 = ctx.$implicit;
    i0.ɵɵproperty("value", c_r7.value);
    i0.ɵɵattribute("custom-reflect-value", c_r7.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", c_r7.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_error_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_h3_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1, "Informa\u00E7\u00F5es complementares");
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_option_65_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", p_r8.value);
    i0.ɵɵattribute("custom-reflect-value", p_r8.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", p_r8.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_70_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", i_r9.value);
    i0.ɵɵattribute("custom-reflect-value", i_r9.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r9.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", d_r10.value);
    i0.ɵɵattribute("custom-reflect-value", d_r10.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", d_r10.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_80_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r11 = ctx.$implicit;
    i0.ɵɵproperty("value", d_r11.value);
    i0.ɵɵattribute("custom-reflect-value", d_r11.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", d_r11.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_85_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r12.value);
    i0.ɵɵattribute("custom-reflect-value", v_r12.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r12.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_90_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r13 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r13.value);
    i0.ɵɵattribute("custom-reflect-value", v_r13.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r13.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_icon_95_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 39);
    i0.ɵɵlistener("mouseenter", function FormularioAutoVeiculoComponent_mat_icon_95_Template_mat_icon_mouseenter_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.focus = true); })("mouseleave", function FormularioAutoVeiculoComponent_mat_icon_95_Template_mat_icon_mouseleave_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.focus = false); })("click", function FormularioAutoVeiculoComponent_mat_icon_95_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.setaValue(ctx_r5.formAutoVeiculo.controls["gasInstalValor"], 0)); });
    i0.ɵɵelementEnd();
} }
function FormularioAutoVeiculoComponent_mat_option_98_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-option", 40);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵlistener("mouseEnter", function FormularioAutoVeiculoComponent_mat_option_98_Template_mat_option_mouseEnter_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.isMouseOverSelect = true); })("mouseLeave", function FormularioAutoVeiculoComponent_mat_option_98_Template_mat_option_mouseLeave_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.isMouseOverSelect = false); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r16 = ctx.$implicit;
    i0.ɵɵproperty("value", i0.ɵɵpipeBind2(1, 2, v_r16.value, "BRL"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", v_r16.viewValue, " ");
} }
function FormularioAutoVeiculoComponent_mat_option_104_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r17 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r17.value);
    i0.ɵɵattribute("custom-reflect-value", v_r17.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r17.viewValue, " ");
} }
class FormularioAutoVeiculoComponent {
    api;
    formBuilder;
    formsService;
    location;
    estatisticasVeiculoService;
    modalPersonalizadaService;
    buscaControler = ConstantFormAuto.controlerBusca;
    currencyOptions = ConstantFormAuto.currency;
    masks = ConstantFormAuto.maskValidate;
    patterns = ConstantFormAuto.patternValidade;
    selects = ConstantFormAuto.objSelects;
    alteraTpVeiculo = false;
    copiaDraft = null;
    subscriptions = new Subscription();
    blindagem = false;
    debounceTimers = {};
    fieldFocusStates = {};
    focus = false;
    isMouseOverSelect = false;
    filteredOptions = { gasInstalValor: undefined };
    formAutoVeiculo;
    modelosFiltrados;
    vigenciaIni;
    //recalculo
    isRecalculo;
    habCampos = {};
    set recalculo(value) {
        this.isRecalculo = value;
    }
    set listaCampo(value) {
        this.habCampos = value;
    }
    constructor(api, formBuilder, formsService, location, estatisticasVeiculoService, modalPersonalizadaService) {
        this.api = api;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.location = location;
        this.estatisticasVeiculoService = estatisticasVeiculoService;
        this.modalPersonalizadaService = modalPersonalizadaService;
        this.formAutoVeiculo = this.formBuilder.group({
            zeroKm: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.zeroKm)]),
            placa: new FormControl('', [Validators.pattern(this.patterns.PLACA)]),
            chassi: new FormControl('', [Validators.pattern(this.patterns.CHASSI)]),
            fipe: new FormControl('', [Validators.required, Validators.pattern(this.patterns.FIPE)]),
            anoFab: new FormControl('', [Validators.required, Validators.pattern(this.patterns.ANO), FormsService.validIntervaloAnos(1970, FormsService.getAnoAtual())]),
            anoMod: new FormControl('', [Validators.required, Validators.pattern(this.patterns.ANO), FormsService.inArrayValidator(this.selects.anoMod)]),
            valReferenciado: new FormControl('', [Validators.required]),
            nrEixos: new FormControl('', [Validators.max(11)]),
            alienado: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.simOuNao)]),
            blindado: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.simOuNao)]),
            kitGas: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.simOuNao)]),
            isencaoFiscal: new FormControl(0, [Validators.required, FormsService.inArrayValidator(this.selects.isencaoFiscal)]),
            isPCD: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.simOuNao)]),
            rastreador: new FormControl('0', [Validators.required, FormsService.inArrayValidator(this.selects.rastreador)]),
            dispAntiFurto: new FormControl('0', [Validators.required, FormsService.inArrayValidator(this.selects.dispAntiFurto)]),
            combustivel: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.combustivel)]),
            modelo: new FormControl('', [Validators.required]),
            codFabr: new FormControl('', [Validators.required]),
            tipoVeic: new FormControl('v', [Validators.required]),
            gasInstalValor: new FormControl('', []),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
        if (!this.isRecalculo)
            this.formsService.desabilitaCampos(ConstantFormAuto.camposVeiculoDesabilitadosDefault, this.formAutoVeiculo);
        this.setaVeiculosFiltrados([]);
    }
    ngOnDestroy() {
        this.formsService.salvarDraftFinal();
        this.subscriptions.unsubscribe();
    }
    atualizaCamposVeiculo(infos) {
        Object.keys(infos).forEach(campo => {
            campo == 'anoMod' && this.setaAnoFabricao(infos[campo]);
            this.formAutoVeiculo.controls[campo] && this.formAutoVeiculo.controls[campo].setValue(FormsService.formatField(campo, infos[campo]));
        });
    }
    atualizaInfosVeiculo(veiculo) {
        try {
            this.setaTipoVeiculo(veiculo.tipo);
            this.setaValReferenciado([veiculo]);
            Object.keys(ConstantFormAuto.camposModelo).forEach(campo => {
                this.formAutoVeiculo.controls[campo].setValue(veiculo[ConstantFormAuto.camposModelo[campo]] ? veiculo[ConstantFormAuto.camposModelo[campo]] : null);
            });
            this.tipoSugerido(veiculo);
        }
        catch (error) {
            this.formsService.openSnackbarModal('Não foi encontrado um veiculo com as informações fornecidas.');
        }
    }
    atualizaZeroKMOptions(anoModelo) {
        let anoAtual = new Date().getFullYear();
        if (anoModelo < anoAtual - 2) {
            this.selects.zeroKm.find(opt => opt.viewValue == 'Sim').disabled = true;
            this.formAutoVeiculo.controls.zeroKm.setValue(false);
        }
        else {
            this.selects.zeroKm.find(opt => opt.viewValue == 'Sim').disabled = false;
        }
    }
    async buscaInfosVeiculo(nomeCampo) {
        let campoValido = this.formAutoVeiculo.controls[nomeCampo].valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler[nomeCampo].ultimaBusca != this.formsService.limparString(this.formAutoVeiculo.controls[nomeCampo].value);
        if (campoValido && buscaAnteriorDiferenteAtual) {
            this.buscaControler[nomeCampo].buscando = true;
            let infosVeiculo = (nomeCampo == 'placa') ?
                await this.api.getCalculoPlacaModelo(this.formsService.limparString(this.formAutoVeiculo.controls[nomeCampo].value)).catch(error => { return error; }) :
                await this.api.getCalculoChassiModelo(this.formsService.limparString(this.formAutoVeiculo.controls[nomeCampo].value)).catch(error => { return error; });
            infosVeiculo = await this.verificaArrayVeiculos(infosVeiculo);
            if (infosVeiculo && !infosVeiculo.hasOwnProperty('error')) {
                await this.atualizaCamposVeiculo(infosVeiculo);
                if (!infosVeiculo.hasOwnProperty('anoMod') && infosVeiculo.hasOwnProperty('anoFab'))
                    this.habilitaAnoModelo();
                this.buscaPelaFipe();
            }
            this.buscaControler[nomeCampo].ultimaBusca = this.formsService.limparString(this.formAutoVeiculo.controls[nomeCampo].value);
            this.buscaControler[nomeCampo].buscando = false;
        }
    }
    buscaModelo() {
        this.debounce(() => {
            let buscaAtual = `${this.formAutoVeiculo.controls.modelo.value} / ${this.formAutoVeiculo.controls.anoMod.value}`;
            if (buscaAtual !== this.buscaControler.veiculo.ultimaBusca) {
                this.buscaControler.veiculo.ultimaBusca = `${this.formAutoVeiculo.controls.modelo.value} / ${this.formAutoVeiculo.controls.anoMod.value}`;
                this.api.getCalculoDescricaoModelo('', this.formAutoVeiculo.controls.modelo.value, this.formAutoVeiculo.controls.anoMod.value).then(function (modelos) {
                    if (modelos && modelos?.length)
                        this.setaVeiculosFiltrados(modelos);
                    else
                        this.formsService.openSnackbarModal('Veículo não encontrado. Verifique os valores fornecidos.');
                }.bind(this)).catch(async function (e) {
                    console.log(e);
                }.bind(this));
            }
        }, 'modelo', 350);
    }
    async buscaPelaFipe() {
        let anoModelo = this.formAutoVeiculo.controls.anoMod.value;
        let zeroKm = this.formAutoVeiculo.controls.zeroKm.value;
        let fipe = this.formAutoVeiculo.controls.fipe.value;
        let fipeValida = this.formAutoVeiculo.controls.fipe.valid;
        if (fipeValida) {
            if (anoModelo) {
                this.buscaControler.fipe.buscando = true;
                let infosModelo = await this.estatisticasVeiculoService.getFipeModelo(fipe, anoModelo, zeroKm, this.api).catch(error => { return error; });
                if (infosModelo && infosModelo.length > 0 && !infosModelo.hasOwnProperty('error')) {
                    if (!this.alteraTpVeiculo && this.copiaDraft?.automoveis[0]?.tipo) {
                        infosModelo[0].tipo = this.copiaDraft.automoveis[0].tipo;
                        this.alteraTpVeiculo = true;
                    }
                    this.atualizaInfosVeiculo(infosModelo[0]);
                }
                this.buscaControler.fipe.buscando = false;
            }
            else {
                this.formsService.openSnackbarModal('Informe o ano modelo!');
            }
        }
    }
    carregaInfosDraft(draft) {
        if (!draft?.isClearDraft && Object.keys(this.formAutoVeiculo?.controls).length) {
            if (draft?.automoveis && draft?.automoveis.length > 0) {
                let draftAutomovel = draft.automoveis[0];
                Object.keys(ConstantFormAuto.camposVeiculoDraft).forEach(campo => {
                    this.formAutoVeiculo.controls[campo] && draftAutomovel[ConstantFormAuto.camposVeiculoDraft[campo]] &&
                        this.formAutoVeiculo.controls[campo].setValue(FormsService.formatField(campo, draftAutomovel[ConstantFormAuto.camposVeiculoDraft[campo]]));
                });
                if (!draftAutomovel.hasOwnProperty('blindado'))
                    this.formAutoVeiculo.controls.blindado.setValue(this.blindagem);
                if (!draftAutomovel.hasOwnProperty('kitGas'))
                    this.formAutoVeiculo.controls.kitGas.setValue(!!draftAutomovel['gasInstalValor']);
                if (!draftAutomovel.hasOwnProperty('antiFurto'))
                    this.formAutoVeiculo.controls.dispAntiFurto.setValue(ConstantFormAuto.deParaAntifurto(draftAutomovel['cdAntiFurto']));
                if (!draftAutomovel.hasOwnProperty('rastreador'))
                    this.formAutoVeiculo.controls.rastreador.setValue(ConstantFormAuto.deParaRastreador(draftAutomovel['cdAntiFurto']));
                this.formAutoVeiculo.controls.isPCD.setValue(!!draft?.segurado?.isPCD);
            }
        }
    }
    debounce(fn, id, timeout) {
        clearTimeout(this.debounceTimers[id]);
        this.debounceTimers[id] = setTimeout(fn, timeout);
    }
    displayFnWrapper() {
        return (offer) => this.displayFn(offer);
    }
    displayFn(offer) {
        if (typeof offer == 'string')
            offer = { modelo: offer };
        return offer && offer.modelo ? offer.modelo : undefined;
    }
    enquadrarVeiculo(veic) {
        veic?.tipo == 'v' || veic == 'v'
            ? (this.setaTipoVeiculo('c'), this.formsService.mudaPerfil('c'))
            : (this.setaTipoVeiculo('v'), this.formsService.mudaPerfil('v'));
    }
    executaFuncoesIniciais() {
        this.alteraTpVeiculo = false;
        this.setFilters();
        this.verificaPCD(this.formAutoVeiculo.controls.isPCD.value);
        this.habilitaAnoModelo();
        this.buscaPelaFipe();
        this.habilitaKitGasValor(this.formAutoVeiculo.controls.kitGas.value);
    }
    geraAnoModeloOptions(ano) {
        this.selects.anoMod = this.formsService.generateOptionsAnoModelo(ano);
        this.formAutoVeiculo.controls.anoMod.setValidators([Validators.required, Validators.pattern(this.patterns.ANO), FormsService.inArrayValidator(this.selects.anoMod)]);
        this.formAutoVeiculo.controls.anoMod.updateValueAndValidity();
    }
    habilitaAnoModelo() {
        if (this.formAutoVeiculo.controls.anoFab.valid) {
            this.geraAnoModeloOptions(this.formAutoVeiculo.controls.anoFab.value);
            this.formAutoVeiculo.controls.anoMod.enable();
            this.formAutoVeiculo.controls.modelo.enable({ emitEvent: false });
            if (!this.formAutoVeiculo.controls.anoMod.value)
                this.formAutoVeiculo.controls.anoMod.setValue(Number(this.formAutoVeiculo.controls.anoFab.value));
            else
                this.formsService.buscaViewValue(this.selects?.anoMod, this.formAutoVeiculo.controls.anoMod.value) ? null
                    : (this.formAutoVeiculo.controls.anoMod.reset(), this.formAutoVeiculo.controls.anoMod.setValue(Number(this.formAutoVeiculo.controls.anoFab.value)));
            this.atualizaZeroKMOptions(this.formAutoVeiculo.controls.anoMod.value);
            this.buscaPelaFipe();
        }
        else {
            this.formAutoVeiculo.controls.anoMod.reset();
            this.formAutoVeiculo.controls.anoMod.disable();
        }
    }
    habilitaKitGasValor(kitGas) {
        kitGas ? this.formAutoVeiculo.controls.gasInstalValor.enable() : (this.formAutoVeiculo.controls.gasInstalValor.disable(),
            this.formAutoVeiculo.controls.gasInstalValor.reset(),
            this.formAutoVeiculo.controls.gasInstalValor.setValue(0));
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            this.copiaDraft = draft;
            if (this.formsService.isVendaCruzada(draft)) {
                this.formsService.setaInfosDefault(this.formAutoVeiculo, 'veiculo');
                this.formsService.setaInfosDefault(this.formAutoVeiculo, this.formAutoVeiculo.controls.tipoVeic.value);
            }
            else
                this.carregaInfosDraft(draft);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formAutoVeiculo?.valueChanges.subscribe(() => {
            if (this.formAutoVeiculo.valid)
                this.formsService.enviaValidadeFormulario({ formularioNome: 'automovel', valido: this.formAutoVeiculo.valid });
        }));
        this.subscriptions.add(this.formsService.vigenciaIniEmiter.subscribe(vigenciaIni => {
            this.vigenciaIni = vigenciaIni;
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formAutoVeiculo.reset();
            this.buscaControler = ConstantFormAuto.controlerBusca;
            this.formsService.setaInfosDefault(this.formAutoVeiculo, 'veiculo');
            this.formsService.setaInfosDefault(this.formAutoVeiculo, this.formAutoVeiculo.controls.tipoVeic.value);
            if (!this.isRecalculo)
                this.formsService.desabilitaCampos(ConstantFormAuto.camposVeiculoDesabilitadosDefault, this.formAutoVeiculo);
        }));
        this.subscriptions.add(this.formsService.tipoVeiculoEmiter.subscribe(tipoVeiculo => {
            this.formAutoVeiculo.controls.tipoVeic.setValue(tipoVeiculo);
            this.formsService.mudaPerfil(tipoVeiculo);
            this.formsService.setaInfosDefault(this.formAutoVeiculo, this.formAutoVeiculo.controls.tipoVeic.value);
        }));
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(() => {
            this.formsService.setaInfosDefault(this.formAutoVeiculo, 'veiculo');
            this.formsService.setaInfosDefault(this.formAutoVeiculo, this.formAutoVeiculo.controls.tipoVeic.value);
            if (!this.isRecalculo)
                this.formsService.desabilitaCampos(ConstantFormAuto.camposVeiculoDesabilitadosDefault, this.formAutoVeiculo);
            this.executaFuncoesIniciais();
        }));
    }
    limparInfosVeiculo() {
        ConstantFormAuto.camposLimparVeiculo.forEach(campo => {
            this.formAutoVeiculo.controls[campo].reset(),
                (campo == 'modelo' || campo == 'anoMod') && this.formAutoVeiculo.controls[campo].disable(),
                (campo == 'zeroKm') && this.formAutoVeiculo.controls[campo].setValue(false),
                (campo == 'placa' || campo == 'chassi' || campo == 'fipe') && (this.buscaControler[campo].ultimaBusca = undefined);
        });
        this.setaTipoVeiculo(this.formAutoVeiculo.controls.tipoVeic.value);
    }
    setaAnoFabricao(ano) {
        this.formAutoVeiculo.controls.anoFab.setValue(FormsService.formatField('anoMod', ano));
        this.habilitaAnoModelo();
    }
    setaTipoVeiculo(tipoVeiculo) {
        this.formsService.enviaTipoVeiculo(tipoVeiculo);
        this.formAutoVeiculo.controls.tipoVeic.setValue(tipoVeiculo);
    }
    setaValReferenciado(infosVeiculo) {
        let valorFipeAtual = this.formsService.getFipeAtualValores(infosVeiculo);
        if (valorFipeAtual !== "")
            this.formAutoVeiculo.controls.valReferenciado.setValue(this.formsService.numberFormat(valorFipeAtual, true));
        else {
            this.formsService.openSnackbarModal('Não foi possível determinar o valor referenciado.');
            this.formAutoVeiculo.controls.valReferenciado.setValue(0);
        }
    }
    setaVeiculosFiltrados(modelos) {
        this.modelosFiltrados = this.formAutoVeiculo.controls.modelo?.valueChanges
            .pipe(startWith(''), map((value) => {
            return (typeof value === 'string' ? value : value?.modelo);
        }), map(name => {
            let arrayModelos = modelos.slice();
            return (name ? this.buscaModelo() : (arrayModelos.length > 0 ? (arrayModelos.length === 1 && !arrayModelos[0].modelo) ? [] : arrayModelos : []));
        }));
    }
    async tipoSugerido(veic) {
        if (veic.tipoSugerido && veic.tipoSugerido !== veic.tipo) {
            let vehicleTypes = await this.formsService.tipoVeiculoText(veic.tipoSugerido);
            let changeForm = await this.formsService.createConfirm('Atenção', 'O veículo selecionado é considerado ' + vehicleTypes.veiculo + ' para algumas seguradoras. Deseja alterar para o formulario de ' + vehicleTypes.form + '?', 'Alterar', 'Manter');
            if (changeForm) {
                this.enquadrarVeiculo(veic);
            }
        }
    }
    verifyAplicacRoute(veic) {
        if (this.api.getAplicacaoId() === 1) {
            if (veic?.tipo === 'c' || veic === 'c') {
                this.changeRouteWhenFramed('carro', 'caminhao');
                this.changeRouteWhenFramed('motocicleta', 'caminhao');
            }
            if (veic?.tipo === 'v' || veic === 'v') {
                this.changeRouteWhenFramed('caminhao', 'carro');
                this.changeRouteWhenFramed('motocicleta', 'carro');
            }
            if (veic?.tipo === 'm' || veic === 'm') {
                this.changeRouteWhenFramed('carro', 'motocicleta');
                this.changeRouteWhenFramed('caminhao', 'motocicleta');
            }
        }
    }
    changeRouteWhenFramed(route, newRoute) {
        let rotaFormularioAuto = this.location.path();
        rotaFormularioAuto = rotaFormularioAuto.replace(route, newRoute);
        this.location.replaceState(rotaFormularioAuto);
    }
    async verificaArrayVeiculos(infosVeiculo) {
        try {
            if (Array.isArray(infosVeiculo)) {
                if (infosVeiculo.length == 0)
                    return false;
                else if (infosVeiculo.length == 1)
                    return infosVeiculo[0];
                else if (infosVeiculo.length > 1) {
                    let retModal = await this.modalPersonalizadaService.open(infosVeiculo);
                    if (retModal)
                        return retModal;
                    else
                        return false;
                }
            }
            else {
                const veiculos = infosVeiculo?.veiculos;
                if (veiculos && veiculos.length > 1) {
                    let retModal = await this.modalPersonalizadaService.open(this.formataArrayVeiculos(infosVeiculo, veiculos));
                    if (retModal)
                        return retModal;
                    else
                        return false;
                }
                else {
                    return infosVeiculo;
                }
            }
        }
        catch (error) {
            return false;
        }
    }
    formataArrayVeiculos(infosVeiculo, veiculos) {
        try {
            let infosVeiculos = [];
            for (let veiculo of veiculos) {
                infosVeiculos.push({
                    "fipe": veiculo["codigoFipe"],
                    "tipoVeic": veiculo["tipoVeic"],
                    "codFabr": veiculo["codFabr"],
                    "modelo": veiculo["modelo"],
                    "anoMod": infosVeiculo["anoMod"],
                    "placa": infosVeiculo["placa"],
                    "chassi": infosVeiculo["chassi"]
                });
            }
            return infosVeiculos;
        }
        catch (error) {
            return false;
        }
    }
    setFilters() {
        Object.keys(this.filteredOptions).forEach(filter => {
            this.filteredOptions[filter] = (this.formAutoVeiculo.controls[filter]?.valueChanges.pipe(startWith(''), map((state) => (state ? this._filterMonetario(state, filter, this.selects) : this.selects?.[filter].slice()))));
        });
    }
    _filterMonetario(value, filter, selects) {
        const filterValue = FormsService.removeNumeroMonetario(value);
        return selects[filter].filter(option => option.value.toString().toLowerCase().includes(filterValue));
    }
    resetaOuMantemValor(formControl) {
        formControl.setValue(formControl.value ? formControl.value : 0);
    }
    arredonda(formControl) {
        if (formControl.value && !Number.isInteger(formControl.value)) {
            formControl.setValue(parseInt(formControl.value));
        }
    }
    controlaFocus(campo) {
        return this.focus || this.isMouseOverSelect ? null : this.fieldFocusStates[campo] = false;
    }
    onFocus(field) {
        this.fieldFocusStates[field] = true;
        Object.keys(this.fieldFocusStates).forEach(key => {
            if (key != field) {
                this.fieldFocusStates[key] = false;
            }
        });
    }
    setaValue(formControl, value, naoEmitirEvento) {
        formControl.setValue(FormsService.removeNumeroMonetario(value), { emitEvent: !naoEmitirEvento });
    }
    verificaPCD(isPCD) {
        isPCD ? this.formAutoVeiculo.controls.isencaoFiscal.enable() : (this.formAutoVeiculo.controls.isencaoFiscal.disable(),
            this.formAutoVeiculo.controls.isencaoFiscal.reset(),
            this.formAutoVeiculo.controls.isencaoFiscal.setValue(0));
    }
    static ɵfac = function FormularioAutoVeiculoComponent_Factory(t) { return new (t || FormularioAutoVeiculoComponent)(i0.ɵɵdirectiveInject('api'), i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(FormsService), i0.ɵɵdirectiveInject(i3.Location), i0.ɵɵdirectiveInject('estatisticas-veiculo-service'), i0.ɵɵdirectiveInject('modal-personalizada-service')); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormularioAutoVeiculoComponent, selectors: [["formulario-auto-veiculo"]], inputs: { recalculo: "recalculo", listaCampo: "listaCampo" }, features: [i0.ɵɵProvidersFeature([{ provide: MAT_SELECT_CONFIG, useValue: { overlayPanelClass: 'selects-formulario-auto-veiculo' } }])], decls: 106, vars: 83, consts: [["auto", "matAutocomplete"], ["gasInstalValor", "matAutocomplete"], [3, "ngClass", "formGroup"], [3, "hidden", "ngClass"], ["matInput", "", "name", "placa", "formControlName", "placa", "placeholder", "Ex. ABC-0A00", "autocomplete", "off", 1, "text-uppercase", 3, "change", "mask", "dropSpecialCharacters"], ["class", "spinnerLoading", "mat-spinner", "", "diameter", "20", 4, "ngIf"], [4, "ngIf"], ["matInput", "", "name", "chassi", "formControlName", "chassi", "autocomplete", "off", 1, "text-uppercase", 3, "change", "mask", "dropSpecialCharacters"], ["matInput", "", "name", "anoFab", "formControlName", "anoFab", "autocomplete", "off", 3, "blur", "mask"], ["name", "anoMod", "formControlName", "anoMod", 3, "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["name", "zeroKm", "formControlName", "zeroKm", 3, "selectionChange"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], ["matInput", "", "name", "fipe", "formControlName", "fipe", "placeholder", "Ex. 000000-0", "autocomplete", "off", 3, "blur", "mask", "dropSpecialCharacters"], ["matInput", "", "formControlName", "modelo", "name", "modelo", "tab-directive", "", "type", "text", "placeholder", "Ex.: Gol City (Trend) 1.0 Mi Total Flex 8V 2p", 3, "matAutocomplete"], ["autoActiveFirstOption", "true", 3, "optionSelected", "displayWith"], ["matTooltipPosition", "right", 3, "value", "matTooltip", 4, "ngFor", "ngForOf"], ["class", "primeiro-icone", 3, "svgIcon", "matTooltip", "click", 4, "ngIf"], ["matTooltip", "Limpar ve\u00EDculo", "svgIcon", "delete", 1, "campo-icone", 3, "click"], ["matInput", "", "name", "valReferenciado", "formControlName", "valReferenciado", "autocomplete", "off"], ["name", "combustivel", "panelClass", "combustivel", "formControlName", "combustivel"], ["matInput", "", "name", "nrEixos", "formControlName", "nrEixos", 3, "mask", "dropSpecialCharacters"], ["name", "isPCD", "formControlName", "isPCD", 3, "selectionChange"], ["name", "isencaoFiscal", "formControlName", "isencaoFiscal"], ["name", "rastreador", "formControlName", "rastreador", "panelClass", "rastreador"], ["name", "dispAntiFurto", "formControlName", "dispAntiFurto", "panelClass", "dispAntiFurto"], ["name", "blindado", "formControlName", "blindado"], ["name", "kitGas", "formControlName", "kitGas", 3, "selectionChange"], ["type", "text", "matInput", "", "name", "gasInstalValor", "formControlName", "gasInstalValor", "currencyMask", "", 3, "keyup", "focus", "blur", "matAutocomplete", "placeholder", "options"], ["matSuffix", "", "class", "segundo-icone", "svgIcon", "delete", "matTooltip", "Limpar campo", 3, "mouseenter", "mouseleave", "click", 4, "ngIf"], ["autoActiveFirstOption", "", 3, "optionSelected"], ["appMouseHover", "", 3, "value", "mouseEnter", "mouseLeave", 4, "ngFor", "ngForOf"], ["name", "alienado", "formControlName", "alienado"], ["tabindex", "-1", "id", "submitFormVeiculo", 2, "opacity", "0", "position", "absolute", "z-index", "-1000"], ["mat-spinner", "", "diameter", "20", 1, "spinnerLoading"], [3, "value"], [3, "value", "disabled"], ["matTooltipPosition", "right", 3, "value", "matTooltip"], [1, "primeiro-icone", 3, "click", "svgIcon", "matTooltip"], ["matSuffix", "", "svgIcon", "delete", "matTooltip", "Limpar campo", 1, "segundo-icone", 3, "mouseenter", "mouseleave", "click"], ["appMouseHover", "", 3, "mouseEnter", "mouseLeave", "value"]], template: function FormularioAutoVeiculoComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 2)(1, "mat-form-field", 3)(2, "mat-label");
            i0.ɵɵtext(3, "Placa");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "input", 4);
            i0.ɵɵlistener("change", function FormularioAutoVeiculoComponent_Template_input_change_4_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaInfosVeiculo("placa")); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FormularioAutoVeiculoComponent_mat_spinner_5_Template, 1, 1, "mat-spinner", 5)(6, FormularioAutoVeiculoComponent_mat_error_6_Template, 2, 0, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "mat-form-field", 3)(8, "mat-label");
            i0.ɵɵtext(9, "Chassi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "input", 7);
            i0.ɵɵlistener("change", function FormularioAutoVeiculoComponent_Template_input_change_10_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaInfosVeiculo("chassi")); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, FormularioAutoVeiculoComponent_mat_spinner_11_Template, 1, 1, "mat-spinner", 5)(12, FormularioAutoVeiculoComponent_mat_error_12_Template, 2, 0, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "mat-form-field", 3)(14, "mat-label");
            i0.ɵɵtext(15, "Ano Fabrica\u00E7\u00E3o");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "input", 8);
            i0.ɵɵlistener("blur", function FormularioAutoVeiculoComponent_Template_input_blur_16_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.habilitaAnoModelo()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(17, FormularioAutoVeiculoComponent_mat_error_17_Template, 2, 0, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "mat-form-field", 3)(19, "mat-label");
            i0.ɵɵtext(20, "Ano Modelo");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "mat-select", 9);
            i0.ɵɵlistener("selectionChange", function FormularioAutoVeiculoComponent_Template_mat_select_selectionChange_21_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaPelaFipe()); });
            i0.ɵɵtemplate(22, FormularioAutoVeiculoComponent_mat_option_22_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(23, "mat-form-field", 3)(24, "mat-label");
            i0.ɵɵtext(25, "Zero KM");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(26, "mat-select", 11);
            i0.ɵɵlistener("selectionChange", function FormularioAutoVeiculoComponent_Template_mat_select_selectionChange_26_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaPelaFipe()); });
            i0.ɵɵtemplate(27, FormularioAutoVeiculoComponent_mat_option_27_Template, 2, 4, "mat-option", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "mat-form-field", 3)(29, "mat-label");
            i0.ɵɵtext(30, "FIPE");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "input", 13);
            i0.ɵɵlistener("blur", function FormularioAutoVeiculoComponent_Template_input_blur_31_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaPelaFipe()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(32, FormularioAutoVeiculoComponent_mat_spinner_32_Template, 1, 1, "mat-spinner", 5)(33, FormularioAutoVeiculoComponent_mat_error_33_Template, 2, 0, "mat-error", 6)(34, FormularioAutoVeiculoComponent_mat_error_34_Template, 2, 0, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(35, "mat-form-field", 3)(36, "mat-label");
            i0.ɵɵtext(37, "Modelo");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(38, "input", 14);
            i0.ɵɵelementStart(39, "mat-autocomplete", 15, 0);
            i0.ɵɵlistener("optionSelected", function FormularioAutoVeiculoComponent_Template_mat_autocomplete_optionSelected_39_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.atualizaInfosVeiculo($event.option.value)); });
            i0.ɵɵtemplate(41, FormularioAutoVeiculoComponent_mat_option_41_Template, 2, 4, "mat-option", 16);
            i0.ɵɵpipe(42, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(43, FormularioAutoVeiculoComponent_mat_icon_43_Template, 1, 2, "mat-icon", 17);
            i0.ɵɵelementStart(44, "mat-icon", 18);
            i0.ɵɵlistener("click", function FormularioAutoVeiculoComponent_Template_mat_icon_click_44_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.limparInfosVeiculo()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(45, FormularioAutoVeiculoComponent_mat_error_45_Template, 2, 0, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(46, "mat-form-field", 3)(47, "mat-label");
            i0.ɵɵtext(48, "Valor Referenciado (R$)");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(49, "input", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "mat-form-field", 3)(51, "mat-label");
            i0.ɵɵtext(52, "Combust\u00EDvel");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(53, "mat-select", 20);
            i0.ɵɵtemplate(54, FormularioAutoVeiculoComponent_mat_option_54_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(55, FormularioAutoVeiculoComponent_mat_error_55_Template, 2, 0, "mat-error", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(56, "mat-form-field", 3)(57, "mat-label");
            i0.ɵɵtext(58, "Eixos");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(59, "input", 21);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(60, FormularioAutoVeiculoComponent_h3_60_Template, 2, 0, "h3", 6);
            i0.ɵɵelementStart(61, "mat-form-field", 3)(62, "mat-label");
            i0.ɵɵtext(63, "PCD");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(64, "mat-select", 22);
            i0.ɵɵlistener("selectionChange", function FormularioAutoVeiculoComponent_Template_mat_select_selectionChange_64_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.verificaPCD($event.value)); });
            i0.ɵɵtemplate(65, FormularioAutoVeiculoComponent_mat_option_65_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(66, "mat-form-field", 3)(67, "mat-label");
            i0.ɵɵtext(68, "Isen\u00E7\u00E3o Fiscal");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(69, "mat-select", 23);
            i0.ɵɵtemplate(70, FormularioAutoVeiculoComponent_mat_option_70_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(71, "mat-form-field", 3)(72, "mat-label");
            i0.ɵɵtext(73, "Rastreador");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(74, "mat-select", 24);
            i0.ɵɵtemplate(75, FormularioAutoVeiculoComponent_mat_option_75_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(76, "mat-form-field", 3)(77, "mat-label");
            i0.ɵɵtext(78, "Dispositivo Anti-furto");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(79, "mat-select", 25);
            i0.ɵɵtemplate(80, FormularioAutoVeiculoComponent_mat_option_80_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(81, "mat-form-field", 3)(82, "mat-label");
            i0.ɵɵtext(83, "Blindado");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(84, "mat-select", 26);
            i0.ɵɵtemplate(85, FormularioAutoVeiculoComponent_mat_option_85_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(86, "mat-form-field", 3)(87, "mat-label");
            i0.ɵɵtext(88, "Kit G\u00E1s");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(89, "mat-select", 27);
            i0.ɵɵlistener("selectionChange", function FormularioAutoVeiculoComponent_Template_mat_select_selectionChange_89_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.habilitaKitGasValor($event.value)); });
            i0.ɵɵtemplate(90, FormularioAutoVeiculoComponent_mat_option_90_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(91, "mat-form-field", 3)(92, "mat-label");
            i0.ɵɵtext(93, "Valor kit G\u00E1s");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(94, "input", 28);
            i0.ɵɵlistener("keyup", function FormularioAutoVeiculoComponent_Template_input_keyup_94_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.resetaOuMantemValor(ctx.formAutoVeiculo.controls["gasInstalValor"])); })("focus", function FormularioAutoVeiculoComponent_Template_input_focus_94_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFocus("gasInstalValor")); })("blur", function FormularioAutoVeiculoComponent_Template_input_blur_94_listener() { i0.ɵɵrestoreView(_r1); ctx.arredonda(ctx.formAutoVeiculo.controls["gasInstalValor"]); return i0.ɵɵresetView(ctx.controlaFocus("gasInstalValor")); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(95, FormularioAutoVeiculoComponent_mat_icon_95_Template, 1, 0, "mat-icon", 29);
            i0.ɵɵelementStart(96, "mat-autocomplete", 30, 1);
            i0.ɵɵlistener("optionSelected", function FormularioAutoVeiculoComponent_Template_mat_autocomplete_optionSelected_96_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setaValue(ctx.formAutoVeiculo.controls["gasInstalValor"], $event.option.value)); });
            i0.ɵɵtemplate(98, FormularioAutoVeiculoComponent_mat_option_98_Template, 3, 5, "mat-option", 31);
            i0.ɵɵpipe(99, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(100, "mat-form-field", 3)(101, "mat-label");
            i0.ɵɵtext(102, "Alienado");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(103, "mat-select", 32);
            i0.ɵɵtemplate(104, FormularioAutoVeiculoComponent_mat_option_104_Template, 2, 3, "mat-option", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(105, "button", 33);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const auto_r18 = i0.ɵɵreference(40);
            const gasInstalValor_r19 = i0.ɵɵreference(97);
            i0.ɵɵproperty("ngClass", !ctx.isRecalculo ? "col-12 form-auto-step" : "col-12 form-auto-step recalculo")("formGroup", ctx.formAutoVeiculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_PLACA))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.PLACA)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buscaControler.placa.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("placa").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CHASSI))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-4" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.CHASSI)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buscaControler.chassi.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("chassi").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_ANOFABRICACAO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.ANO);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("anoFab").hasError("intervalAnos"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_ANOMODELO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.anoMod);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_ZEROKM))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.zeroKm);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_FIPE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.FIPE)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buscaControler.fipe.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("fipe").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("fipe").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_DESCRICAO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-4" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matAutocomplete", auto_r18);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayWith", ctx.displayFnWrapper());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(42, 79, ctx.modelosFiltrados));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.value.tipoVeic != "m" && !ctx.isRecalculo);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("modelo").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_VALREFERENCIADO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_COMBUSTIVEL))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.combustivel);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoVeiculo.get("combustivel").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.formAutoVeiculo.value.tipoVeic != "c" || ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_EIXOS))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-1" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.DOUBLE)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.formAutoVeiculo.value.tipoVeic != "v" || ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_PCD))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.formAutoVeiculo.value.tipoVeic != "v" || ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_TIPOISENCAO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.isencaoFiscal);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.rastreador);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_ANTIFURTO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.dispAntiFurto);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.formAutoVeiculo.value.tipoVeic == "m" || ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.formAutoVeiculo.value.tipoVeic != "v" || ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("mat-focused", ctx.fieldFocusStates["gasInstalValor"]);
            i0.ɵɵproperty("hidden", ctx.formAutoVeiculo.value.tipoVeic != "v" || ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_GASINSTALVALOR))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matAutocomplete", gasInstalValor_r19)("placeholder", "R$ 0,00")("options", ctx.currencyOptions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.fieldFocusStates["gasInstalValor"]);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(99, 81, ctx.filteredOptions.gasInstalValor));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-2" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i4$3.MatAutocomplete, i4$1.MatOption, i4$3.MatAutocompleteTrigger, i5.MatFormField, i5.MatLabel, i5.MatError, i5.MatSuffix, i6.MatIcon, i7.MatInput, i8.MatProgressSpinner, i9.MatSelect, i10.MatTooltip, i11.NgxMaskDirective, i1$2.FormGroupDirective, i1$2.FormControlName, i13.NgxCurrencyDirective, i3.AsyncPipe, i3.CurrencyPipe], styles: [".form-auto-step[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:var(--color-tertiary-first);font-weight:500;text-transform:uppercase;font-size:15px;letter-spacing:.5px;padding:0 7px;margin:10px 0 16px}.form-auto-step[_ngcontent-%COMP%]   .campo-icone[_ngcontent-%COMP%]{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step[_ngcontent-%COMP%]   .primeiro-icone[_ngcontent-%COMP%]{position:absolute;right:25px;top:10px;cursor:pointer;color:#d8d1d1!important}.form-auto-step[_ngcontent-%COMP%]   .segundo-icone[_ngcontent-%COMP%]{cursor:pointer;color:var(--color-icon);width:17px;padding-right:0}.form-auto-step[_ngcontent-%COMP%]   .spinnerLoading[_ngcontent-%COMP%]{position:absolute;right:0;top:10px}.form-auto-step[_ngcontent-%COMP%]:not(.recalculo){padding:0 15px}.recalculo[_ngcontent-%COMP%]{padding:0}"], data: { animation: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])] } });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormularioAutoVeiculoComponent, [{
        type: Component,
        args: [{ selector: 'formulario-auto-veiculo', animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])], providers: [{ provide: MAT_SELECT_CONFIG, useValue: { overlayPanelClass: 'selects-formulario-auto-veiculo' } }], template: "<form [ngClass]=\"!isRecalculo ? 'col-12 form-auto-step' : 'col-12 form-auto-step recalculo'\" [formGroup]=\"formAutoVeiculo\">\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_PLACA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Placa</mat-label>\r\n    <input matInput class=\"text-uppercase\" name=\"placa\" formControlName=\"placa\" placeholder=\"Ex. ABC-0A00\"\r\n      [mask]=\"masks.PLACA\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaInfosVeiculo('placa')\">\r\n    <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.placa.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('placa').hasError('pattern')\">Por favor, insira uma placa v\u00E1lida.</mat-error>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CHASSI\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-4' : 'col-12'\">\r\n    <mat-label>Chassi</mat-label>\r\n    <input matInput class=\"text-uppercase\" name=\"chassi\" formControlName=\"chassi\" [mask]=\"masks.CHASSI\"\r\n      [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaInfosVeiculo('chassi')\">\r\n    <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.chassi.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('chassi').hasError('pattern')\">Por favor, insira um chassi v\u00E1lido.</mat-error>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_ANOFABRICACAO\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Ano Fabrica\u00E7\u00E3o</mat-label>\r\n    <input matInput name=\"anoFab\" formControlName=\"anoFab\" [mask]=\"masks.ANO\" autocomplete=\"off\" (blur)=\"habilitaAnoModelo()\"/>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('anoFab').hasError('intervalAnos')\">Ano de fabrica\u00E7\u00E3o n\u00E3o permitido.</mat-error>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_ANOMODELO\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Ano Modelo</mat-label>\r\n    <mat-select name=\"anoMod\" formControlName=\"anoMod\" (selectionChange)=\"buscaPelaFipe()\">\r\n      <mat-option *ngFor=\"let a of selects.anoMod\" [value]=\"a.value\" [attr.custom-reflect-value]=\"a.value\">\r\n        {{ a.viewValue}}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_ZEROKM\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Zero KM</mat-label>\r\n    <mat-select name=\"zeroKm\" formControlName=\"zeroKm\" (selectionChange)=\"buscaPelaFipe()\">\r\n      <mat-option *ngFor=\"let k of selects.zeroKm\" [value]=\"k.value\" [attr.custom-reflect-value]=\"k.value\" [disabled]=\"k.disabled\">\r\n        {{ k.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_FIPE\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>FIPE</mat-label>\r\n    <input matInput name=\"fipe\" formControlName=\"fipe\" placeholder=\"Ex. 000000-0\" [mask]=\"masks.FIPE\"\r\n      [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (blur)=\"buscaPelaFipe()\"/>\r\n    <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.fipe.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('fipe').hasError('required')\">Por favor, digite a FIPE.</mat-error>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('fipe').hasError('pattern')\">Por favor, digite uma FIPE v\u00E1lida.</mat-error>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_DESCRICAO\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-4' : 'col-12'\">\r\n    <mat-label>Modelo</mat-label>\r\n    <input matInput formControlName=\"modelo\" name=\"modelo\" tab-directive type=\"text\"\r\n      placeholder=\"Ex.: Gol City (Trend) 1.0 Mi Total Flex 8V 2p\" [matAutocomplete]=\"auto\"/>\r\n    <mat-autocomplete [displayWith]=\"displayFnWrapper()\" #auto=\"matAutocomplete\" autoActiveFirstOption=\"true\" (optionSelected)=\"atualizaInfosVeiculo($event.option.value)\">\r\n        <mat-option *ngFor=\"let opt of modelosFiltrados | async\" [value]=\"opt\" [attr.custom-reflect-value]=\"opt\" [matTooltip]=\"opt.modelo\" matTooltipPosition=\"right\">\r\n          {{ opt.modelo }}\r\n        </mat-option>\r\n    </mat-autocomplete>\r\n    <mat-icon class=\"primeiro-icone\" *ngIf=\"formAutoVeiculo.value.tipoVeic != 'm' && !isRecalculo\"\r\n    [svgIcon]=\"formAutoVeiculo.value.tipoVeic == 'c' ? 'car-side' : 'truck'\" (click)=\"enquadrarVeiculo(formAutoVeiculo.value.tipoVeic)\"\r\n    [matTooltip]=\"formAutoVeiculo.value.tipoVeic == 'v' ? 'Enquadrar como ve\u00EDculo utilit\u00E1rio de pequeno porte ou caminh\u00E3o' : 'Enquadrar ve\u00EDculo como autom\u00F3vel de passeio'\"></mat-icon>\r\n    <mat-icon matTooltip=\"Limpar ve\u00EDculo\" class=\"campo-icone\" svgIcon=\"delete\" (click)=\"limparInfosVeiculo()\"></mat-icon>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('modelo').hasError('required')\">Por favor, digite o modelo.</mat-error>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_VALREFERENCIADO\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Valor Referenciado (R$)</mat-label>\r\n    <input matInput name=\"valReferenciado\" formControlName=\"valReferenciado\" autocomplete=\"off\"/>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_COMBUSTIVEL\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Combust\u00EDvel</mat-label>\r\n    <mat-select name=\"combustivel\" panelClass=\"combustivel\" formControlName=\"combustivel\">\r\n      <mat-option *ngFor=\"let c of selects.combustivel\" [value]=\"c.value\" [attr.custom-reflect-value]=\"c.value\">\r\n        {{ c.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n    <mat-error *ngIf=\"formAutoVeiculo.get('combustivel').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"(formAutoVeiculo.value.tipoVeic != 'c') || (isRecalculo && !habCampos?.AUTOMOVEIS_EIXOS)\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-1' : 'col-12'\">\r\n    <mat-label>Eixos</mat-label>\r\n    <input matInput name=\"nrEixos\" formControlName=\"nrEixos\" [mask]=\"masks.DOUBLE\" [dropSpecialCharacters]=\"false\"/>\r\n  </mat-form-field>\r\n\r\n  <h3 *ngIf=\"!isRecalculo\">Informa\u00E7\u00F5es complementares</h3>\r\n\r\n  <mat-form-field [hidden]=\"formAutoVeiculo.value.tipoVeic != 'v' || (isRecalculo && !habCampos?.AUTOMOVEIS_PCD)\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>PCD</mat-label>\r\n    <mat-select name=\"isPCD\" formControlName=\"isPCD\" (selectionChange)=\"verificaPCD($event.value)\">\r\n      <mat-option *ngFor=\"let p of selects.simOuNao\" [value]=\"p.value\" [attr.custom-reflect-value]=\"p.value\">\r\n        {{ p.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"(formAutoVeiculo.value.tipoVeic != 'v') || (isRecalculo && !habCampos?.AUTOMOVEIS_TIPOISENCAO)\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Isen\u00E7\u00E3o Fiscal</mat-label>\r\n    <mat-select name=\"isencaoFiscal\" formControlName=\"isencaoFiscal\">\r\n      <mat-option *ngFor=\"let i of selects.isencaoFiscal\" [value]=\"i.value\" [attr.custom-reflect-value]=\"i.value\">\r\n        {{ i.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Rastreador</mat-label>\r\n    <mat-select name=\"rastreador\" formControlName=\"rastreador\" panelClass=\"rastreador\">\r\n      <mat-option *ngFor=\"let d of selects.rastreador\" [value]=\"d.value\" [attr.custom-reflect-value]=\"d.value\">\r\n        {{ d.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_ANTIFURTO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Dispositivo Anti-furto</mat-label>\r\n    <mat-select name=\"dispAntiFurto\" formControlName=\"dispAntiFurto\" panelClass=\"dispAntiFurto\">\r\n      <mat-option *ngFor=\"let d of selects.dispAntiFurto\" [value]=\"d.value\" [attr.custom-reflect-value]=\"d.value\">\r\n        {{ d.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"formAutoVeiculo.value.tipoVeic == 'm' || isRecalculo\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Blindado</mat-label>\r\n    <mat-select name=\"blindado\" formControlName=\"blindado\">\r\n      <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n        {{ v.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"formAutoVeiculo.value.tipoVeic != 'v' || isRecalculo\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Kit G\u00E1s</mat-label>\r\n    <mat-select name=\"kitGas\" formControlName=\"kitGas\" (selectionChange)=\"habilitaKitGasValor($event.value)\">\r\n      <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n        {{ v.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"(formAutoVeiculo.value.tipoVeic != 'v') || (isRecalculo && !habCampos?.AUTOMOVEIS_GASINSTALVALOR)\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\" [class.mat-focused]=\"fieldFocusStates['gasInstalValor']\">\r\n    <mat-label>Valor kit G\u00E1s</mat-label>\r\n    <input type=\"text\" matInput name=\"gasInstalValor\" formControlName=\"gasInstalValor\" [matAutocomplete]=\"gasInstalValor\"\r\n        [placeholder]=\"'R$ 0,00'\" currencyMask [options]=\"currencyOptions\"\r\n        (keyup)=\"resetaOuMantemValor(formAutoVeiculo.controls['gasInstalValor'])\" (focus)=\"onFocus('gasInstalValor')\"\r\n        (blur)=\"arredonda(formAutoVeiculo.controls['gasInstalValor']);controlaFocus('gasInstalValor')\">\r\n    <mat-icon matSuffix *ngIf=\"fieldFocusStates['gasInstalValor']\" class=\"segundo-icone\" (mouseenter)=\"focus = true\"\r\n        (mouseleave)=\"focus = false\" svgIcon=\"delete\" matTooltip=\"Limpar campo\"\r\n        (click)=\"setaValue(formAutoVeiculo.controls['gasInstalValor'], 0)\">\r\n    </mat-icon>\r\n    <mat-autocomplete autoActiveFirstOption #gasInstalValor=\"matAutocomplete\"\r\n        (optionSelected)=\"setaValue(formAutoVeiculo.controls['gasInstalValor'], $event.option.value)\">\r\n        <mat-option *ngFor=\"let v of filteredOptions.gasInstalValor | async\" [value]=\"v.value | currency : 'BRL'\"\r\n            appMouseHover (mouseEnter)=\"isMouseOverSelect = true\" (mouseLeave)=\"isMouseOverSelect = false\">\r\n            {{ v.viewValue }}\r\n        </mat-option>\r\n    </mat-autocomplete>\r\n  </mat-form-field>\r\n\r\n  <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-2' : 'col-12'\">\r\n    <mat-label>Alienado</mat-label>\r\n    <mat-select name=\"alienado\" formControlName=\"alienado\">\r\n      <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n        {{ v.viewValue }}\r\n      </mat-option>\r\n    </mat-select>\r\n  </mat-form-field>\r\n  <button tabindex=\"-1\" id=\"submitFormVeiculo\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>", styles: [".form-auto-step h3{color:var(--color-tertiary-first);font-weight:500;text-transform:uppercase;font-size:15px;letter-spacing:.5px;padding:0 7px;margin:10px 0 16px}.form-auto-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step .primeiro-icone{position:absolute;right:25px;top:10px;cursor:pointer;color:#d8d1d1!important}.form-auto-step .segundo-icone{cursor:pointer;color:var(--color-icon);width:17px;padding-right:0}.form-auto-step .spinnerLoading{position:absolute;right:0;top:10px}.form-auto-step:not(.recalculo){padding:0 15px}.recalculo{padding:0}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['api']
            }] }, { type: i1$2.FormBuilder }, { type: FormsService }, { type: i3.Location }, { type: undefined, decorators: [{
                type: Inject,
                args: ['estatisticas-veiculo-service']
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: ['modal-personalizada-service']
            }] }], { recalculo: [{
            type: Input
        }], listaCampo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormularioAutoVeiculoComponent, { className: "FormularioAutoVeiculoComponent", filePath: "components\\formulario-auto-veiculo\\formulario-auto-veiculo.component.ts", lineNumber: 18 }); })();

function FormularioAutoPerfilCarroComponent_mat_option_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", r_r2.value)("disabled", r_r2.disabled);
    i0.ɵɵattribute("custom-reflect-value", r_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", r_r2.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Verifique os valores fornecidos.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_spinner_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 29);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoPerfilCarroComponent_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "N\u00FAmero do documento inv\u00E1lido.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_error_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira nome e sobrenome");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_error_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira nome e sobrenome");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_error_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_error_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "O condutor deve ser maior de idade.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_error_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Verifique a idade do condutor e/ou do segurado.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r3.value);
    i0.ɵɵattribute("custom-reflect-value", s_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", s_r3.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", e_r4.value);
    i0.ɵɵattribute("custom-reflect-value", e_r4.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", e_r4.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r5.value);
    i0.ɵɵattribute("custom-reflect-value", t_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r5.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r6 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r6.value);
    i0.ɵɵattribute("custom-reflect-value", t_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r6.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_spinner_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 29);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoPerfilCarroComponent_mat_icon_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 31);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r6.buscaControler.endereco == null ? null : ctx_r6.buscaControler.endereco.tooltip);
} }
function FormularioAutoPerfilCarroComponent_mat_icon_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 32);
} }
function FormularioAutoPerfilCarroComponent_mat_error_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um cep v\u00E1lido");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_error_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, digite um CEP");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_64_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const k_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", k_r8.value);
    i0.ɵɵattribute("custom-reflect-value", k_r8.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", k_r8.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_65_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_70_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const j_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", j_r9.value);
    i0.ɵɵattribute("custom-reflect-value", j_r9.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", j_r9.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_71_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", i_r10.value);
    i0.ɵɵattribute("custom-reflect-value", i_r10.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r10.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_82_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r11 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r11.value);
    i0.ɵɵattribute("custom-reflect-value", s_r11.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", s_r11.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_83_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_88_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r12.value);
    i0.ɵɵattribute("custom-reflect-value", t_r12.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r12.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_89_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_94_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const l_r13 = ctx.$implicit;
    i0.ɵɵproperty("value", l_r13.value);
    i0.ɵɵattribute("custom-reflect-value", l_r13.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", l_r13.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_95_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_100_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r14 = ctx.$implicit;
    i0.ɵɵproperty("value", i_r14.value);
    i0.ɵɵattribute("custom-reflect-value", i_r14.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r14.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_101_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_option_106_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", i_r15.value);
    i0.ɵɵattribute("custom-reflect-value", i_r15.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r15.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_error_107_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_h3_108_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1, "Informa\u00E7\u00F5es complementares");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCarroComponent_mat_form_field_109_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r16 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r16.value);
    i0.ɵɵattribute("custom-reflect-value", v_r16.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r16.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_form_field_109_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 2)(1, "mat-label");
    i0.ɵɵtext(2, "Associado a Moto Clube");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 33);
    i0.ɵɵtemplate(4, FormularioAutoPerfilCarroComponent_mat_form_field_109_mat_option_4_Template, 2, 3, "mat-option", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r6.isRecalculo)("ngClass", !ctx_r6.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r6.selects.simOuNao);
} }
function FormularioAutoPerfilCarroComponent_mat_form_field_110_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r17 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r17.value);
    i0.ɵɵattribute("custom-reflect-value", v_r17.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r17.viewValue, " ");
} }
function FormularioAutoPerfilCarroComponent_mat_form_field_110_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 2)(1, "mat-label");
    i0.ɵɵtext(2, "Per\u00EDodo de Uso");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 34);
    i0.ɵɵtemplate(4, FormularioAutoPerfilCarroComponent_mat_form_field_110_mat_option_4_Template, 2, 3, "mat-option", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r6.isRecalculo)("ngClass", !ctx_r6.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r6.selects.periodoUso);
} }
class FormularioAutoPerfilCarroComponent {
    api;
    formBuilder;
    formsService;
    buscaControler = ConstantFormAuto.controlerBusca;
    masks = ConstantFormAuto.maskValidate;
    patterns = ConstantFormAuto.patternValidade;
    selects = ConstantFormAuto.objSelects;
    subscriptions = new Subscription();
    carregouInfosDraft = false;
    formAutoPerfilCarro;
    estadoCivilSegurado;
    segurado;
    tipoPessoa;
    tipoVeiculo;
    tiposDeVeiculo = ConstantFormAuto.tipoVeiculo;
    //recalculo
    isRecalculo;
    habCampos = {};
    set recalculo(value) {
        this.isRecalculo = value;
    }
    set listaCampo(value) {
        this.habCampos = value;
    }
    constructor(api, formBuilder, formsService) {
        this.api = api;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.formAutoPerfilCarro = this.formBuilder.group({
            cpfCnpj: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CPF), FormsService.formBuilderCpfCnpj()]),
            nome: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.patterns.NOME)]),
            dataNasc: new FormControl('', [Validators.required, Validators.pattern(this.patterns.DATA), FormsService.validarDataNascimento(), FormsService.isMaiorIdade()]),
            sexo: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.sexo)]),
            estadoCivil: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.estadoCivil)]),
            tempoHabilitacao: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.tempoHabilitacao)]),
            dataPrimHabil: new FormControl('', []),
            relacaoSegurado: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.relacaoSegurado)]),
            tpUso: new FormControl(1, [Validators.required, FormsService.inArrayValidator(this.selects.tpUso(this.tipoVeiculo))]),
            cepPernoite: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CEP)]),
            cepCirculacao: new FormControl('', []),
            kmMensal: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.kmMensal)]),
            jovemCondutor: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.simOuNao)]),
            idadeJovem: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.idadeJovem)]),
            jovemSexo: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.jovemSexo)]),
            tipoResidencia: new FormControl(1, [Validators.required, FormsService.inArrayValidator(this.selects.tipoResidencia)]),
            garagemResidencia: new FormControl("2", [Validators.required, FormsService.inArrayValidator(this.selects.garagemResidencia)]),
            garagemTrabalho: new FormControl("0", [Validators.required, FormsService.inArrayValidator(this.selects.garagemTrabalho)]),
            garagemEstudo: new FormControl("0", [Validators.required, FormsService.inArrayValidator(this.selects.garagemEstudo)]),
            associado: new FormControl(false, [Validators.required, FormsService.inArrayValidator(this.selects.simOuNao)]),
            periodoUso: new FormControl("0", [Validators.required, FormsService.inArrayValidator(this.selects.periodoUso)]),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
        if (!this.isRecalculo)
            this.formsService.desabilitaCampos(ConstantFormAuto.camposCondutorDesabilitadosDefault, this.formAutoPerfilCarro);
    }
    ngOnDestroy() {
        this.formsService.salvarDraftFinal();
        this.subscriptions.unsubscribe();
    }
    async atualizaCamposPelaRelacaoSegurado(relacaoSegurado) {
        if (relacaoSegurado == 'Próprio') {
            ConstantFormAuto.camposAtualizaCondutor.demaisRelacoes.forEach(campo => {
                if (this.formAutoPerfilCarro.controls[campo]) {
                    this.formAutoPerfilCarro.controls[campo].setValue(this.segurado ? this.segurado[campo] : null);
                    this.formAutoPerfilCarro.controls[campo].disable();
                }
            });
            FormsService.setaUltimaBusca(this.buscaControler.condutor, undefined);
        }
        else if (relacaoSegurado == 'Sem perfil') {
            this.formsService.desabilitaResetaCampos(ConstantFormAuto.camposAtualizaCondutor.semPerfil, this.formAutoPerfilCarro);
        }
        else {
            let relacaoEraOProprioSegurado = this.formAutoPerfilCarro.controls.cpfCnpj.value == this.segurado?.cpfCnpj;
            ConstantFormAuto.camposAtualizaCondutor.demaisRelacoes.forEach(campo => {
                if (this.formAutoPerfilCarro.controls[campo]) {
                    relacaoEraOProprioSegurado && this.formAutoPerfilCarro.controls[campo].reset();
                    this.formAutoPerfilCarro.controls[campo].enable();
                }
            });
            this.formAutoPerfilCarro.controls['tipoResidencia'].enable();
            if (relacaoSegurado == 'Cônjuge' && this.segurado?.estadoCivil) {
                this.formAutoPerfilCarro.controls.estadoCivil.setValue(this.segurado.estadoCivil);
                this.formAutoPerfilCarro.controls.estadoCivil.disable();
            }
        }
        this.geraOpcoesTempoHabilitacao(this.formAutoPerfilCarro.controls.dataNasc.value);
    }
    atualizaCepPernoite() {
        if (this.segurado?.cep && !this.buscaControler.endereco?.buscouManualmente) {
            let cepSeguradoIgual = this.formsService.limparString(this.segurado.cep) === this.formAutoPerfilCarro.controls.cepPernoite.value;
            if (cepSeguradoIgual || !this.carregouInfosDraft)
                this.formAutoPerfilCarro.controls.cepPernoite.setValue(this.segurado.cep);
        }
    }
    atualizaTempoHabilitacao() {
        let dataNascimentoValida = this.formAutoPerfilCarro.controls.dataNasc.valid;
        if (dataNascimentoValida)
            this.geraOpcoesTempoHabilitacao(this.formAutoPerfilCarro.controls.dataNasc.value);
        else
            this.geraOpcoesTempoHabilitacao(false);
    }
    atualizaOpcoesRelacaoSegurado(mudanca) {
        let relacaoSelecionada = this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formAutoPerfilCarro.controls.relacaoSegurado.value);
        if (mudanca == 'estadoCivil') {
            let podeTerConjuge = this.formsService.podeTerConjuge(this.estadoCivilSegurado);
            this.selects.relacaoSegurado.find(opt => opt.viewValue == 'Cônjuge').disabled = podeTerConjuge ? false : true;
            if (relacaoSelecionada == 'Cônjuge' && this.estadoCivilSegurado && !podeTerConjuge) {
                this.formAutoPerfilCarro.controls.relacaoSegurado.reset();
                this.formAutoPerfilCarro.controls.estadoCivil.reset();
                this.formAutoPerfilCarro.controls.estadoCivil.enable();
            }
        }
        else if (mudanca == 'tipoPessoa' && this.tipoPessoa) {
            this.selects.relacaoSegurado.forEach(opt => { ConstantFormAuto.desabilitaRelacaoSegurado[this.tipoPessoa].find(a => a == opt.viewValue) ? opt.disabled = true : opt.disabled = false; });
            this.atualizaOpcoesRelacaoSegurado('estadoCivil');
            let relacaoFoiDesabilitada = !!ConstantFormAuto.desabilitaRelacaoSegurado[this.tipoPessoa].find(opt => opt == relacaoSelecionada);
            if (relacaoFoiDesabilitada)
                this.formAutoPerfilCarro.controls.relacaoSegurado.reset();
        }
    }
    async buscaCepPernoite() {
        if (!this.buscaControler.endereco?.buscouManualmente)
            this.buscaControler = ConstantFormAuto.controlerBusca;
        let cepValido = this.formAutoPerfilCarro.controls.cepPernoite.valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler.endereco.ultimaBusca != this.formsService.limparString(this.formAutoPerfilCarro.controls.cepPernoite.value);
        if (cepValido && buscaAnteriorDiferenteAtual) {
            this.buscaControler.endereco.buscando = true;
            let infosEndereco = await this.api.getEndereco(this.formsService.limparString(this.formAutoPerfilCarro.controls.cepPernoite.value));
            if (infosEndereco && infosEndereco.length > 0 && infosEndereco[0]) {
                this.formAutoPerfilCarro.controls.cepPernoite.setValue(FormsService.formatField('cep', infosEndereco[0]['cep']));
                this.buscaControler.endereco.cidade = infosEndereco[0]['cidade'];
                this.buscaControler.endereco.status = 'ENCONTROU';
                this.buscaControler.endereco.tooltip = `CEP válido: ${FormsService.joinValues(', ', [infosEndereco[0]['logradouro'], infosEndereco[0]['cidade']])}`;
            }
            else
                this.buscaControler.endereco.status = 'NAO-ENCONTROU';
            this.buscaControler.endereco.ultimaBusca = this.formsService.limparString(this.formAutoPerfilCarro.controls.cepPernoite.value);
            this.buscaControler.endereco.buscando = false;
            this.buscaControler.endereco.buscouManualmente = true;
        }
    }
    async buscaInfosCondutor() {
        let cpfValido = this.formAutoPerfilCarro.controls.cpfCnpj.valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler.condutor.ultimaBusca != this.formsService.limparString(this.formAutoPerfilCarro.controls.cpfCnpj.value);
        if (cpfValido && buscaAnteriorDiferenteAtual) {
            let cpfDoSegurado = this.formAutoPerfilCarro.controls.cpfCnpj.value == this.segurado?.cpfCnpj;
            if (cpfDoSegurado) {
                this.formAutoPerfilCarro.controls.relacaoSegurado.setValue(this.formsService.buscaValue(ConstantFormAuto.relacaoSegurado, 'Próprio'));
                this.atualizaCamposPelaRelacaoSegurado('Próprio');
            }
            else {
                this.buscaControler.condutor.buscando = true;
                let relacaoSegurado = this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formAutoPerfilCarro.controls.relacaoSegurado.value);
                let camposCondutor = relacaoSegurado === 'Cônjuge' ? ConstantFormAuto.camposCondutor.filter(c => c !== 'estadoCivil') : ConstantFormAuto.camposCondutor;
                this.formsService.desabilitaCampos(camposCondutor, this.formAutoPerfilCarro);
                let infosSegurado = await this.api.getSegurado(this.formsService.limparString(this.formAutoPerfilCarro.controls.cpfCnpj.value)).catch(error => { return error; });
                if (infosSegurado && infosSegurado.length > 0 && infosSegurado[0]) {
                    if (relacaoSegurado === 'Cônjuge' && infosSegurado[0].hasOwnProperty('estadoCivil'))
                        delete infosSegurado[0]['estadoCivil'];
                    if (infosSegurado[0].cpfCnpj === this.formsService.limparString(this.formAutoPerfilCarro.controls.cpfCnpj.value)) // Foi criado este IF para não preencher quando o CPF não for igual, pois estava ocasionando erro.
                        this.formsService.atualizaCampos(infosSegurado[0], this.formAutoPerfilCarro);
                    this.geraOpcoesTempoHabilitacao(this.formAutoPerfilCarro.controls.dataNasc.value);
                }
                this.formsService.habilitaCampos(camposCondutor, this.formAutoPerfilCarro);
                FormsService.setaUltimaBusca(this.buscaControler.condutor, this.formsService.limparString(this.formAutoPerfilCarro.controls.cpfCnpj.value));
                this.buscaControler.condutor.buscando = false;
            }
        }
    }
    carregaInfosDraft(draft) {
        try {
            if (!draft?.isClearDraft && Object.keys(this.formAutoPerfilCarro?.controls).length) {
                let draftCondutor;
                if (this.verificaCondutorSemPerfil(draft)) {
                    draftCondutor = draft?.automoveis[0]?.condutores;
                    this.formAutoPerfilCarro.controls.relacaoSegurado.setValue(this.formsService.buscaValue(ConstantFormAuto.relacaoSegurado, 'Sem perfil'));
                }
                else {
                    draftCondutor = draft?.automoveis[0]?.condutores[0];
                    Object.keys(ConstantFormAuto.camposCondutorDraft).forEach(campo => {
                        this.formAutoPerfilCarro.controls[campo] &&
                            (draftCondutor?.[ConstantFormAuto.camposCondutorDraft[campo]] || draftCondutor?.[ConstantFormAuto.camposCondutorDraft[campo]] === 0) &&
                            this.formAutoPerfilCarro.controls[campo].setValue(FormsService.formatField(campo, draftCondutor?.[ConstantFormAuto.camposCondutorDraft[campo]]));
                    });
                }
                let draftPerfil = draft?.automoveis[0];
                Object.keys(ConstantFormAuto.camposPerfilDraft).forEach(campo => {
                    if (this.formAutoPerfilCarro.controls[campo] && draftPerfil?.[ConstantFormAuto.camposPerfilDraft[campo]]) {
                        if (campo === "kmMensal") {
                            this.formAutoPerfilCarro.controls[campo].setValue(FormsService.formatField(campo, [draftPerfil?.[ConstantFormAuto.camposPerfilDraft[campo]], this.selects.kmMensal]));
                        }
                        else {
                            this.formAutoPerfilCarro.controls[campo].setValue(FormsService.formatField(campo, draftPerfil?.[ConstantFormAuto.camposPerfilDraft[campo]]));
                        }
                    }
                });
                if (!draftPerfil.hasOwnProperty('garagemResidencia'))
                    this.formAutoPerfilCarro.controls.garagemResidencia.setValue(ConstantFormAuto.deParaGaragemResidencia(draftPerfil['tpLocalPernoite']));
                if (!draftPerfil.hasOwnProperty('garagemTrabalho'))
                    this.formAutoPerfilCarro.controls.garagemTrabalho.setValue(ConstantFormAuto.deParaGaragemTrabalho(draftPerfil['idaVoltaTrabalho'], draftPerfil['garTrabManha']));
                if (!draftPerfil.hasOwnProperty('garagemEstudo'))
                    this.formAutoPerfilCarro.controls.garagemEstudo.setValue(ConstantFormAuto.deParaGaragemEstudo(draftPerfil['idaVoltaEstudo'], draftPerfil['garEstudoManha']));
                if (!this.formAutoPerfilCarro.controls.tempoHabilitacao.value && draftCondutor?.dataPrimHabil)
                    this.formAutoPerfilCarro.controls.tempoHabilitacao.setValue(FormsService.calcTempCnh(draftCondutor?.dataPrimHabil));
                this.carregouInfosDraft = draftCondutor ? true : false;
            }
        }
        catch (error) {
            return false;
        }
    }
    executaFuncoesIniciais() {
        this.atualizaTempoHabilitacao();
        this.buscaCepPernoite();
        this.verificaJovemCondutor(this.formAutoPerfilCarro.controls.jovemCondutor.value);
        FormsService.setaUltimaBusca(this.buscaControler.condutor, this.formsService.limparString(this.formAutoPerfilCarro.controls.cpfCnpj.value));
    }
    geraOpcoesTempoHabilitacao(dataNascimento) {
        if (dataNascimento) {
            this.selects.tempoHabilitacao = this.formsService.tempoHabilitacaoOptionsPelaIdade(dataNascimento, ConstantFormAuto.tempoHabilitacao);
            this.formAutoPerfilCarro.controls.tempoHabilitacao.setValidators([Validators.required, FormsService.inArrayValidator(this.selects.tempoHabilitacao)]);
            this.formAutoPerfilCarro.controls.tempoHabilitacao.updateValueAndValidity();
            this.formAutoPerfilCarro.controls.tempoHabilitacao.enable();
        }
        else if (!this.formAutoPerfilCarro.controls.tempoHabilitacao.value && this.formAutoPerfilCarro.controls.tempoHabilitacao.value !== 0) {
            this.formsService.desabilitaResetaCampos(['tempoHabilitacao'], this.formAutoPerfilCarro);
        }
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.estadoCivilEmiter.subscribe(estadoCivil => {
            this.estadoCivilSegurado = estadoCivil;
            this.atualizaOpcoesRelacaoSegurado('estadoCivil');
        }));
        this.subscriptions.add(this.formsService.tipoPessoaEmiter.subscribe(tipoPessoa => {
            this.tipoPessoa = tipoPessoa;
            this.atualizaOpcoesRelacaoSegurado('tipoPessoa');
        }));
        this.subscriptions.add(this.formsService.seguradoEmiter.subscribe(segurado => {
            this.segurado = segurado;
            this.atualizaCamposPelaRelacaoSegurado(this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formAutoPerfilCarro.controls.relacaoSegurado.value));
            this.atualizaCepPernoite();
        }));
        this.subscriptions.add(this.formsService.buscaControlerEmiter.subscribe(buscaControler => {
            if (!this.buscaControler.endereco?.buscouManualmente)
                this.buscaControler = buscaControler;
        }));
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            if (this.formsService.isVendaCruzada(draft)) {
                this.formsService.setaInfosDefault(this.formAutoPerfilCarro, 'perfilCarro');
                this.formsService.desabilitaCampos(ConstantFormAuto.camposCondutorDesabilitadosDefault, this.formAutoPerfilCarro);
            }
            else
                this.carregaInfosDraft(draft);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formAutoPerfilCarro?.valueChanges.subscribe(() => {
            if (this.formAutoPerfilCarro.valid)
                this.formsService.enviaValidadeFormulario({ formularioNome: 'perfil', valido: this.formAutoPerfilCarro.valid });
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formAutoPerfilCarro.reset();
            this.buscaControler = ConstantFormAuto.controlerBusca;
            this.formsService.setaInfosDefault(this.formAutoPerfilCarro, 'perfilCarro');
        }));
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(() => {
            this.formsService.setaInfosDefault(this.formAutoPerfilCarro, 'perfilCarro');
            this.formsService.desabilitaCampos(ConstantFormAuto.camposCondutorDesabilitadosDefault, this.formAutoPerfilCarro);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formsService.mudaPerCarrofilEmiter.subscribe(() => {
            this.atualizaOpcoesRelacaoSegurado('tipoPessoa');
        }));
        this.subscriptions.add(this.formsService.tipoVeiculoEmiter.subscribe(tipoVeiculo => {
            this.tipoVeiculo = tipoVeiculo;
            this.formAutoPerfilCarro.controls.tpUso.setValidators([
                Validators.required, FormsService.inArrayValidator(this.selects.tpUso(this.tipoVeiculo))
            ]);
            this.formAutoPerfilCarro.controls.tpUso.updateValueAndValidity();
        }));
    }
    verificaCondutorSemPerfil(draft) {
        try {
            return draft?.automoveis[0]?.condutores && draft?.automoveis[0]?.condutores.length === 0;
        }
        catch (error) {
            return false;
        }
    }
    verificaJovemCondutor(jovemCondutor) {
        jovemCondutor ?
            this.formsService.habilitaCampos(ConstantFormAuto.camposJovemCondutor, this.formAutoPerfilCarro) :
            this.formsService.desabilitaResetaCampos(ConstantFormAuto.camposJovemCondutor, this.formAutoPerfilCarro);
    }
    static ɵfac = function FormularioAutoPerfilCarroComponent_Factory(t) { return new (t || FormularioAutoPerfilCarroComponent)(i0.ɵɵdirectiveInject('api'), i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(FormsService)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormularioAutoPerfilCarroComponent, selectors: [["formulario-auto-perfil-carro"]], inputs: { recalculo: "recalculo", listaCampo: "listaCampo" }, decls: 112, vars: 83, consts: [["cpfCnpj", ""], [3, "ngClass", "formGroup"], [3, "hidden", "ngClass"], ["name", "perfilRelacaoSegurado", "formControlName", "relacaoSegurado", 3, "selectionChange"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["matInput", "", "name", "perfilCpfCnpj", "formControlName", "cpfCnpj", "placeholder", "Ex. 000.000.000-00", "autocomplete", "off", 3, "blur", "mask", "dropSpecialCharacters"], ["class", "spinnerLoading", "mat-spinner", "", "diameter", "20", 4, "ngIf"], ["matInput", "", "name", "perfilNomeCondutor", "formControlName", "nome", 1, "text-capitalize"], ["matInput", "", "name", "perfilDataNascimento", "formControlName", "dataNasc", "placeholder", "Ex.: 00/00/0000", 3, "blur", "mask", "dropSpecialCharacters"], ["name", "perfilSexo", "formControlName", "sexo"], [3, "value", 4, "ngFor", "ngForOf"], ["name", "perfilEstadoCivil", "formControlName", "estadoCivil"], ["name", "perfilTempoHabilitacao", "formControlName", "tempoHabilitacao"], ["name", "perfilTpUso", "formControlName", "tpUso"], ["matInput", "", "name", "perfilCepPernoite", "formControlName", "cepPernoite", "placeholder", "Ex. 00000-000", "autocomplete", "off", 3, "change", "mask", "dropSpecialCharacters"], ["class", "campo-icone", "svgIcon", "check-circle-outline", 3, "matTooltip", 4, "ngIf"], ["class", "campo-icone", "svgIcon", "alert-circle-outline", "matTooltip", "N\u00E3o foi poss\u00EDvel validar seu CEP", 4, "ngIf"], ["name", "perfilKmMensal", "formControlName", "kmMensal"], ["name", "perfilJovemCondutor", "formControlName", "jovemCondutor", 3, "selectionChange"], ["name", "perfilIdadeJovem", "formControlName", "idadeJovem"], ["name", "perfilJovemSexo", "formControlName", "jovemSexo"], ["name", "perfilTipoResidencia", "formControlName", "tipoResidencia"], ["name", "garagemResidencia", "formControlName", "garagemResidencia"], ["name", "garagemTrabalho", "formControlName", "garagemTrabalho"], ["name", "garagemEstudo", "formControlName", "garagemEstudo"], [3, "hidden", "ngClass", 4, "ngIf"], ["tabindex", "-1", "id", "submitFormPerfilCarro", 2, "opacity", "0", "position", "absolute", "z-index", "-1000"], [3, "value", "disabled"], ["mat-spinner", "", "diameter", "20", 1, "spinnerLoading"], [3, "value"], ["svgIcon", "check-circle-outline", 1, "campo-icone", 3, "matTooltip"], ["svgIcon", "alert-circle-outline", "matTooltip", "N\u00E3o foi poss\u00EDvel validar seu CEP", 1, "campo-icone"], ["name", "associado", "formControlName", "associado"], ["name", "periodoUso", "formControlName", "periodoUso"]], template: function FormularioAutoPerfilCarroComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 1)(1, "mat-form-field", 2)(2, "mat-label");
            i0.ɵɵtext(3, "Condutor Principal");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-select", 3);
            i0.ɵɵlistener("selectionChange", function FormularioAutoPerfilCarroComponent_Template_mat_select_selectionChange_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.atualizaCamposPelaRelacaoSegurado(ctx.formsService.buscaViewValue(ctx.selects.relacaoSegurado, $event.value))); });
            i0.ɵɵtemplate(5, FormularioAutoPerfilCarroComponent_mat_option_5_Template, 2, 4, "mat-option", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, FormularioAutoPerfilCarroComponent_mat_error_6_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "mat-form-field", 2)(8, "mat-label");
            i0.ɵɵtext(9, "CPF");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "input", 6, 0);
            i0.ɵɵlistener("blur", function FormularioAutoPerfilCarroComponent_Template_input_blur_10_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaInfosCondutor()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, FormularioAutoPerfilCarroComponent_mat_spinner_12_Template, 1, 1, "mat-spinner", 7)(13, FormularioAutoPerfilCarroComponent_mat_error_13_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-form-field", 2)(15, "mat-label");
            i0.ɵɵtext(16, "Nome Completo");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(17, "input", 8);
            i0.ɵɵtemplate(18, FormularioAutoPerfilCarroComponent_mat_error_18_Template, 2, 0, "mat-error", 5)(19, FormularioAutoPerfilCarroComponent_mat_error_19_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "mat-form-field", 2)(21, "mat-label");
            i0.ɵɵtext(22, "Data de Nascimento");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "input", 9);
            i0.ɵɵlistener("blur", function FormularioAutoPerfilCarroComponent_Template_input_blur_23_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.atualizaTempoHabilitacao()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, FormularioAutoPerfilCarroComponent_mat_error_24_Template, 2, 0, "mat-error", 5)(25, FormularioAutoPerfilCarroComponent_mat_error_25_Template, 2, 0, "mat-error", 5)(26, FormularioAutoPerfilCarroComponent_mat_error_26_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "mat-form-field", 2)(28, "mat-label");
            i0.ɵɵtext(29, "Sexo");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "mat-select", 10);
            i0.ɵɵtemplate(31, FormularioAutoPerfilCarroComponent_mat_option_31_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(32, FormularioAutoPerfilCarroComponent_mat_error_32_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "mat-form-field", 2)(34, "mat-label");
            i0.ɵɵtext(35, "Estado Civil");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "mat-select", 12);
            i0.ɵɵtemplate(37, FormularioAutoPerfilCarroComponent_mat_option_37_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(38, FormularioAutoPerfilCarroComponent_mat_error_38_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "mat-form-field", 2)(40, "mat-label");
            i0.ɵɵtext(41, "Tempo de Habilita\u00E7\u00E3o");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(42, "mat-select", 13);
            i0.ɵɵtemplate(43, FormularioAutoPerfilCarroComponent_mat_option_43_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(44, FormularioAutoPerfilCarroComponent_mat_error_44_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "mat-form-field", 2)(46, "mat-label");
            i0.ɵɵtext(47, "Tipo de Uso");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "mat-select", 14);
            i0.ɵɵtemplate(49, FormularioAutoPerfilCarroComponent_mat_option_49_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(50, FormularioAutoPerfilCarroComponent_mat_error_50_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(51, "mat-form-field", 2)(52, "mat-label");
            i0.ɵɵtext(53, "CEP Pernoite");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(54, "input", 15);
            i0.ɵɵlistener("change", function FormularioAutoPerfilCarroComponent_Template_input_change_54_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaCepPernoite()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(55, FormularioAutoPerfilCarroComponent_mat_spinner_55_Template, 1, 1, "mat-spinner", 7)(56, FormularioAutoPerfilCarroComponent_mat_icon_56_Template, 1, 1, "mat-icon", 16)(57, FormularioAutoPerfilCarroComponent_mat_icon_57_Template, 1, 0, "mat-icon", 17)(58, FormularioAutoPerfilCarroComponent_mat_error_58_Template, 2, 0, "mat-error", 5)(59, FormularioAutoPerfilCarroComponent_mat_error_59_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(60, "mat-form-field", 2)(61, "mat-label");
            i0.ɵɵtext(62, "Quilometragem (Mensal)");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(63, "mat-select", 18);
            i0.ɵɵtemplate(64, FormularioAutoPerfilCarroComponent_mat_option_64_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(65, FormularioAutoPerfilCarroComponent_mat_error_65_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(66, "mat-form-field", 2)(67, "mat-label");
            i0.ɵɵtext(68, "Jovem Condutor (17 \u00E0 25 Anos)");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(69, "mat-select", 19);
            i0.ɵɵlistener("selectionChange", function FormularioAutoPerfilCarroComponent_Template_mat_select_selectionChange_69_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.verificaJovemCondutor($event.value)); });
            i0.ɵɵtemplate(70, FormularioAutoPerfilCarroComponent_mat_option_70_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(71, FormularioAutoPerfilCarroComponent_mat_error_71_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(72, "mat-form-field", 2)(73, "mat-label");
            i0.ɵɵtext(74, "Idade do Mais Novo");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(75, "mat-select", 20);
            i0.ɵɵtemplate(76, FormularioAutoPerfilCarroComponent_mat_option_76_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(77, FormularioAutoPerfilCarroComponent_mat_error_77_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(78, "mat-form-field", 2)(79, "mat-label");
            i0.ɵɵtext(80, "Sexo dos Jovens");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(81, "mat-select", 21);
            i0.ɵɵtemplate(82, FormularioAutoPerfilCarroComponent_mat_option_82_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(83, FormularioAutoPerfilCarroComponent_mat_error_83_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(84, "mat-form-field", 2)(85, "mat-label");
            i0.ɵɵtext(86, "Tipo de Resid\u00EAncia");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(87, "mat-select", 22);
            i0.ɵɵtemplate(88, FormularioAutoPerfilCarroComponent_mat_option_88_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(89, FormularioAutoPerfilCarroComponent_mat_error_89_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(90, "mat-form-field", 2)(91, "mat-label");
            i0.ɵɵtext(92, "Garagem na Resid\u00EAncia");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(93, "mat-select", 23);
            i0.ɵɵtemplate(94, FormularioAutoPerfilCarroComponent_mat_option_94_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(95, FormularioAutoPerfilCarroComponent_mat_error_95_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(96, "mat-form-field", 2)(97, "mat-label");
            i0.ɵɵtext(98, "Garagem no Trabalho");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(99, "mat-select", 24);
            i0.ɵɵtemplate(100, FormularioAutoPerfilCarroComponent_mat_option_100_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(101, FormularioAutoPerfilCarroComponent_mat_error_101_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(102, "mat-form-field", 2)(103, "mat-label");
            i0.ɵɵtext(104, "Garagem na Escola/Faculdade");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(105, "mat-select", 25);
            i0.ɵɵtemplate(106, FormularioAutoPerfilCarroComponent_mat_option_106_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(107, FormularioAutoPerfilCarroComponent_mat_error_107_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(108, FormularioAutoPerfilCarroComponent_h3_108_Template, 2, 0, "h3", 5)(109, FormularioAutoPerfilCarroComponent_mat_form_field_109_Template, 5, 3, "mat-form-field", 26)(110, FormularioAutoPerfilCarroComponent_mat_form_field_110_Template, 5, 3, "mat-form-field", 26);
            i0.ɵɵelement(111, "button", 27);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", !ctx.isRecalculo ? "col-12 form-auto-step" : "col-12 form-auto-step recalculo")("formGroup", ctx.formAutoPerfilCarro);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.relacaoSegurado);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("relacaoSegurado").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_CPFCNPJ) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.CPF)("dropSpecialCharacters", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.buscaControler.condutor.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("cpfCnpj").hasError("validaCpfCnpj"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_NOME) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-6" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("nome").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("nome").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_DATANASC) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.DATA)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("dataNasc").hasError("validaData"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("dataNasc").hasError("validaMaiorIdade"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("dataNasc").hasError("invalidValue"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_SEXO) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.sexo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("sexo").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_ESTADOCIVIL) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.estadoCivil);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("estadoCivil").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_TEMPOHABILITACAO) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tempoHabilitacao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("tempoHabilitacao").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_TPUSO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tpUso(ctx.tipoVeiculo));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("tpUso").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CEPPERNOITE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.CEP)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buscaControler.endereco.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.buscaControler.endereco.buscando && ctx.buscaControler.endereco.status == "ENCONTROU");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.buscaControler.endereco.buscando && ctx.buscaControler.endereco.status == "NAO-ENCONTROU");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("cepPernoite").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("cepPernoite").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_KMANUAL))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.kmMensal);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("kmMensal").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_JOVEMCONDUTOR))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("jovemCondutor").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_JOVEMIDADE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.idadeJovem);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("idadeJovem").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_JOVEMSEXO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.jovemSexo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("jovemSexo").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_TPRESIDENCIA) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tipoResidencia);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("tipoResidencia").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_LOCALPERNOITE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.garagemResidencia);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("garagemResidencia").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_IDA_VOLTA_TRABALHO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.garagemTrabalho);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("garagemTrabalho").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_IDA_VOLTA_ESTUDO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.garagemEstudo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCarro.get("garagemEstudo").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo && ctx.tipoVeiculo === ctx.tiposDeVeiculo.motocicleta);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo === ctx.tiposDeVeiculo.motocicleta);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo === ctx.tiposDeVeiculo.motocicleta);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i4$1.MatOption, i5.MatFormField, i5.MatLabel, i5.MatError, i6.MatIcon, i7.MatInput, i8.MatProgressSpinner, i9.MatSelect, i10.MatTooltip, i11.NgxMaskDirective, i1$2.FormGroupDirective, i1$2.FormControlName], styles: [".form-auto-step[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:var(--color-tertiary-first);font-size:15px;font-weight:500;letter-spacing:.5px;margin-top:10px;margin-bottom:16px;padding:0 7px;text-transform:uppercase}.form-auto-step[_ngcontent-%COMP%]   .campo-icone[_ngcontent-%COMP%]{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step[_ngcontent-%COMP%]   .spinnerLoading[_ngcontent-%COMP%]{position:absolute;right:0;top:10px}.form-auto-step[_ngcontent-%COMP%]:not(.recalculo){padding:0 15px}.recalculo[_ngcontent-%COMP%]{padding:0}"], data: { animation: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])] } });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormularioAutoPerfilCarroComponent, [{
        type: Component,
        args: [{ selector: 'formulario-auto-perfil-carro', animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])], template: "<form [ngClass]=\"!isRecalculo ? 'col-12 form-auto-step' : 'col-12 form-auto-step recalculo'\"  [formGroup]=\"formAutoPerfilCarro\">\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Condutor Principal</mat-label>\r\n        <mat-select name=\"perfilRelacaoSegurado\" formControlName=\"relacaoSegurado\" (selectionChange)=\"atualizaCamposPelaRelacaoSegurado(formsService.buscaViewValue(selects.relacaoSegurado, $event.value))\">\r\n          <mat-option *ngFor=\"let r of selects.relacaoSegurado\" [value]=\"r.value\" [disabled]=\"r.disabled\" [attr.custom-reflect-value]=\"r.value\">\r\n            {{ r.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('relacaoSegurado').hasError('required')\">Verifique os valores fornecidos.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_CPFCNPJ && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>CPF</mat-label>\r\n          <input matInput name=\"perfilCpfCnpj\" formControlName=\"cpfCnpj\" placeholder=\"Ex. 000.000.000-00\" [mask]=\"masks.CPF\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (blur)=\"buscaInfosCondutor()\" #cpfCnpj/>\r\n          <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.condutor.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('cpfCnpj').hasError('validaCpfCnpj')\">N\u00FAmero do documento inv\u00E1lido.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_NOME && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-6' : 'col-12'\">\r\n        <mat-label>Nome Completo</mat-label>\r\n        <input matInput name=\"perfilNomeCondutor\" formControlName=\"nome\" class=\"text-capitalize\"/>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('nome').hasError('pattern')\">Por favor, insira nome e sobrenome</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('nome').hasError('required')\">Por favor, insira nome e sobrenome</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_DATANASC && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Data de Nascimento</mat-label>\r\n        <input matInput name=\"perfilDataNascimento\" formControlName=\"dataNasc\" placeholder=\"Ex.: 00/00/0000\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" (blur)=\"atualizaTempoHabilitacao()\"/>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('dataNasc').hasError('validaData')\">Data Inv\u00E1lida</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('dataNasc').hasError('validaMaiorIdade')\">O condutor deve ser maior de idade.</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCarro.get('dataNasc').hasError('invalidValue')\">Verifique a idade do condutor e/ou do segurado.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_SEXO && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Sexo</mat-label>\r\n      <mat-select name=\"perfilSexo\" formControlName=\"sexo\">\r\n        <mat-option *ngFor=\"let s of selects.sexo\" [value]=\"s.value\"[attr.custom-reflect-value]=\"s.value\">\r\n          {{ s.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('sexo').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_ESTADOCIVIL && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Estado Civil</mat-label>\r\n      <mat-select name=\"perfilEstadoCivil\" formControlName=\"estadoCivil\">\r\n        <mat-option *ngFor=\"let e of selects.estadoCivil\" [value]=\"e.value\" [attr.custom-reflect-value]=\"e.value\">\r\n          {{ e.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('estadoCivil').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_TEMPOHABILITACAO && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Tempo de Habilita\u00E7\u00E3o</mat-label>\r\n      <mat-select name=\"perfilTempoHabilitacao\" formControlName=\"tempoHabilitacao\">\r\n        <mat-option *ngFor=\"let t of selects.tempoHabilitacao\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n         {{ t.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('tempoHabilitacao').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_TPUSO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Tipo de Uso</mat-label>\r\n      <mat-select name=\"perfilTpUso\" formControlName=\"tpUso\">\r\n        <mat-option *ngFor=\"let t of selects.tpUso(tipoVeiculo)\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n          {{ t.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('tpUso').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CEPPERNOITE\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n      <mat-label>CEP Pernoite</mat-label>\r\n      <input matInput name=\"perfilCepPernoite\" formControlName=\"cepPernoite\" placeholder=\"Ex. 00000-000\" [mask]=\"masks.CEP\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaCepPernoite()\"/>\r\n      <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.endereco.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n      <mat-icon class=\"campo-icone\" svgIcon=\"check-circle-outline\" [matTooltip]=\"buscaControler.endereco?.tooltip\"\r\n      *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'ENCONTROU'\"></mat-icon>\r\n      <mat-icon class=\"campo-icone\" svgIcon=\"alert-circle-outline\" matTooltip=\"N\u00E3o foi poss\u00EDvel validar seu CEP\"\r\n      *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'NAO-ENCONTROU'\" ></mat-icon>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('cepPernoite').hasError('pattern')\">Por favor, insira um cep v\u00E1lido</mat-error>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('cepPernoite').hasError('required')\">Por favor, digite um CEP</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_KMANUAL\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Quilometragem (Mensal)</mat-label>\r\n      <mat-select name=\"perfilKmMensal\" formControlName=\"kmMensal\">\r\n        <mat-option *ngFor=\"let k of selects.kmMensal\" [value]=\"k.value\" [attr.custom-reflect-value]=\"k.value\">\r\n          {{ k.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('kmMensal').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_JOVEMCONDUTOR\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Jovem Condutor (17 \u00E0 25 Anos)</mat-label>\r\n      <mat-select name=\"perfilJovemCondutor\" formControlName=\"jovemCondutor\" (selectionChange)=\"verificaJovemCondutor($event.value)\">\r\n        <mat-option *ngFor=\"let j of selects.simOuNao\" [value]=\"j.value\" [attr.custom-reflect-value]=\"j.value\">\r\n          {{ j.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('jovemCondutor').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_JOVEMIDADE\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Idade do Mais Novo</mat-label>\r\n      <mat-select name=\"perfilIdadeJovem\" formControlName=\"idadeJovem\">\r\n        <mat-option *ngFor=\"let i of selects.idadeJovem\" [value]=\"i.value\" [attr.custom-reflect-value]=\"i.value\">\r\n          {{ i.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('idadeJovem').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_JOVEMSEXO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Sexo dos Jovens</mat-label>\r\n      <mat-select name=\"perfilJovemSexo\" formControlName=\"jovemSexo\">\r\n        <mat-option *ngFor=\"let s of selects.jovemSexo\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n          {{ s.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('jovemSexo').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_TPRESIDENCIA && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Tipo de Resid\u00EAncia</mat-label>\r\n      <mat-select name=\"perfilTipoResidencia\" formControlName=\"tipoResidencia\">\r\n        <mat-option *ngFor=\"let t of selects.tipoResidencia\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n          {{ t.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('tipoResidencia').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_LOCALPERNOITE\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Garagem na Resid\u00EAncia</mat-label>\r\n      <mat-select name=\"garagemResidencia\" formControlName=\"garagemResidencia\">\r\n        <mat-option *ngFor=\"let l of selects.garagemResidencia\" [value]=\"l.value\" [attr.custom-reflect-value]=\"l.value\">\r\n          {{ l.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('garagemResidencia').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_IDA_VOLTA_TRABALHO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Garagem no Trabalho</mat-label>\r\n      <mat-select name=\"garagemTrabalho\" formControlName=\"garagemTrabalho\">\r\n        <mat-option *ngFor=\"let i of selects.garagemTrabalho\" [value]=\"i.value\" [attr.custom-reflect-value]=\"i.value\">\r\n          {{ i.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('garagemTrabalho').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_IDA_VOLTA_ESTUDO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Garagem na Escola/Faculdade</mat-label>\r\n      <mat-select name=\"garagemEstudo\" formControlName=\"garagemEstudo\">\r\n        <mat-option *ngFor=\"let i of selects.garagemEstudo\" [value]=\"i.value\" [attr.custom-reflect-value]=\"i.value\">\r\n          {{ i.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCarro.get('garagemEstudo').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <h3 *ngIf=\"!isRecalculo && tipoVeiculo === tiposDeVeiculo.motocicleta\">Informa\u00E7\u00F5es complementares</h3>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\" \r\n      *ngIf=\"tipoVeiculo === tiposDeVeiculo.motocicleta\">\r\n      <mat-label>Associado a Moto Clube</mat-label>\r\n      <mat-select name=\"associado\" formControlName=\"associado\">\r\n        <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n          {{ v.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\" \r\n      *ngIf=\"tipoVeiculo === tiposDeVeiculo.motocicleta\">\r\n      <mat-label>Per\u00EDodo de Uso</mat-label>\r\n      <mat-select name=\"periodoUso\" formControlName=\"periodoUso\">\r\n        <mat-option *ngFor=\"let v of selects.periodoUso\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n          {{ v.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormPerfilCarro\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-auto-step h3{color:var(--color-tertiary-first);font-size:15px;font-weight:500;letter-spacing:.5px;margin-top:10px;margin-bottom:16px;padding:0 7px;text-transform:uppercase}.form-auto-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step .spinnerLoading{position:absolute;right:0;top:10px}.form-auto-step:not(.recalculo){padding:0 15px}.recalculo{padding:0}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['api']
            }] }, { type: i1$2.FormBuilder }, { type: FormsService }], { recalculo: [{
            type: Input
        }], listaCampo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormularioAutoPerfilCarroComponent, { className: "FormularioAutoPerfilCarroComponent", filePath: "components\\formulario-auto-perfil-carro\\formulario-auto-perfil-carro.component.ts", lineNumber: 13 }); })();

function FormularioAutoPerfilCaminhaoComponent_mat_option_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", r_r2.value)("disabled", r_r2.disabled);
    i0.ɵɵattribute("custom-reflect-value", r_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", r_r2.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Verifique os valores fornecidos.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_spinner_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 28);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "N\u00FAmero do documento inv\u00E1lido.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira nome e sobrenome");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira nome e sobrenome");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "O condutor deve ser maior de idade.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Verifique a idade do condutor e/ou do segurado.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r3.value);
    i0.ɵɵattribute("custom-reflect-value", s_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", s_r3.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", e_r4.value);
    i0.ɵɵattribute("custom-reflect-value", e_r4.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", e_r4.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r5.value);
    i0.ɵɵattribute("custom-reflect-value", t_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r5.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r6 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r6.value);
    i0.ɵɵattribute("custom-reflect-value", t_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r6.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_spinner_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 28);
} if (rf & 2) {
    i0.ɵɵproperty("@fadeInOut", undefined);
} }
function FormularioAutoPerfilCaminhaoComponent_mat_icon_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 30);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r6.buscaControler.endereco == null ? null : ctx_r6.buscaControler.endereco.tooltip);
} }
function FormularioAutoPerfilCaminhaoComponent_mat_icon_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 31);
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira um cep v\u00E1lido");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, digite um CEP");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_h3_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1, "Informa\u00E7\u00F5es complementares");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_65_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r8.value);
    i0.ɵɵattribute("custom-reflect-value", t_r8.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r8.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_66_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_71_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", p_r9.value);
    i0.ɵɵattribute("custom-reflect-value", p_r9.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", p_r9.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_72_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", e_r10.value);
    i0.ɵɵattribute("custom-reflect-value", e_r10.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", e_r10.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_83_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const g_r11 = ctx.$implicit;
    i0.ɵɵproperty("value", g_r11.value);
    i0.ɵɵattribute("custom-reflect-value", g_r11.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", g_r11.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_84_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_89_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r12.value);
    i0.ɵɵattribute("custom-reflect-value", s_r12.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", s_r12.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_90_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_95_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r13 = ctx.$implicit;
    i0.ɵɵproperty("value", a_r13.value);
    i0.ɵɵattribute("custom-reflect-value", a_r13.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", a_r13.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_96_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_101_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r14 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r14.value);
    i0.ɵɵattribute("custom-reflect-value", t_r14.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r14.viewValue, " ");
} }
function FormularioAutoPerfilCaminhaoComponent_mat_error_102_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoPerfilCaminhaoComponent_mat_option_107_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const u_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", u_r15.value);
    i0.ɵɵattribute("custom-reflect-value", u_r15.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", u_r15.viewValue, " ");
} }
class FormularioAutoPerfilCaminhaoComponent {
    api;
    formBuilder;
    formsService;
    buscaControler = ConstantFormAuto.controlerBusca;
    masks = ConstantFormAuto.maskValidate;
    patterns = ConstantFormAuto.patternValidade;
    selects = ConstantFormAuto.objSelects;
    subscriptions = new Subscription();
    inputMask = false;
    formAutoPerfilCaminhao;
    estadoCivilSegurado;
    segurado;
    tipoPessoa;
    tipoVeiculo;
    //recalculo
    isRecalculo;
    habCampos = {};
    set recalculo(value) {
        this.isRecalculo = value;
    }
    set listaCampo(value) {
        this.habCampos = value;
    }
    ngxCurrencyOptions = {
        prefix: 'R$ ',
        thousands: '.',
        precision: 2,
        decimal: ',',
        allowNegative: false,
        nullable: false,
        align: 'left'
    };
    currencyInputMask = createMask({
        alias: 'numeric',
        groupSeparator: '.',
        radixPoint: ",",
        digits: 2,
        digitsOptional: false,
        prefix: 'R$ ',
        rightAlign: false
    });
    constructor(api, formBuilder, formsService) {
        this.api = api;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.formAutoPerfilCaminhao = this.formBuilder.group({
            cpfCnpj: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CPF), FormsService.formBuilderCpfCnpj()]),
            nome: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.patterns.NOME)]),
            dataNasc: new FormControl('', [Validators.required, Validators.pattern(this.patterns.DATA), FormsService.validarDataNascimento(), FormsService.isMaiorIdade()]),
            sexo: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.sexo)]),
            estadoCivil: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.estadoCivil)]),
            tempoHabilitacao: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.tempoHabilitacao)]),
            dataPrimHabil: new FormControl('', []),
            relacaoSegurado: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.relacaoSeguradoCaminhao)]),
            tpUso: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.tpUso(this.tipoVeiculo))]),
            equipamento: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.equipamento)]),
            cepPernoite: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CEP)]),
            cepCirculacao: new FormControl('', []),
            tpCarroceria: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.tipoCarroceria)]),
            periodoUso: new FormControl('', [Validators.required]),
            risco: new FormControl('', [Validators.required, FormsService.inArrayValidator(this.selects.gerenciamentoRisco)]),
            garagemForaServico: new FormControl('', []),
            proprioEstado: new FormControl('', []),
            seguroCarga: new FormControl('0', [Validators.required, FormsService.inArrayValidator(this.selects.seguroCarga)]),
            areaCirculacao: new FormControl('', [Validators.required]),
            tipoCarga: new FormControl('', [Validators.required]),
            perguntasAdicionais: new FormControl('', [])
        });
    }
    atualizaCamposPelaRelacaoSegurado(relacaoSegurado) {
        if (relacaoSegurado == 'Próprio') {
            ConstantFormAuto.camposAtualizaCondutor.demaisRelacoes.forEach(campo => {
                if (this.formAutoPerfilCaminhao.controls[campo]) {
                    this.formAutoPerfilCaminhao.controls[campo].setValue(this.segurado ? this.segurado[campo] : null);
                    this.formAutoPerfilCaminhao.controls[campo].disable();
                }
            });
            FormsService.setaUltimaBusca(this.buscaControler.condutor, undefined);
        }
        else if (relacaoSegurado == 'Sem perfil') {
            this.formsService.desabilitaResetaCampos(ConstantFormAuto.camposAtualizaCondutor.semPerfil, this.formAutoPerfilCaminhao);
        }
        else {
            let relacaoEraOProprioSegurado = this.formAutoPerfilCaminhao.controls.cpfCnpj.value == this.segurado?.cpfCnpj;
            ConstantFormAuto.camposAtualizaCondutor.demaisRelacoes.forEach(campo => {
                if (this.formAutoPerfilCaminhao.controls[campo]) {
                    relacaoEraOProprioSegurado && this.formAutoPerfilCaminhao.controls[campo].reset();
                    this.formAutoPerfilCaminhao.controls[campo].enable();
                }
            });
            if (relacaoSegurado == 'Cônjuge' && this.segurado?.estadoCivil) {
                this.formAutoPerfilCaminhao.controls.estadoCivil.setValue(this.segurado.estadoCivil);
                this.formAutoPerfilCaminhao.controls.estadoCivil.disable();
            }
        }
        this.geraOpcoesTempoHabilitacao(this.formAutoPerfilCaminhao.controls.dataNasc.value);
    }
    atualizaTempoHabilitacao() {
        let dataNascimentoValida = this.formAutoPerfilCaminhao.controls.dataNasc.valid;
        if (dataNascimentoValida)
            this.geraOpcoesTempoHabilitacao(this.formAutoPerfilCaminhao.controls.dataNasc.value);
        else
            this.geraOpcoesTempoHabilitacao(false);
    }
    atualizaOpcoesRelacaoSegurado(mudanca) {
        let relacaoSelecionada = this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formAutoPerfilCaminhao.controls.relacaoSegurado.value);
        if (mudanca == 'estadoCivil') {
            let podeTerConjuge = this.formsService.podeTerConjuge(this.estadoCivilSegurado);
            this.selects.relacaoSeguradoCaminhao.find(opt => opt.viewValue == 'Cônjuge').disabled = podeTerConjuge ? false : true;
            if (relacaoSelecionada == 'Cônjuge' && this.estadoCivilSegurado && !podeTerConjuge) {
                this.formAutoPerfilCaminhao.controls.relacaoSegurado.reset();
                this.formAutoPerfilCaminhao.controls.estadoCivil.reset();
                this.formAutoPerfilCaminhao.controls.estadoCivil.enable();
            }
        }
        else if (mudanca == 'tipoPessoa' && this.tipoPessoa) {
            this.selects.relacaoSeguradoCaminhao.forEach(opt => { ConstantFormAuto.desabilitaRelacaoSeguradoCaminhao[this.tipoPessoa].find(a => a == opt.viewValue) ? opt.disabled = true : opt.disabled = false; });
            this.atualizaOpcoesRelacaoSegurado('estadoCivil');
            let relacaoFoiDesabilitada = !!ConstantFormAuto.desabilitaRelacaoSeguradoCaminhao[this.tipoPessoa].find(opt => opt == relacaoSelecionada);
            if (relacaoFoiDesabilitada)
                this.formAutoPerfilCaminhao.controls.relacaoSegurado.reset();
        }
    }
    async buscaInfosCondutor() {
        let cpfValido = this.formAutoPerfilCaminhao.controls.cpfCnpj.valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler.condutor.ultimaBusca != this.formsService.limparString(this.formAutoPerfilCaminhao.controls.cpfCnpj.value);
        if (cpfValido && buscaAnteriorDiferenteAtual) {
            let cpfDoSegurado = this.formAutoPerfilCaminhao.controls.cpfCnpj.value == this.segurado?.cpfCnpj;
            if (cpfDoSegurado) {
                this.formAutoPerfilCaminhao.controls.relacaoSegurado.setValue(this.formsService.buscaValue(ConstantFormAuto.relacaoSegurado, 'Próprio'));
                this.atualizaCamposPelaRelacaoSegurado('Próprio');
            }
            else {
                this.buscaControler.condutor.buscando = true;
                let relacaoSegurado = this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formAutoPerfilCaminhao.controls.relacaoSegurado.value);
                let camposCondutor = relacaoSegurado === 'Cônjuge' ? ConstantFormAuto.camposCondutor.filter(c => c !== 'estadoCivil') : ConstantFormAuto.camposCondutor;
                this.formsService.desabilitaCampos(camposCondutor, this.formAutoPerfilCaminhao);
                let infosSegurado = await this.api.getSegurado(this.formsService.limparString(this.formAutoPerfilCaminhao.controls.cpfCnpj.value)).catch(error => { return error; });
                if (infosSegurado && infosSegurado.length > 0 && infosSegurado[0]) {
                    if (relacaoSegurado === 'Cônjuge' && infosSegurado[0].hasOwnProperty('estadoCivil'))
                        delete infosSegurado[0]['estadoCivil'];
                    this.formsService.atualizaCampos(infosSegurado[0], this.formAutoPerfilCaminhao);
                    this.geraOpcoesTempoHabilitacao(this.formAutoPerfilCaminhao.controls.dataNasc.value);
                }
                this.formsService.habilitaCampos(camposCondutor, this.formAutoPerfilCaminhao);
                FormsService.setaUltimaBusca(this.buscaControler.condutor, this.formsService.limparString(this.formAutoPerfilCaminhao.controls.cpfCnpj.value));
                this.buscaControler.condutor.buscando = false;
            }
        }
    }
    ngOnInit() {
        this.inscreverEmiters();
        this.formsService.desabilitaCampos(ConstantFormAuto.camposCondutorDesabilitadosDefault, this.formAutoPerfilCaminhao);
    }
    ngOnDestroy() {
        this.formsService.salvarDraftFinal();
        this.subscriptions.unsubscribe();
    }
    atualizaCepPernoite() {
        if (this.segurado?.cep && !this.buscaControler.endereco?.buscouManualmente) {
            this.formAutoPerfilCaminhao.controls.cepPernoite.setValue(this.segurado.cep);
        }
    }
    async buscaCepPernoite() {
        if (!this.buscaControler.endereco?.buscouManualmente)
            this.buscaControler = ConstantFormAuto.controlerBusca;
        let cepValido = this.formAutoPerfilCaminhao.controls.cepPernoite.valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler.endereco.ultimaBusca != this.formsService.limparString(this.formAutoPerfilCaminhao.controls.cepPernoite.value);
        if (cepValido && buscaAnteriorDiferenteAtual) {
            this.buscaControler.endereco.buscando = true;
            let infosEndereco = await this.api.getEndereco(this.formsService.limparString(this.formAutoPerfilCaminhao.controls.cepPernoite.value));
            if (infosEndereco && infosEndereco.length > 0 && infosEndereco[0]) {
                this.formAutoPerfilCaminhao.controls.cepPernoite.setValue(FormsService.formatField('cep', infosEndereco[0]['cep']));
                this.buscaControler.endereco.cidade = infosEndereco[0]['cidade'];
                this.buscaControler.endereco.status = 'ENCONTROU';
                this.buscaControler.endereco.tooltip = `CEP válido: ${FormsService.joinValues(', ', [infosEndereco[0]['logradouro'], infosEndereco[0]['cidade']])}`;
            }
            else
                this.buscaControler.endereco.status = 'NAO-ENCONTROU';
            this.buscaControler.endereco.ultimaBusca = this.formsService.limparString(this.formAutoPerfilCaminhao.controls.cepPernoite.value);
            this.buscaControler.endereco.buscando = false;
            this.buscaControler.endereco.buscouManualmente = true;
        }
    }
    carregaInfosDraft(draft) {
        try {
            if (!draft?.isClearDraft && Object.keys(this.formAutoPerfilCaminhao?.controls).length) {
                let draftCondutor;
                let draftPerfil = draft?.automoveis[0];
                Object.keys(ConstantFormAuto.camposPerfilDraft).forEach(campo => {
                    if (this.formAutoPerfilCaminhao.controls[campo] && draftPerfil?.[ConstantFormAuto.camposPerfilDraft[campo]]) {
                        this.formAutoPerfilCaminhao.controls[campo].setValue(FormsService.formatField(campo, draftPerfil?.[ConstantFormAuto.camposPerfilDraft[campo]]));
                    }
                    else if (this.formAutoPerfilCaminhao.controls[campo] && draftPerfil?.condutores[0]?.[ConstantFormAuto.camposPerfilDraft[campo]]) {
                        this.formAutoPerfilCaminhao.controls[campo].setValue(FormsService.formatField(campo, draftPerfil?.condutores[0]?.[ConstantFormAuto.camposPerfilDraft[campo]]));
                    }
                });
                if (!draftPerfil.hasOwnProperty('equipamento'))
                    this.formAutoPerfilCaminhao.controls.equipamento.setValue(ConstantFormAuto.deParaEquipamento(draftPerfil['equipamentos']));
                this.formAutoPerfilCaminhao.controls?.perguntasAdicionais.setValue(FormsService.formatPerguntasAdicionais(draftPerfil));
                if (!this.formAutoPerfilCaminhao.controls.tempoHabilitacao.value && draftCondutor?.dataPrimHabil)
                    this.formAutoPerfilCaminhao.controls.tempoHabilitacao.setValue(FormsService.calcTempCnh(draftCondutor?.dataPrimHabil));
            }
        }
        catch (error) {
            return false;
        }
    }
    executaFuncoesIniciais() {
        this.buscaCepPernoite();
    }
    geraOpcoesTempoHabilitacao(dataNascimento) {
        if (dataNascimento) {
            this.selects.tempoHabilitacao = this.formsService.tempoHabilitacaoOptionsPelaIdade(dataNascimento, ConstantFormAuto.tempoHabilitacao);
            this.formAutoPerfilCaminhao.controls.tempoHabilitacao.setValidators([Validators.required, FormsService.inArrayValidator(this.selects.tempoHabilitacao)]);
            this.formAutoPerfilCaminhao.controls.tempoHabilitacao.updateValueAndValidity();
            this.formAutoPerfilCaminhao.controls.tempoHabilitacao.enable();
        }
        else if (!this.formAutoPerfilCaminhao.controls.tempoHabilitacao.value && this.formAutoPerfilCaminhao.controls.tempoHabilitacao.value !== 0) {
            this.formsService.desabilitaResetaCampos(['tempoHabilitacao'], this.formAutoPerfilCaminhao);
        }
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.estadoCivilEmiter.subscribe(estadoCivil => {
            this.estadoCivilSegurado = estadoCivil;
            this.atualizaOpcoesRelacaoSegurado('estadoCivil');
        }));
        this.subscriptions.add(this.formsService.tipoPessoaEmiter.subscribe(tipoPessoa => {
            this.tipoPessoa = tipoPessoa;
            this.atualizaOpcoesRelacaoSegurado('tipoPessoa');
        }));
        this.subscriptions.add(this.formsService.seguradoEmiter.subscribe(segurado => {
            this.segurado = segurado;
            this.atualizaCepPernoite();
        }));
        this.subscriptions.add(this.formsService.buscaControlerEmiter.subscribe(buscaControler => {
            if (!this.buscaControler.endereco?.buscouManualmente)
                this.buscaControler = buscaControler;
        }));
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            if (this.formsService.isVendaCruzada(draft)) {
                this.formsService.setaInfosDefault(this.formAutoPerfilCaminhao, 'perfilCaminhao');
                this.formsService.desabilitaCampos(ConstantFormAuto.camposCondutorDesabilitadosDefault, this.formAutoPerfilCaminhao);
            }
            else
                this.carregaInfosDraft(draft);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formAutoPerfilCaminhao?.valueChanges.subscribe(() => {
            if (this.formAutoPerfilCaminhao.valid)
                this.formsService.enviaValidadeFormulario({ formularioNome: 'perfil', valido: this.formAutoPerfilCaminhao.valid });
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formAutoPerfilCaminhao.reset();
            this.buscaControler = ConstantFormAuto.controlerBusca;
            this.formsService.setaInfosDefault(this.formAutoPerfilCaminhao, 'perfilCaminhao');
        }));
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(() => {
            this.formsService.setaInfosDefault(this.formAutoPerfilCaminhao, 'perfilCaminhao');
            this.formsService.desabilitaCampos(ConstantFormAuto.camposCondutorDesabilitadosDefault, this.formAutoPerfilCaminhao);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formsService.tipoVeiculoEmiter.subscribe(tipoVeiculo => {
            this.tipoVeiculo = tipoVeiculo;
            this.formAutoPerfilCaminhao.controls.tpUso.setValidators([
                Validators.required, FormsService.inArrayValidator(this.selects.tpUso(this.tipoVeiculo))
            ]);
            this.formAutoPerfilCaminhao.controls.tpUso.updateValueAndValidity();
        }));
    }
    verificaCondutorSemPerfil(draft) {
        try {
            return draft?.automoveis[0]?.condutores && draft?.automoveis[0]?.condutores.length === 0;
        }
        catch (error) {
            return false;
        }
    }
    setaValue(field, value) {
        this.formAutoPerfilCaminhao.controls[field].setValue(this.inputMask ? value : FormsService.removeNumeroMonetario(value));
    }
    arredonda(campo) {
        if (this.formAutoPerfilCaminhao.controls[campo].value && !Number.isInteger(this.formAutoPerfilCaminhao.controls[campo].value)) {
            this.formAutoPerfilCaminhao.controls[campo].setValue(parseInt(this.formAutoPerfilCaminhao.controls[campo].value));
        }
    }
    resetaOuMantemValor(field) {
        this.formAutoPerfilCaminhao.controls[field].setValue(this.formAutoPerfilCaminhao.controls[field].value ? this.formAutoPerfilCaminhao.controls[field].value : 0);
    }
    static ɵfac = function FormularioAutoPerfilCaminhaoComponent_Factory(t) { return new (t || FormularioAutoPerfilCaminhaoComponent)(i0.ɵɵdirectiveInject('api'), i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(FormsService)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormularioAutoPerfilCaminhaoComponent, selectors: [["formulario-auto-perfil-caminhao"]], inputs: { inputMask: "inputMask", recalculo: "recalculo", listaCampo: "listaCampo" }, decls: 109, vars: 80, consts: [["cpfCnpj", ""], [3, "ngClass", "formGroup"], [3, "hidden", "ngClass"], ["name", "perfilRelacaoSegurado", "formControlName", "relacaoSegurado", 3, "selectionChange"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["matInput", "", "name", "perfilCpfCnpj", "formControlName", "cpfCnpj", "placeholder", "Ex. 000.000.000-00", "autocomplete", "off", 3, "blur", "mask", "dropSpecialCharacters"], ["class", "spinnerLoading", "mat-spinner", "", "diameter", "20", 4, "ngIf"], ["matInput", "", "name", "perfilNomeCondutor", "formControlName", "nome", 1, "text-capitalize"], ["matInput", "", "name", "perfilDataNascimento", "formControlName", "dataNasc", "placeholder", "Ex. 00/00/0000", 3, "blur", "mask", "dropSpecialCharacters"], ["name", "perfilSexo", "formControlName", "sexo"], [3, "value", 4, "ngFor", "ngForOf"], ["name", "perfilEstadoCivil", "formControlName", "estadoCivil"], ["name", "perfilTempoHabilitacao", "formControlName", "tempoHabilitacao"], ["name", "perfilTpUso", "formControlName", "tpUso"], ["matInput", "", "name", "perfilCepPernoite", "formControlName", "cepPernoite", "placeholder", "Ex. 00000-000", "autocomplete", "off", 3, "change", "mask", "dropSpecialCharacters"], ["class", "campo-icone", "svgIcon", "check-circle-outline", 3, "matTooltip", 4, "ngIf"], ["class", "campo-icone", "svgIcon", "alert-circle-outline", "matTooltip", "N\u00E3o foi poss\u00EDvel validar seu CEP", 4, "ngIf"], ["name", "perfilTpCarroceria", "formControlName", "tpCarroceria"], ["name", "perfilPeriodoUso", "formControlName", "periodoUso"], ["name", "equipamento", "formControlName", "equipamento"], ["name", "perfilRisco", "formControlName", "risco"], ["name", "seguroCarga", "formControlName", "seguroCarga"], ["name", "perfilAreaCirculacao", "formControlName", "areaCirculacao"], ["name", "perfilTipoCarga", "formControlName", "tipoCarga"], ["name", "perfilPerguntasAdicionais", "formControlName", "perguntasAdicionais", "multiple", ""], ["tabindex", "-1", "id", "submitFormPerfilCaminhao", 2, "opacity", "0", "position", "absolute", "z-index", "-1000"], [3, "value", "disabled"], ["mat-spinner", "", "diameter", "20", 1, "spinnerLoading"], [3, "value"], ["svgIcon", "check-circle-outline", 1, "campo-icone", 3, "matTooltip"], ["svgIcon", "alert-circle-outline", "matTooltip", "N\u00E3o foi poss\u00EDvel validar seu CEP", 1, "campo-icone"]], template: function FormularioAutoPerfilCaminhaoComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 1)(1, "mat-form-field", 2)(2, "mat-label");
            i0.ɵɵtext(3, "Condutor Principal");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-select", 3);
            i0.ɵɵlistener("selectionChange", function FormularioAutoPerfilCaminhaoComponent_Template_mat_select_selectionChange_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.atualizaCamposPelaRelacaoSegurado(ctx.formsService.buscaViewValue(ctx.selects.relacaoSeguradoCaminhao, $event.value))); });
            i0.ɵɵtemplate(5, FormularioAutoPerfilCaminhaoComponent_mat_option_5_Template, 2, 4, "mat-option", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, FormularioAutoPerfilCaminhaoComponent_mat_error_6_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "mat-form-field", 2)(8, "mat-label");
            i0.ɵɵtext(9, "CPF");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "input", 6, 0);
            i0.ɵɵlistener("blur", function FormularioAutoPerfilCaminhaoComponent_Template_input_blur_10_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaInfosCondutor()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, FormularioAutoPerfilCaminhaoComponent_mat_spinner_12_Template, 1, 1, "mat-spinner", 7)(13, FormularioAutoPerfilCaminhaoComponent_mat_error_13_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-form-field", 2)(15, "mat-label");
            i0.ɵɵtext(16, "Nome Completo");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(17, "input", 8);
            i0.ɵɵtemplate(18, FormularioAutoPerfilCaminhaoComponent_mat_error_18_Template, 2, 0, "mat-error", 5)(19, FormularioAutoPerfilCaminhaoComponent_mat_error_19_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "mat-form-field", 2)(21, "mat-label");
            i0.ɵɵtext(22, "Data de Nascimento");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "input", 9);
            i0.ɵɵlistener("blur", function FormularioAutoPerfilCaminhaoComponent_Template_input_blur_23_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.atualizaTempoHabilitacao()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, FormularioAutoPerfilCaminhaoComponent_mat_error_24_Template, 2, 0, "mat-error", 5)(25, FormularioAutoPerfilCaminhaoComponent_mat_error_25_Template, 2, 0, "mat-error", 5)(26, FormularioAutoPerfilCaminhaoComponent_mat_error_26_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "mat-form-field", 2)(28, "mat-label");
            i0.ɵɵtext(29, "Sexo");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "mat-select", 10);
            i0.ɵɵtemplate(31, FormularioAutoPerfilCaminhaoComponent_mat_option_31_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(32, FormularioAutoPerfilCaminhaoComponent_mat_error_32_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "mat-form-field", 2)(34, "mat-label");
            i0.ɵɵtext(35, "Estado Civil");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "mat-select", 12);
            i0.ɵɵtemplate(37, FormularioAutoPerfilCaminhaoComponent_mat_option_37_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(38, FormularioAutoPerfilCaminhaoComponent_mat_error_38_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "mat-form-field", 2)(40, "mat-label");
            i0.ɵɵtext(41, "Tempo de Habilita\u00E7\u00E3o");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(42, "mat-select", 13);
            i0.ɵɵtemplate(43, FormularioAutoPerfilCaminhaoComponent_mat_option_43_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(44, FormularioAutoPerfilCaminhaoComponent_mat_error_44_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "mat-form-field", 2)(46, "mat-label");
            i0.ɵɵtext(47, "Tipo de Uso");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "mat-select", 14);
            i0.ɵɵtemplate(49, FormularioAutoPerfilCaminhaoComponent_mat_option_49_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(50, FormularioAutoPerfilCaminhaoComponent_mat_error_50_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(51, "mat-form-field", 2)(52, "mat-label");
            i0.ɵɵtext(53, "CEP Pernoite");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(54, "input", 15);
            i0.ɵɵlistener("change", function FormularioAutoPerfilCaminhaoComponent_Template_input_change_54_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.buscaCepPernoite()); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(55, FormularioAutoPerfilCaminhaoComponent_mat_spinner_55_Template, 1, 1, "mat-spinner", 7)(56, FormularioAutoPerfilCaminhaoComponent_mat_icon_56_Template, 1, 1, "mat-icon", 16)(57, FormularioAutoPerfilCaminhaoComponent_mat_icon_57_Template, 1, 0, "mat-icon", 17)(58, FormularioAutoPerfilCaminhaoComponent_mat_error_58_Template, 2, 0, "mat-error", 5)(59, FormularioAutoPerfilCaminhaoComponent_mat_error_59_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(60, FormularioAutoPerfilCaminhaoComponent_h3_60_Template, 2, 0, "h3", 5);
            i0.ɵɵelementStart(61, "mat-form-field", 2)(62, "mat-label");
            i0.ɵɵtext(63, "Tipo de Carroceria");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(64, "mat-select", 18);
            i0.ɵɵtemplate(65, FormularioAutoPerfilCaminhaoComponent_mat_option_65_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(66, FormularioAutoPerfilCaminhaoComponent_mat_error_66_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(67, "mat-form-field", 2)(68, "mat-label");
            i0.ɵɵtext(69, "Per\u00EDodo de Uso");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(70, "mat-select", 19);
            i0.ɵɵtemplate(71, FormularioAutoPerfilCaminhaoComponent_mat_option_71_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(72, FormularioAutoPerfilCaminhaoComponent_mat_error_72_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(73, "mat-form-field", 2)(74, "mat-label");
            i0.ɵɵtext(75, "Equipamentos");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(76, "mat-select", 20);
            i0.ɵɵtemplate(77, FormularioAutoPerfilCaminhaoComponent_mat_option_77_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(78, FormularioAutoPerfilCaminhaoComponent_mat_error_78_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(79, "mat-form-field", 2)(80, "mat-label");
            i0.ɵɵtext(81, "Gerenciamento de Risco");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(82, "mat-select", 21);
            i0.ɵɵtemplate(83, FormularioAutoPerfilCaminhaoComponent_mat_option_83_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(84, FormularioAutoPerfilCaminhaoComponent_mat_error_84_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(85, "mat-form-field", 2)(86, "mat-label");
            i0.ɵɵtext(87, "Seguro da Carga");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(88, "mat-select", 22);
            i0.ɵɵtemplate(89, FormularioAutoPerfilCaminhaoComponent_mat_option_89_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(90, FormularioAutoPerfilCaminhaoComponent_mat_error_90_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(91, "mat-form-field", 2)(92, "mat-label");
            i0.ɵɵtext(93, "\u00C1rea de Maior Circula\u00E7\u00E3o");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(94, "mat-select", 23);
            i0.ɵɵtemplate(95, FormularioAutoPerfilCaminhaoComponent_mat_option_95_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(96, FormularioAutoPerfilCaminhaoComponent_mat_error_96_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(97, "mat-form-field", 2)(98, "mat-label");
            i0.ɵɵtext(99, "Tipos de Carga");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(100, "mat-select", 24);
            i0.ɵɵtemplate(101, FormularioAutoPerfilCaminhaoComponent_mat_option_101_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(102, FormularioAutoPerfilCaminhaoComponent_mat_error_102_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(103, "mat-form-field", 2)(104, "mat-label");
            i0.ɵɵtext(105, "Perguntas Adicionais");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(106, "mat-select", 25);
            i0.ɵɵtemplate(107, FormularioAutoPerfilCaminhaoComponent_mat_option_107_Template, 2, 3, "mat-option", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(108, "button", 26);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", !ctx.isRecalculo ? "col-12 form-auto-step" : "col-12 form-auto-step recalculo")("formGroup", ctx.formAutoPerfilCaminhao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.relacaoSeguradoCaminhao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("relacaoSegurado").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_CPFCNPJ) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.CPF)("dropSpecialCharacters", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.buscaControler.condutor.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("cpfCnpj").hasError("validaCpfCnpj"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_NOME) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("nome").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("nome").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_DATANASC) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.DATA)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("dataNasc").hasError("validaData"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("dataNasc").hasError("validaMaiorIdade"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("dataNasc").hasError("invalidValue"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_SEXO) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.sexo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("sexo").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_ESTADOCIVIL) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.estadoCivil);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("estadoCivil").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES_TEMPOHABILITACAO) && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CONDUTORES))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tempoHabilitacao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("tempoHabilitacao").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_TPUSO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tpUso(ctx.tipoVeiculo));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("tpUso").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_CEPPERNOITE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.CEP)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.buscaControler.endereco.buscando);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.buscaControler.endereco.buscando && ctx.buscaControler.endereco.status == "ENCONTROU");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.buscaControler.endereco.buscando && ctx.buscaControler.endereco.status == "NAO-ENCONTROU");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("cepPernoite").hasError("pattern"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("cepPernoite").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_TPCARROCERIA))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tipoCarroceria);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("tpCarroceria").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.periodoUsoCaminhao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("periodoUso").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.equipamento);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("equipamento").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.gerenciamentoRisco);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("risco").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.seguroCarga);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("seguroCarga").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.areaDeCirculacao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("areaCirculacao").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_TIPOCARGA))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tiposCarga);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoPerfilCaminhao.get("tipoCarga").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo)("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-6" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.utilizacaoCaminhao);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i4$1.MatOption, i5.MatFormField, i5.MatLabel, i5.MatError, i6.MatIcon, i7.MatInput, i8.MatProgressSpinner, i9.MatSelect, i10.MatTooltip, i11.NgxMaskDirective, i1$2.FormGroupDirective, i1$2.FormControlName], styles: [".form-auto-step[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:var(--color-tertiary-first);font-size:15px;font-weight:500;letter-spacing:.5px;margin-top:10px;margin-bottom:16px;padding:0 7px;text-transform:uppercase}.form-auto-step[_ngcontent-%COMP%]   .campo-icone[_ngcontent-%COMP%]{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step[_ngcontent-%COMP%]   .spinnerLoading[_ngcontent-%COMP%]{position:absolute;right:0;top:10px}.form-auto-step[_ngcontent-%COMP%]:not(.recalculo){padding:0 15px}.recalculo[_ngcontent-%COMP%]{padding:0}"], data: { animation: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])] } });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormularioAutoPerfilCaminhaoComponent, [{
        type: Component,
        args: [{ selector: 'formulario-auto-perfil-caminhao', animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])], template: "<form [ngClass]=\"!isRecalculo ? 'col-12 form-auto-step' : 'col-12 form-auto-step recalculo'\" [formGroup]=\"formAutoPerfilCaminhao\">\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Condutor Principal</mat-label>\r\n        <mat-select name=\"perfilRelacaoSegurado\" formControlName=\"relacaoSegurado\" (selectionChange)=\"atualizaCamposPelaRelacaoSegurado(formsService.buscaViewValue(selects.relacaoSeguradoCaminhao, $event.value))\">\r\n          <mat-option *ngFor=\"let r of selects.relacaoSeguradoCaminhao\" [value]=\"r.value\" [disabled]=\"r.disabled\" [attr.custom-reflect-value]=\"r.value\">\r\n            {{ r.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('relacaoSegurado').hasError('required')\">Verifique os valores fornecidos.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_CPFCNPJ && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>CPF</mat-label>\r\n          <input matInput name=\"perfilCpfCnpj\" formControlName=\"cpfCnpj\" placeholder=\"Ex. 000.000.000-00\" [mask]=\"masks.CPF\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (blur)=\"buscaInfosCondutor()\" #cpfCnpj/>\r\n          <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.condutor.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('cpfCnpj').hasError('validaCpfCnpj')\">N\u00FAmero do documento inv\u00E1lido.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_NOME && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Nome Completo</mat-label>\r\n        <input matInput name=\"perfilNomeCondutor\" formControlName=\"nome\" class=\"text-capitalize\"/>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('nome').hasError('pattern')\">Por favor, insira nome e sobrenome</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('nome').hasError('required')\">Por favor, insira nome e sobrenome</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_DATANASC && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Data de Nascimento</mat-label>\r\n        <input matInput name=\"perfilDataNascimento\" formControlName=\"dataNasc\" placeholder=\"Ex. 00/00/0000\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" (blur)=\"atualizaTempoHabilitacao()\"/>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('dataNasc').hasError('validaData')\">Data Inv\u00E1lida</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('dataNasc').hasError('validaMaiorIdade')\">O condutor deve ser maior de idade.</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('dataNasc').hasError('invalidValue')\">Verifique a idade do condutor e/ou do segurado.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_SEXO && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Sexo</mat-label>\r\n      <mat-select name=\"perfilSexo\" formControlName=\"sexo\">\r\n        <mat-option *ngFor=\"let s of selects.sexo\" [value]=\"s.value\"[attr.custom-reflect-value]=\"s.value\">\r\n          {{ s.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCaminhao.get('sexo').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_ESTADOCIVIL && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Estado Civil</mat-label>\r\n      <mat-select name=\"perfilEstadoCivil\" formControlName=\"estadoCivil\">\r\n        <mat-option *ngFor=\"let e of selects.estadoCivil\" [value]=\"e.value\" [attr.custom-reflect-value]=\"e.value\">\r\n          {{ e.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCaminhao.get('estadoCivil').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CONDUTORES_TEMPOHABILITACAO && !habCampos?.AUTOMOVEIS_CONDUTORES\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n      <mat-label>Tempo de Habilita\u00E7\u00E3o</mat-label>\r\n      <mat-select name=\"perfilTempoHabilitacao\" formControlName=\"tempoHabilitacao\">\r\n        <mat-option *ngFor=\"let t of selects.tempoHabilitacao\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n        {{ t.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formAutoPerfilCaminhao.get('tempoHabilitacao').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_TPUSO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Tipo de Uso</mat-label>\r\n        <mat-select name=\"perfilTpUso\" formControlName=\"tpUso\">\r\n          <mat-option *ngFor=\"let t of selects.tpUso(tipoVeiculo)\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n            {{ t.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('tpUso').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_CEPPERNOITE\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n        <mat-label>CEP Pernoite</mat-label>\r\n        <input matInput name=\"perfilCepPernoite\" formControlName=\"cepPernoite\" placeholder=\"Ex. 00000-000\" [mask]=\"masks.CEP\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaCepPernoite()\"/>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.endereco.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-icon class=\"campo-icone\" svgIcon=\"check-circle-outline\" [matTooltip]=\"buscaControler.endereco?.tooltip\"\r\n        *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'ENCONTROU'\"></mat-icon>\r\n        <mat-icon class=\"campo-icone\" svgIcon=\"alert-circle-outline\" matTooltip=\"N\u00E3o foi poss\u00EDvel validar seu CEP\"\r\n        *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'NAO-ENCONTROU'\" ></mat-icon>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('cepPernoite').hasError('pattern')\">Por favor, insira um cep v\u00E1lido</mat-error>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('cepPernoite').hasError('required')\">Por favor, digite um CEP</mat-error>\r\n    </mat-form-field>\r\n\r\n      <h3 *ngIf=\"!isRecalculo\">Informa\u00E7\u00F5es complementares</h3>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_TPCARROCERIA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Tipo de Carroceria</mat-label>\r\n        <mat-select name=\"perfilTpCarroceria\" formControlName=\"tpCarroceria\">\r\n          <mat-option *ngFor=\"let t of selects.tipoCarroceria\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n            {{ t.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('tpCarroceria').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Per\u00EDodo de Uso</mat-label>\r\n        <mat-select name=\"perfilPeriodoUso\" formControlName=\"periodoUso\">\r\n          <mat-option *ngFor=\"let p of selects.periodoUsoCaminhao\" [value]=\"p.value\" [attr.custom-reflect-value]=\"p.value\">\r\n            {{ p.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('periodoUso').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Equipamentos</mat-label>\r\n        <mat-select name=\"equipamento\" formControlName=\"equipamento\">\r\n          <mat-option *ngFor=\"let e of selects.equipamento\" [value]=\"e.value\" [attr.custom-reflect-value]=\"e.value\">\r\n            {{ e.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('equipamento').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Gerenciamento de Risco</mat-label>\r\n        <mat-select name=\"perfilRisco\" formControlName=\"risco\">\r\n          <mat-option *ngFor=\"let g of selects.gerenciamentoRisco\" [value]=\"g.value\" [attr.custom-reflect-value]=\"g.value\">\r\n            {{ g.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('risco').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Seguro da Carga</mat-label>\r\n        <mat-select name=\"seguroCarga\" formControlName=\"seguroCarga\">\r\n          <mat-option *ngFor=\"let s of selects.seguroCarga\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n            {{ s.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('seguroCarga').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>\u00C1rea de Maior Circula\u00E7\u00E3o</mat-label>\r\n        <mat-select name=\"perfilAreaCirculacao\" formControlName=\"areaCirculacao\">\r\n          <mat-option *ngFor=\"let a of selects.areaDeCirculacao\" [value]=\"a.value\" [attr.custom-reflect-value]=\"a.value\">\r\n            {{ a.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('areaCirculacao').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_TIPOCARGA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Tipos de Carga</mat-label>\r\n        <mat-select name=\"perfilTipoCarga\" formControlName=\"tipoCarga\">\r\n          <mat-option *ngFor=\"let t of selects.tiposCarga\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n            {{ t.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoPerfilCaminhao.get('tipoCarga').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n      </mat-form-field>\r\n\r\n      <mat-form-field [hidden]=\"isRecalculo\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-6' : 'col-12'\">\r\n        <mat-label>Perguntas Adicionais</mat-label>\r\n        <mat-select name=\"perfilPerguntasAdicionais\" formControlName=\"perguntasAdicionais\" multiple>\r\n          <mat-option *ngFor=\"let u of selects.utilizacaoCaminhao\" [value]=\"u.value\" [attr.custom-reflect-value]=\"u.value\">\r\n            {{ u.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n      </mat-form-field>\r\n\r\n      <button tabindex=\"-1\" id=\"submitFormPerfilCaminhao\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-auto-step h3{color:var(--color-tertiary-first);font-size:15px;font-weight:500;letter-spacing:.5px;margin-top:10px;margin-bottom:16px;padding:0 7px;text-transform:uppercase}.form-auto-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-auto-step .spinnerLoading{position:absolute;right:0;top:10px}.form-auto-step:not(.recalculo){padding:0 15px}.recalculo{padding:0}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['api']
            }] }, { type: i1$2.FormBuilder }, { type: FormsService }], { inputMask: [{
            type: Input
        }], recalculo: [{
            type: Input
        }], listaCampo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormularioAutoPerfilCaminhaoComponent, { className: "FormularioAutoPerfilCaminhaoComponent", filePath: "components\\formulario-auto-perfil-caminhao\\formulario-auto-perfil-caminhao.component.ts", lineNumber: 15 }); })();

function FormularioAutoSeguroComponent_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_error_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_option_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const t_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", t_r1.value);
    i0.ɵɵattribute("custom-reflect-value", t_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", t_r1.viewValue, " ");
} }
function FormularioAutoSeguroComponent_h3_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1, "Renova\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_section_17_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 17)(1, "mat-checkbox", 18);
    i0.ɵɵlistener("change", function FormularioAutoSeguroComponent_section_17_Template_mat_checkbox_change_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.verificaRenovacao()); });
    i0.ɵɵtext(2, "Esta \u00E9 uma renova\u00E7\u00E3o");
    i0.ɵɵelementEnd()();
} }
function FormularioAutoSeguroComponent_mat_error_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_error_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Data Inv\u00E1lida.");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_option_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r4.value);
    i0.ɵɵattribute("custom-reflect-value", s_r4.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", s_r4.viewValue, " ");
} }
function FormularioAutoSeguroComponent_mat_error_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, insira o n\u00FAmero da ap\u00F3lice anterior");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_option_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", s_r5.value);
    i0.ɵɵattribute("custom-reflect-value", s_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", s_r5.viewValue, " ");
} }
function FormularioAutoSeguroComponent_mat_error_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
function FormularioAutoSeguroComponent_mat_option_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const b_r6 = ctx.$implicit;
    i0.ɵɵproperty("value", b_r6.value);
    i0.ɵɵattribute("custom-reflect-value", b_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", b_r6.viewValue, " ");
} }
function FormularioAutoSeguroComponent_mat_error_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o");
    i0.ɵɵelementEnd();
} }
class FormularioAutoSeguroComponent {
    api;
    formBuilder;
    formsService;
    formAutoSeguro;
    masks = ConstantFormAuto.maskValidate;
    patterns = ConstantFormAuto.patternValidade;
    selects = ConstantFormAuto.objSelects;
    subscriptions = new Subscription();
    //recalculo
    isRecalculo;
    habCampos = {};
    set recalculo(value) {
        this.isRecalculo = value;
    }
    set listaCampo(value) {
        this.habCampos = value;
    }
    constructor(api, formBuilder, formsService) {
        this.api = api;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.formAutoSeguro = this.formBuilder.group({
            vigenciaIni: new FormControl(FormsService.geraDataVigencia('vigenciaIni'), [Validators.required, FormsService.validarData(), FormsService.validarDataMaximaVigencia()]),
            vigenciaFim: new FormControl(FormsService.geraDataVigencia('vigenciaFim'), [Validators.required, FormsService.validarData(), FormsService.validarDataMaximaVigencia()]),
            tpCobertura: new FormControl(1, [Validators.required, FormsService.inArrayValidator(this.selects.tpCobertura)]),
            vigIniAnterior: new FormControl('', []),
            vigFimAnterior: new FormControl('', []),
            numeroRenovacao: new FormControl('', []),
            seguradoraAnteriorId: new FormControl('', []),
            CI: new FormControl('', []),
            sinistrosAnterior: new FormControl('', []),
            bonusAnterior: new FormControl('', []),
            renovacao: new FormControl(false, []),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
        this.formsService.desabilitaCampos(ConstantFormAuto.camposRenovacao, this.formAutoSeguro);
        this.removeValidators();
    }
    ngOnDestroy() {
        this.formsService.salvarDraftFinal();
        this.subscriptions.unsubscribe();
    }
    alteraDataVigenciaIni() {
        let hj = new Date();
        let vigenciaIni = this.formsService.converteDataAmerica(this.formAutoSeguro?.controls.vigenciaIni.value);
        let vigFim = this.formsService.editarData({ data: vigenciaIni, operacao: '+', dia: 0, mes: 0, ano: 1 });
        if (!this.formsService.verificaDataFormulario(this.formAutoSeguro?.controls.vigenciaIni.value)) {
            vigenciaIni = hj;
            this.formAutoSeguro?.controls.vigenciaIni.setValue(this.formsService.converteDataAmerica(vigenciaIni));
            vigFim = this.formsService.editarData({ data: vigenciaIni, operacao: '+', dia: 0, mes: 0, ano: 1 });
            this.formsService.openSnackbarModal('A data do início de vigência não pode ser retroativa.');
        }
        this.formAutoSeguro?.controls.vigenciaFim.setValue(this.formsService.converteDataAmerica(vigFim));
    }
    alteraVigenciaFinalAnterior() {
        // let vigIni = this.formsService.converteDataAmerica(this.formAutoSeguro?.controls.vigIniAnterior.value);
        // let vigFimAnterior = this.formsService.editarData({ data: vigIni, operacao: '+', dia: 0, mes: 0, ano: 1 });
        // this.formAutoSeguro?.controls.vigFimAnterior.setValue(this.formsService.converteDataAmerica(vigFimAnterior));
    }
    carregaInfosDraft(draft) {
        if (!draft?.isClearDraft && Object.keys(this.formAutoSeguro?.controls).length) {
            try {
                Object.keys(ConstantFormAuto.camposSeguroDraft).forEach(campo => {
                    this.formAutoSeguro.controls[campo] &&
                        (draft[ConstantFormAuto.camposSeguroDraft[campo]] || draft[ConstantFormAuto.camposSeguroDraft[campo]] === 0 || draft[ConstantFormAuto.camposSeguroDraft[campo]] === false || draft[ConstantFormAuto.camposSeguroDraft[campo]] === null) &&
                        this.formAutoSeguro.controls[campo].setValue(FormsService.formatField(campo, draft[ConstantFormAuto.camposSeguroDraft[campo]]));
                });
            }
            catch (error) {
                return false;
            }
        }
    }
    enviaCobertura(cobertura) {
        this.formsService.enviaCobertura(cobertura);
    }
    enviaSeguradoraAnterior(seguradoAnterior) {
        this.formsService.enviaSeguradoraAnterior(seguradoAnterior);
    }
    executaFuncoesIniciais() {
        this.verificaRenovacao();
    }
    async geraSeguradorasOptions() {
        let arraySeguradoras = await this.api.getSeguradoraAnterior();
        this.selects.seguradoraAnteriorId = this.formsService.generateOptionsSeguradoraAnterior(arraySeguradoras.filter(seguradora => seguradora.auto));
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(async (draft) => {
            this.carregaInfosDraft(draft);
            await this.geraSeguradorasOptions();
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formsService.solicitaVigenciaIniEmiter.subscribe(() => {
            this.formsService.enviaVigenciaIni(this.formsService.converteDataAmerica(this.formAutoSeguro.controls.vigenciaIni.value));
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formAutoSeguro.reset();
            this.removeValidators();
            this.formsService.setaInfosDefault(this.formAutoSeguro, 'seguro');
            this.formsService.desabilitaCampos(ConstantFormAuto.camposRenovacao, this.formAutoSeguro);
        }));
        this.subscriptions.add(this.formAutoSeguro?.valueChanges.subscribe(() => {
            if (this.formAutoSeguro.valid)
                this.formsService.enviaValidadeFormulario({ formularioNome: 'seguro', valido: this.formAutoSeguro.valid });
        }));
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(async () => {
            this.formsService.setaInfosDefault(this.formAutoSeguro, 'seguro');
            this.formsService.desabilitaCampos(ConstantFormAuto.camposRenovacao, this.formAutoSeguro);
            await this.geraSeguradorasOptions();
            this.executaFuncoesIniciais();
        }));
    }
    verificaDataFinalValida() {
        // let data = this.formsService.getDataVigenciaValida(this.formAutoSeguro?.controls.vigIniAnterior.value, this.formAutoSeguro?.controls.vigFimAnterior.value);
        // if (data)
        //   this.formAutoSeguro?.controls.vigFimAnterior.setValue(data);
        this.verificaDiferencaDias(true);
    }
    verificaDiferencaDias(isRenocacao) {
        const vigenciaIni = this.formAutoSeguro?.controls.vigenciaIni.value;
        const vigenciaFim = this.formAutoSeguro?.controls.vigenciaFim.value;
        let vigIniAnterior;
        let vigFimAnterior;
        let diffDays;
        if (isRenocacao) {
            vigIniAnterior = this.formAutoSeguro?.controls.vigIniAnterior.value;
            vigFimAnterior = this.formAutoSeguro?.controls.vigFimAnterior.value;
        }
        diffDays = this.formsService.verifyDiffDays(vigenciaIni, vigenciaFim, vigIniAnterior, vigFimAnterior);
        // if (isRenocacao && diffDays.isDiffDaysAnterior)
        //   this.formAutoSeguro?.controls.vigFimAnterior.setErrors({ invalidValue: true });
        if (diffDays.isDiffDays)
            this.formAutoSeguro?.controls.vigenciaFim.setErrors({ invalidValue: true });
    }
    verificaRenovacao() {
        let isRenovacao = this.formAutoSeguro.controls.renovacao.value;
        ConstantFormAuto.camposRenovacao.forEach(campo => {
            isRenovacao ? (this.formAutoSeguro.controls[campo].setValidators(campo === 'seguradoraAnteriorId' ?
                ConstantFormAuto.setValidatorsRenovacao[campo].concat(FormsService.inArrayValidator(this.selects.seguradoraAnteriorId)) :
                ConstantFormAuto.setValidatorsRenovacao[campo]),
                this.formAutoSeguro.controls[campo].enable(),
                this.formAutoSeguro.controls[campo].updateValueAndValidity()) : (this.formAutoSeguro.controls[campo].disable(),
                this.formAutoSeguro.controls[campo].reset(),
                this.formAutoSeguro.controls[campo].clearValidators(),
                this.formAutoSeguro.controls[campo].updateValueAndValidity());
        });
        if (isRenovacao) {
            if (this.formAutoSeguro.controls.seguradoraAnteriorId.hasError('valueNotInArrayOptions'))
                this.formAutoSeguro.controls.seguradoraAnteriorId.setValue(this.encontraSeguradoraCorrespondenteCorp(this.formAutoSeguro.controls.seguradoraAnteriorId.value));
            if (!this.formAutoSeguro.controls.vigIniAnterior.value)
                this.formAutoSeguro.controls.vigIniAnterior.setValue(FormsService.geraDataVigencia('vigIniAnterior', this.formAutoSeguro.controls.vigenciaIni.value));
            if (!this.formAutoSeguro.controls.vigFimAnterior.value)
                this.formAutoSeguro.controls.vigFimAnterior.setValue(FormsService.geraDataVigencia('vigFimAnterior', this.formAutoSeguro.controls.vigenciaIni.value));
        }
    }
    removeValidators() {
        ConstantFormAuto.camposRenovacao.forEach(campo => {
            this.formAutoSeguro?.controls[campo].clearValidators();
            this.formAutoSeguro?.controls[campo].disable();
        });
    }
    encontraSeguradoraCorrespondenteCorp(valorCampo) {
        try {
            return ConstantFormAuto.deParaSeguradorasCorp[valorCampo] ? ConstantFormAuto.deParaSeguradorasCorp[valorCampo] : valorCampo;
        }
        catch (error) {
            return valorCampo;
        }
    }
    static ɵfac = function FormularioAutoSeguroComponent_Factory(t) { return new (t || FormularioAutoSeguroComponent)(i0.ɵɵdirectiveInject('api'), i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(FormsService)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormularioAutoSeguroComponent, selectors: [["formulario-auto-seguro"]], inputs: { recalculo: "recalculo", listaCampo: "listaCampo" }, decls: 56, vars: 44, consts: [[3, "ngClass", "formGroup"], [3, "hidden", "ngClass"], ["matInput", "", "name", "vigenciaIni", "formControlName", "vigenciaIni", 3, "change", "dropSpecialCharacters", "mask"], [4, "ngIf"], ["matInput", "", "name", "vigenciaFim", "formControlName", "vigenciaFim", 3, "change", "dropSpecialCharacters", "mask"], ["name", "tpCobertura", "formControlName", "tpCobertura", 3, "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "renovacao-section", 4, "ngIf"], ["matInput", "", "name", "vigIniAnterior", "formControlName", "vigIniAnterior", 3, "change", "mask", "dropSpecialCharacters"], ["matInput", "", "name", "vigFimAnterior", "formControlName", "vigFimAnterior", 3, "change", "mask", "dropSpecialCharacters"], ["name", "seguradoraAnteriorId", "formControlName", "seguradoraAnteriorId", 3, "selectionChange"], ["matInput", "", "name", "numeroRenovacao", "formControlName", "numeroRenovacao"], ["matInput", "", "name", "CI", "formControlName", "CI"], ["name", "sinistrosAnterior", "formControlName", "sinistrosAnterior"], ["name", "bonusAnterior", "formControlName", "bonusAnterior"], ["tabindex", "-1", "id", "submitFormSeguro", 2, "opacity", "0", "position", "absolute", "z-index", "-1000"], [3, "value"], [1, "renovacao-section"], ["name", "renovacao", "formControlName", "renovacao", 3, "change"]], template: function FormularioAutoSeguroComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0)(1, "mat-form-field", 1)(2, "mat-label");
            i0.ɵɵtext(3, "In\u00EDcio Vig\u00EAncia");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "input", 2);
            i0.ɵɵlistener("change", function FormularioAutoSeguroComponent_Template_input_change_4_listener() { return ctx.alteraDataVigenciaIni(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FormularioAutoSeguroComponent_mat_error_5_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-form-field", 1)(7, "mat-label");
            i0.ɵɵtext(8, "Final Vig\u00EAncia");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "input", 4);
            i0.ɵɵlistener("change", function FormularioAutoSeguroComponent_Template_input_change_9_listener() { return ctx.verificaDiferencaDias(false); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, FormularioAutoSeguroComponent_mat_error_10_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "mat-form-field", 1)(12, "mat-label");
            i0.ɵɵtext(13, "Tipo de Cobertura");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-select", 5);
            i0.ɵɵlistener("selectionChange", function FormularioAutoSeguroComponent_Template_mat_select_selectionChange_14_listener($event) { return ctx.enviaCobertura($event.value); });
            i0.ɵɵtemplate(15, FormularioAutoSeguroComponent_mat_option_15_Template, 2, 3, "mat-option", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(16, FormularioAutoSeguroComponent_h3_16_Template, 2, 0, "h3", 3)(17, FormularioAutoSeguroComponent_section_17_Template, 3, 0, "section", 7);
            i0.ɵɵelementStart(18, "mat-form-field", 1)(19, "mat-label");
            i0.ɵɵtext(20, "In\u00EDcio Vig\u00EAncia Anterior");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "input", 8);
            i0.ɵɵlistener("change", function FormularioAutoSeguroComponent_Template_input_change_21_listener() { return ctx.alteraVigenciaFinalAnterior(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, FormularioAutoSeguroComponent_mat_error_22_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "mat-form-field", 1)(24, "mat-label");
            i0.ɵɵtext(25, "Final Vig\u00EAncia Anterior");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(26, "input", 9);
            i0.ɵɵlistener("change", function FormularioAutoSeguroComponent_Template_input_change_26_listener() { return ctx.verificaDataFinalValida(); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(27, FormularioAutoSeguroComponent_mat_error_27_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(28, "mat-form-field", 1)(29, "mat-label");
            i0.ɵɵtext(30, "Seguradora Anterior");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "mat-select", 10);
            i0.ɵɵlistener("selectionChange", function FormularioAutoSeguroComponent_Template_mat_select_selectionChange_31_listener($event) { return ctx.enviaSeguradoraAnterior($event.value); });
            i0.ɵɵtemplate(32, FormularioAutoSeguroComponent_mat_option_32_Template, 2, 3, "mat-option", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(33, FormularioAutoSeguroComponent_mat_error_33_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "mat-form-field", 1)(35, "mat-label");
            i0.ɵɵtext(36, "N\u00FAmero Ap\u00F3lice Anterior");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(37, "input", 11);
            i0.ɵɵtemplate(38, FormularioAutoSeguroComponent_mat_error_38_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "mat-form-field", 1)(40, "mat-label");
            i0.ɵɵtext(41, "C\u00F3digo Interno (CI)");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(42, "input", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "mat-form-field", 1)(44, "mat-label");
            i0.ɵɵtext(45, "Quantidade de Sinistros");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(46, "mat-select", 13);
            i0.ɵɵtemplate(47, FormularioAutoSeguroComponent_mat_option_47_Template, 2, 3, "mat-option", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(48, FormularioAutoSeguroComponent_mat_error_48_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(49, "mat-form-field", 1)(50, "mat-label");
            i0.ɵɵtext(51, "B\u00F4nus de Renova\u00E7\u00E3o");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(52, "mat-select", 14);
            i0.ɵɵtemplate(53, FormularioAutoSeguroComponent_mat_option_53_Template, 2, 3, "mat-option", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(54, FormularioAutoSeguroComponent_mat_error_54_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(55, "button", 15);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", !ctx.isRecalculo ? "col-12 form-auto-step" : "col-12 form-auto-step recalculo")("formGroup", ctx.formAutoSeguro);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.VIGENCIAINI))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("dropSpecialCharacters", false)("mask", ctx.masks.DATA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("vigenciaIni").invalid);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.VIGENCIAFIM))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("dropSpecialCharacters", false)("mask", ctx.masks.DATA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("vigenciaFim").invalid);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.TPCOBERTURA))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-6" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tpCobertura);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.ANTERIOR_VIGENCIAINI))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.DATA)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("vigIniAnterior").invalid);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.ANTERIOR_VIGENCIAFIM))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mask", ctx.masks.DATA)("dropSpecialCharacters", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("vigFimAnterior").invalid);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SEGURADORAANTERIORID))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-6" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.seguradoraAnteriorId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("seguradoraAnteriorId").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.NUMERORENOVACAO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("numeroRenovacao").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CI))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.SINISTROSANTERIOR))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.sinistrosAnterior);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("sinistrosAnterior").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.BONUSANTERIOR))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.bonusAnterior);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formAutoSeguro.get("bonusAnterior").hasError("required"));
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i4$1.MatOption, i5$1.MatCheckbox, i5.MatFormField, i5.MatLabel, i5.MatError, i7.MatInput, i9.MatSelect, i11.NgxMaskDirective, i1$2.FormGroupDirective, i1$2.FormControlName], styles: [".form-auto-step[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:var(--color-tertiary-first);font-weight:500;text-transform:uppercase;font-size:15px;letter-spacing:.5px;padding:0 7px;margin:10px 0}.form-auto-step[_ngcontent-%COMP%]   .renovacao-section[_ngcontent-%COMP%]{padding:0 0 10px}.form-auto-step[_ngcontent-%COMP%]:not(.recalculo){padding:0 15px}.recalculo[_ngcontent-%COMP%]{padding:0}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormularioAutoSeguroComponent, [{
        type: Component,
        args: [{ selector: 'formulario-auto-seguro', template: "<form [ngClass]=\"!isRecalculo ? 'col-12 form-auto-step' : 'col-12 form-auto-step recalculo'\" [formGroup]=\"formAutoSeguro\">\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.VIGENCIAINI\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>In\u00EDcio Vig\u00EAncia</mat-label>\r\n        <input matInput name=\"vigenciaIni\" formControlName=\"vigenciaIni\" [dropSpecialCharacters]=\"false\" [mask]=\"masks.DATA\" (change)=\"alteraDataVigenciaIni()\"/>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('vigenciaIni').invalid\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.VIGENCIAFIM\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Final Vig\u00EAncia</mat-label>\r\n        <input matInput name=\"vigenciaFim\" formControlName=\"vigenciaFim\" [dropSpecialCharacters]=\"false\" [mask]=\"masks.DATA\" (change)=\"verificaDiferencaDias(false)\"/>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('vigenciaFim').invalid\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.TPCOBERTURA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-6' : 'col-12'\">\r\n        <mat-label>Tipo de Cobertura</mat-label>\r\n        <mat-select name=\"tpCobertura\" formControlName=\"tpCobertura\" (selectionChange)=\"enviaCobertura($event.value)\">\r\n          <mat-option *ngFor=\"let t of selects.tpCobertura\" [value]=\"t.value\" [attr.custom-reflect-value]=\"t.value\">\r\n            {{ t.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n    </mat-form-field>\r\n\r\n    <h3 *ngIf=\"!isRecalculo\">Renova\u00E7\u00E3o</h3>\r\n\r\n    <section *ngIf=\"!isRecalculo\" class=\"renovacao-section\">\r\n        <mat-checkbox name=\"renovacao\" formControlName=\"renovacao\" (change)=\"verificaRenovacao()\">Esta \u00E9 uma renova\u00E7\u00E3o</mat-checkbox>\r\n    </section>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.ANTERIOR_VIGENCIAINI\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>In\u00EDcio Vig\u00EAncia Anterior</mat-label>\r\n        <input matInput name=\"vigIniAnterior\" formControlName=\"vigIniAnterior\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" (change)=\"alteraVigenciaFinalAnterior()\"/>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('vigIniAnterior').invalid\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.ANTERIOR_VIGENCIAFIM\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Final Vig\u00EAncia Anterior</mat-label>\r\n        <input matInput name=\"vigFimAnterior\" formControlName=\"vigFimAnterior\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" (change)=\"verificaDataFinalValida()\"/>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('vigFimAnterior').invalid\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SEGURADORAANTERIORID\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-6' : 'col-12'\">\r\n        <mat-label>Seguradora Anterior</mat-label>\r\n        <mat-select name=\"seguradoraAnteriorId\" formControlName=\"seguradoraAnteriorId\" (selectionChange)=\"enviaSeguradoraAnterior($event.value)\">\r\n          <mat-option *ngFor=\"let s of selects.seguradoraAnteriorId\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n            {{ s.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('seguradoraAnteriorId').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.NUMERORENOVACAO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>N\u00FAmero Ap\u00F3lice Anterior</mat-label>\r\n        <input matInput name=\"numeroRenovacao\" formControlName=\"numeroRenovacao\" />\r\n        <mat-error *ngIf=\"formAutoSeguro.get('numeroRenovacao').hasError('required')\">Por favor, insira o n\u00FAmero da ap\u00F3lice anterior</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CI\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>C\u00F3digo Interno (CI)</mat-label>\r\n        <input matInput name=\"CI\" formControlName=\"CI\"/>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.SINISTROSANTERIOR\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Quantidade de Sinistros</mat-label>\r\n        <mat-select name=\"sinistrosAnterior\" formControlName=\"sinistrosAnterior\">\r\n          <mat-option *ngFor=\"let s of selects.sinistrosAnterior\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n            {{ s.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('sinistrosAnterior').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"isRecalculo && !habCampos?.BONUSANTERIOR\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>B\u00F4nus de Renova\u00E7\u00E3o</mat-label>\r\n        <mat-select name=\"bonusAnterior\" formControlName=\"bonusAnterior\">\r\n          <mat-option *ngFor=\"let b of selects.bonusAnterior\" [value]=\"b.value\" [attr.custom-reflect-value]=\"b.value\">\r\n            {{ b.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formAutoSeguro.get('bonusAnterior').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o</mat-error>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormSeguro\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-auto-step h3{color:var(--color-tertiary-first);font-weight:500;text-transform:uppercase;font-size:15px;letter-spacing:.5px;padding:0 7px;margin:10px 0}.form-auto-step .renovacao-section{padding:0 0 10px}.form-auto-step:not(.recalculo){padding:0 15px}.recalculo{padding:0}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['api']
            }] }, { type: i1$2.FormBuilder }, { type: FormsService }], { recalculo: [{
            type: Input
        }], listaCampo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormularioAutoSeguroComponent, { className: "FormularioAutoSeguroComponent", filePath: "components\\formulario-auto-seguro\\formulario-auto-seguro.component.ts", lineNumber: 12 }); })();

const _c0 = ["formSegurado"];
const _c1 = ["formVeiculo"];
const _c2 = ["formPerfilCarro"];
const _c3 = ["formPerfilCaminhao"];
const _c4 = ["formSeguro"];
function LibFormularioAutoComponent_mat_expansion_panel_header_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel-header", 18)(1, "h1", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Formul\u00E1rio de ", ctx_r0.titulosFormulario[ctx_r0.tipoVeiculo], "");
} }
function LibFormularioAutoComponent_mat_panel_title_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-panel-title", 20)(1, "h2", 21);
    i0.ɵɵtext(2, "Segurado");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.exibirTitulo ? "tem-titulo" : "sem-titulo");
} }
function LibFormularioAutoComponent_mat_expansion_panel_header_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel-header")(1, "mat-panel-title")(2, "h2", 21);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.titulosFormulario[ctx_r0.tipoVeiculo]);
} }
function LibFormularioAutoComponent_mat_expansion_panel_header_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel-header")(1, "mat-panel-title")(2, "h2", 21);
    i0.ɵɵtext(3, "Perfil");
    i0.ɵɵelementEnd()()();
} }
function LibFormularioAutoComponent_mat_expansion_panel_header_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel-header")(1, "mat-panel-title")(2, "h2", 21);
    i0.ɵɵtext(3, "Seguro");
    i0.ɵɵelementEnd()()();
} }
function LibFormularioAutoComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "button", 23);
    i0.ɵɵlistener("click", function LibFormularioAutoComponent_div_22_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.matStepRoute("previous")); });
    i0.ɵɵelementStart(2, "span", 24);
    i0.ɵɵtext(3, "VOLTAR");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "button", 25);
    i0.ɵɵlistener("click", function LibFormularioAutoComponent_div_22_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.salvar()); });
    i0.ɵɵelementStart(5, "span", 24);
    i0.ɵɵtext(6, "SALVAR");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 26);
    i0.ɵɵlistener("click", function LibFormularioAutoComponent_div_22_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.matStepRoute("next")); });
    i0.ɵɵelementStart(8, "span", 24);
    i0.ɵɵtext(9, "PR\u00D3XIMO");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltip", (ctx_r0.draft == null ? null : ctx_r0.draft.status) == undefined || (ctx_r0.draft == null ? null : ctx_r0.draft.status) == 1 ? ctx_r0.toolTipVoltarHome : "VOLTAR PARA RESULTADOS")("matTooltipPosition", "left");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matTooltipPosition", "right");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matTooltipPosition", "right");
} }
class LibFormularioAutoComponent {
    api;
    cdr;
    formsService;
    iconsService;
    routerState;
    formSegurado;
    set contentformSegurado(contentformSegurado) {
        if (contentformSegurado)
            this.formSegurado = contentformSegurado;
    }
    formVeiculo;
    set contentformVeiculo(contentformVeiculo) {
        if (contentformVeiculo)
            this.formVeiculo = contentformVeiculo;
    }
    formPerfilCarro;
    set contentformPerfilCarro(contentformPerfilCarro) {
        if (contentformPerfilCarro)
            this.formPerfilCarro = contentformPerfilCarro;
    }
    formPerfilCaminhao;
    set contentformPerfilCaminhao(contentformPerfilCaminhao) {
        if (contentformPerfilCaminhao)
            this.formPerfilCaminhao = contentformPerfilCaminhao;
    }
    formSeguro;
    set contentformSeguro(contentformSeguro) {
        if (contentformSeguro)
            this.formSeguro = contentformSeguro;
    }
    draft;
    exibirTitulo;
    nomeLoader = 'loader-multi';
    ramo;
    inputMask = false;
    changeSeguradoraSelectedEvent = new EventEmitter();
    changeTpCoberturaSelectedEvent = new EventEmitter();
    matStepRouteEvent = new EventEmitter();
    salvarEvent = new EventEmitter();
    buscaCotacoesEvent = new EventEmitter();
    currentVersion;
    formularioValido = { segurado: false, automovel: false, perfil: false, seguro: false };
    isCopiarCotacao = false;
    isModifiedId = false;
    tipoVeiculo = 'v';
    titulosFormulario = ConstantFormAuto.titulosFormulario;
    userInfos;
    hideAccordion = true;
    intervalExpansionCounter = 0;
    subscriptions = new Subscription();
    toolTipVoltarHome = 'VOLTAR PARA HOME';
    clienteIndisponivel = false;
    //libs
    recalculo = false;
    listaCampo = {};
    painelHab = {
        segurado: false,
        automovel: false,
        perfil: false,
        seguro: false
    };
    constructor(api, cdr, formsService, iconsService, routerState) {
        this.api = api;
        this.cdr = cdr;
        this.formsService = formsService;
        this.iconsService = iconsService;
        this.routerState = routerState;
        iconsService.registerIcons(ConstantFormAuto.icons);
    }
    ngOnInit() {
        this.addDelayMatExpasionPanel();
        this.inscreverEmiters();
    }
    setRecalculo(campos) {
        this.recalculo = true;
        this.listaCampo = campos;
        this.verificaStepHab();
    }
    verificaStepHab() {
        Object.keys(ConstantFormAuto.errosPorStepAuto).forEach(step => {
            for (let index of ConstantFormAuto.errosPorStepAuto[step]) {
                if (this.listaCampo[index]) {
                    this.painelHab[step] = true;
                    break;
                }
                else
                    this.painelHab[step] = false;
            }
        });
    }
    recalcular() {
        return new Promise((resolve) => {
            this.isCopiarCotacao = false;
            this.clicaBotoesSubmit();
            if (this.validarForm()) {
                this.copyObjDraft();
                resolve();
            }
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    ngAfterViewChecked() {
        this.cdr.detectChanges();
    }
    addDelayMatExpasionPanel() {
        let intervalExpansion = setInterval(() => {
            this.intervalExpansionCounter++;
            if (this.intervalExpansionCounter >= 100) {
                this.intervalExpansionCounter = 0;
                clearInterval(intervalExpansion);
                return;
            }
            let elementsAux = document.getElementsByTagName('lib-formulario-auto');
            let elements = elementsAux?.length ? elementsAux[0].getElementsByClassName('ng-trigger-bodyExpansion') : [];
            if (elements?.length == 4
            // &&
            // elements[0]['style']['visibility'] &&
            // elements[1]['style']['visibility'] &&
            // elements[2]['style']['visibility'] &&
            // elements[3]['style']['visibility']
            ) {
                this.intervalExpansionCounter = 0;
                this.hideAccordion = false;
                clearInterval(intervalExpansion);
            }
        }, 100);
    }
    buscarCotacoesRecentes(dados) {
        dados.tipoVeiculo = this.tipoVeiculo;
        this.buscaCotacoesEvent.emit(dados);
    }
    clearFieldsAfterChangeRoute(currentRoute) {
        this.tipoVeiculo = currentRoute ? ConstantFormAuto.tipoVeiculo[currentRoute] : 'v';
        this.formsService.resetaFormulario();
        this.formularioValido = { segurado: false, automovel: false, perfil: false, seguro: false };
    }
    clicaBotoesSubmit() {
        ConstantFormAuto.botoesSubmit.forEach(botao => { document.getElementById(botao).click(); });
    }
    copyDraftObj() {
        this.formsService.preencheFormulario(this.draft);
    }
    copyObjDraft() {
        if (this.draft) {
            this.draft.isClearDraft = false;
            if (this.formsService.isVendaCruzada(this.draft)) {
                this.draft.automoveis = [{}];
                this.draft.automoveis[0]['condutores'] = [{}];
            }
            this.verificaDraft();
            this.copiaParteSegurado();
            this.copiaParteVeiculo();
            this.copiaParteCondutor();
            this.copiaParteSeguro();
        }
    }
    verificaDraft() {
        try {
            const propiedades = [
                'tpCarroceria',
                'tipoCarga',
                'periodoUso',
                'comboio',
                'areaCirculacao',
                'risco',
            ];
            if ('v' == this.draft?.automoveis[0]?.tipo || 'm' == this.draft?.automoveis[0]?.tipo) {
                for (let key of propiedades) {
                    delete this.draft?.automoveis[0][key];
                }
            }
        }
        catch (err) {
            console.log("Erro contacao.service -> verificaDraft ", err);
        }
    }
    copiaParteSegurado() {
        try {
            if (Object.keys(this.formSegurado?.formAutoSegurado.controls).length) {
                Object.keys(ConstantFormAuto.camposSeguradoDraft).forEach(campo => {
                    this.draft.segurado[ConstantFormAuto.camposSeguradoDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formSegurado.formAutoSegurado.controls[campo].value);
                });
                this.draft.segurado.isPCD = this.formVeiculo.formAutoVeiculo.controls.isPCD.value;
            }
        }
        catch (error) {
            return false;
        }
    }
    copiaParteVeiculo() {
        try {
            if (Object.keys(this.formVeiculo?.formAutoVeiculo.controls).length) {
                Object.keys(ConstantFormAuto.camposVeiculoDraft).forEach(campo => {
                    this.draft.automoveis[0][ConstantFormAuto.camposVeiculoDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formVeiculo.formAutoVeiculo.controls[campo].value);
                });
                this.draft.automoveis[0]['valReferenciado'] = this.formVeiculo.formAutoVeiculo.controls['valReferenciado'].value ? FormsService.formatFieldToDraft('valReferenciado', this.formVeiculo.formAutoVeiculo.controls['valReferenciado'].value) : this.draft.automoveis[0]['valReferenciado'];
                this.formVeiculo.formAutoVeiculo.controls.zeroKm.value ?
                    this.draft.automoveis[0].dataHoraSaidaLoja = this.formsService.converteDataAmerica(this.formSeguro.formAutoSeguro.controls.vigenciaIni.value) :
                    this.draft.automoveis[0].dataHoraSaidaLoja = null;
                if (this.formsService.dataHoraSaidaLojaInvalida(this.draft.automoveis[0].dataHoraSaidaLoja)) {
                    this.draft.automoveis[0].dataHoraSaidaLoja = this.formsService.converteDataAmerica(this.formsService.converteDataAmerica(new Date()));
                }
                if (this.formsService.tipoVeiculo(this.draft.automoveis[0].tipo) !== 'CAMINHÃO')
                    delete this.draft.automoveis[0].nrEixos;
                if (this.formsService.tipoVeiculo(this.draft.automoveis[0].tipo) !== 'AUTOMÓVEL')
                    delete this.draft.automoveis[0].gasInstalValor; //realizo essa atibuição pois em um caso de 2017 havia mais de um veículo neste array, sendo o primeiro o correto
                this.draft.automoveis[0] = this.draft.automoveis[0];
            }
        }
        catch (error) {
            return false;
        }
    }
    copiaParteCondutor() {
        try {
            if (this.draft.automoveis[0].condutores.length === 0)
                this.draft.automoveis[0].condutores = [{}];
            if (this.formsService.tipoVeiculo(this.draft?.automoveis[0].tipo) !== 'CAMINHÃO') {
                if (Object.keys(this.formPerfilCarro?.formAutoPerfilCarro.controls).length) {
                    if (this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formPerfilCarro.formAutoPerfilCarro.controls.relacaoSegurado.value) !== 'Sem perfil') {
                        Object.keys(ConstantFormAuto.camposCondutorDraft).forEach(campo => {
                            (this.formPerfilCarro.formAutoPerfilCarro.controls[campo].value ||
                                this.formPerfilCarro.formAutoPerfilCarro.controls[campo].value === 0 ||
                                this.formPerfilCarro.formAutoPerfilCarro.controls[campo].value === false) &&
                                (this.draft.automoveis[0].condutores[0][ConstantFormAuto.camposCondutorDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formPerfilCarro.formAutoPerfilCarro.controls[campo].value));
                        });
                        this.draft.automoveis[0].condutores[0].dataPrimHabil = this.formsService.geraDataPrimHabil(this.formPerfilCarro.formAutoPerfilCarro.controls.tempoHabilitacao.value);
                        this.draft.automoveis[0].condutores[0].principal = true;
                    }
                    else {
                        this.draft.automoveis[0].condutores = [];
                    }
                    Object.keys(ConstantFormAuto.camposPerfilDraft).forEach(campo => {
                        this.formPerfilCarro.formAutoPerfilCarro.controls[campo] && (this.draft.automoveis[0][ConstantFormAuto.camposPerfilDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formPerfilCarro.formAutoPerfilCarro.controls[campo].value));
                    });
                    this.draft.automoveis[0].pctAjuste = this.draft.automoveis[0]?.pctAjuste ? this.draft.automoveis[0].pctAjuste : null;
                    this.draft.automoveis[0].cepCirculacao = this.draft.automoveis[0].cepPernoite;
                }
            }
            else {
                if (Object.keys(this.formPerfilCaminhao?.formAutoPerfilCaminhao.controls).length) {
                    FormsService.atualizaPerguntasAdicionais(this.formPerfilCaminhao.formAutoPerfilCaminhao);
                    if (this.formsService.buscaViewValue(ConstantFormAuto.relacaoSegurado, this.formPerfilCaminhao.formAutoPerfilCaminhao.controls.relacaoSegurado.value) !== 'Sem perfil') {
                        Object.keys(ConstantFormAuto.camposCondutorDraft).forEach(campo => {
                            (this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo]) && (this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo].value ||
                                this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo].value === 0 ||
                                this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo].value === false) &&
                                (this.draft.automoveis[0].condutores[0][ConstantFormAuto.camposCondutorDraft[campo]] =
                                    FormsService.formatFieldToDraft(campo, this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo] ? this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo].value : null));
                        });
                        this.draft.automoveis[0].condutores[0].dataPrimHabil = this.formsService.geraDataPrimHabil(this.formPerfilCaminhao.formAutoPerfilCaminhao.controls.tempoHabilitacao.value);
                        this.draft.automoveis[0].condutores[0].principal = true;
                    }
                    else {
                        this.draft.automoveis[0].condutores = [];
                    }
                    Object.keys(ConstantFormAuto.camposPerfilDraft).forEach(campo => {
                        this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo] && (this.draft.automoveis[0][ConstantFormAuto.camposPerfilDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formPerfilCaminhao.formAutoPerfilCaminhao.controls[campo].value));
                    });
                    this.draft.automoveis[0].pctAjuste = this.draft.automoveis[0]?.pctAjuste ? this.draft.automoveis[0].pctAjuste : null;
                    this.draft.automoveis[0].cepCirculacao = this.draft.automoveis[0].cepPernoite;
                }
            }
            const camposNull = ['idaVoltaTrabalho', 'idaVoltaEstudo', 'tpLocalPernoite'];
            camposNull.forEach(campo => { this.draft.automoveis[0][campo] = null; });
        }
        catch (error) {
            return false;
        }
    }
    copiaParteSeguro() {
        try {
            if (Object.keys(this.formSeguro?.formAutoSeguro.controls).length) {
                Object.keys(ConstantFormAuto.camposSeguroDraft).forEach(campo => {
                    this.draft[ConstantFormAuto.camposSeguroDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formSeguro.formAutoSeguro.controls[campo].value);
                });
            }
        }
        catch (error) {
            return false;
        }
    }
    enviaTipoVeiculo(currentRoute) {
        this.tipoVeiculo = currentRoute ? ConstantFormAuto.tipoVeiculo[currentRoute] : 'v';
        let tipoVeiculoDraft = this.getTipoVeiculoDraft();
        this.formsService.enviaTipoVeiculo(tipoVeiculoDraft ? tipoVeiculoDraft : this.tipoVeiculo);
    }
    enviarInformacoesUsuario(vazio) {
        if (this.userInfos) {
            this.formsService.enviaUserInfos(this.userInfos, vazio);
        }
    }
    async initialize(draft, empty, objadd) {
        this.draft = draft;
        this.currentVersion = objadd?.currentVersion;
        this.isModifiedId = objadd?.modifiedId ? objadd.modifiedId : false;
        this.userInfos = objadd?.userInfos;
        this.setaBlindagem();
        if (!empty)
            this.copyDraftObj();
        else
            this.formsService.setarInfosDefault();
        if (objadd?.isCopiarCotacao)
            this.setaFormularioValido();
        this.enviarInformacoesUsuario(empty);
        this.enviaTipoVeiculo(objadd?.url);
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.coberturaEmiter.subscribe(cobertura => this.updateTpCobertura(cobertura)));
        this.subscriptions.add(this.formsService.formularioValidoEmiter.subscribe(infos => this.formularioValido[infos?.formularioNome] = infos?.valido));
        this.subscriptions.add(this.formsService.seguradoraAnteriorEmiter.subscribe(seguradoraAnterior => this.uploadActivesSeguradoras(seguradoraAnterior)));
        this.subscriptions.add(this.formsService.tipoVeiculoEmiter.subscribe(tipoVeiculo => this.tipoVeiculo = tipoVeiculo));
        this.subscriptions.add(this.formsService.buscaCotacoesEmiter.subscribe(dados => this.buscarCotacoesRecentes(dados)));
        this.subscriptions.add(this.formsService.atualizaDraftFinal.subscribe(() => this.copyObjDraft()));
        this.subscriptions.add(this.formsService.clienteIndisponivelEmiter.subscribe(clienteIndisponivel => this.setClienteIndisponivel(clienteIndisponivel)));
    }
    setaFormularioValido() {
        this.formularioValido = { segurado: true, automovel: true, perfil: true, seguro: true };
    }
    matStepRoute(action) {
        if (action == 'next') {
            this.isCopiarCotacao = false;
            this.clicaBotoesSubmit();
            if (this.clienteIndisponivel) {
                this.formsService.openSnackbarModal('Este cálculo pertence a outro corretor.');
            }
            else {
                if (this.validarForm()) {
                    this.copyObjDraft();
                    this.matStepRouteEvent.emit(action);
                }
                else {
                    this.formsService.openSnackbarModal('Preencha todas informações obrigatórias antes de prosseguir.');
                }
            }
        }
        else {
            if ((this.draft?.status == undefined || this.draft?.status == 1))
                this.routerState.navigateByUrl(this.api.getUrlHome());
            else
                this.matStepRouteEvent.emit(action);
        }
    }
    salvar() {
        this.isCopiarCotacao = false;
        this.copyObjDraft();
        this.salvarEvent.emit({});
    }
    setDraft(draft) {
        this.draft = draft;
        this.copyDraftObj();
    }
    setClienteIndisponivel(clienteIndisponivel) {
        this.clienteIndisponivel = clienteIndisponivel;
    }
    setToolTipHome(tooltip) {
        this.toolTipVoltarHome = tooltip;
    }
    uploadActivesSeguradoras(seguradoraSelectedId) {
        this.changeSeguradoraSelectedEvent.emit(seguradoraSelectedId);
    }
    updateTpCobertura(coberturaSelected) {
        this.changeTpCoberturaSelectedEvent.emit(coberturaSelected);
    }
    validarForm() {
        const segurado = this.formSegurado.formAutoSegurado.valid;
        const veiculo = this.formVeiculo.formAutoVeiculo.valid;
        const perfil = this.formsService.tipoVeiculo(this.tipoVeiculo) !== 'CAMINHÃO' ? this.formPerfilCarro.formAutoPerfilCarro.valid : this.formPerfilCaminhao.formAutoPerfilCaminhao.valid;
        const seguro = this.formSeguro.formAutoSeguro.valid;
        return segurado && veiculo && perfil && seguro;
    }
    getTipoVeiculoDraft() {
        try {
            return this.draft.automoveis[0].tipo;
        }
        catch (error) {
            return false;
        }
    }
    setaBlindagem() {
        try {
            if (this.currentVersion && this.currentVersion.calculos.length) {
                this.formVeiculo.blindagem = !!this.currentVersion.calculos[0].isBlindagemValor;
            }
        }
        catch (error) {
            console.log(error);
            return false;
        }
    }
    static ɵfac = function LibFormularioAutoComponent_Factory(t) { return new (t || LibFormularioAutoComponent)(i0.ɵɵdirectiveInject('api'), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(FormsService), i0.ɵɵdirectiveInject(IconsService), i0.ɵɵdirectiveInject(i4$2.Router)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LibFormularioAutoComponent, selectors: [["lib-formulario-auto"]], viewQuery: function LibFormularioAutoComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
            i0.ɵɵviewQuery(_c3, 5);
            i0.ɵɵviewQuery(_c4, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentformSegurado = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentformVeiculo = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentformPerfilCarro = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentformPerfilCaminhao = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentformSeguro = _t.first);
        } }, inputs: { draft: "draft", exibirTitulo: "exibirTitulo", nomeLoader: "nomeLoader", ramo: "ramo", inputMask: "inputMask" }, outputs: { changeSeguradoraSelectedEvent: "changeSeguradoraSelectedEvent", changeTpCoberturaSelectedEvent: "changeTpCoberturaSelectedEvent", matStepRouteEvent: "matStepRouteEvent", salvarEvent: "salvarEvent", buscaCotacoesEvent: "buscaCotacoesEvent" }, decls: 25, vars: 39, consts: [["formSegurado", ""], ["formVeiculo", ""], ["formPerfilCarro", ""], ["formPerfilCaminhao", ""], ["formSeguro", ""], ["id", "form-auto", 3, "hidden"], [1, "container-form-auto", "accordeons", "d-flex", "justify-content-center"], ["multi", ""], [3, "hideToggle", "ngClass", "expanded", "disabled"], ["class", "d-flex justify-content-center", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "recalculo", "listaCampo"], [4, "ngIf"], [3, "recalculo", "listaCampo", "hidden"], [3, "inputMask", "recalculo", "listaCampo", "hidden"], ["class", "container-buttons-form-auto", 4, "ngIf"], ["id", "content-loader", 3, "ngClass"], [1, "", 3, "src", "hidden"], [1, "d-flex", "justify-content-center"], [1, "title-form-auto"], [3, "ngClass"], [1, "subtitle-form-auto"], [1, "container-buttons-form-auto"], ["name", "btn-voltar", "mat-stroked-button", "", 1, "btn-voltar", 3, "click", "matTooltip", "matTooltipPosition"], [1, "text-btn"], ["name", "btn-salvar", "mat-stroked-button", "", "matTooltip", "SALVAR C\u00C1LCULO", 1, "btn-salvar", 3, "click", "matTooltipPosition"], ["name", "btn-proximo", "mat-flat-button", "", "matTooltip", "SELECIONAR SEGURADORAS", 1, "btn-proximo", 3, "click", "matTooltipPosition"]], template: function LibFormularioAutoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "mat-accordion", 7)(3, "mat-expansion-panel", 8);
            i0.ɵɵtemplate(4, LibFormularioAutoComponent_mat_expansion_panel_header_4_Template, 3, 1, "mat-expansion-panel-header", 9)(5, LibFormularioAutoComponent_mat_panel_title_5_Template, 3, 1, "mat-panel-title", 10);
            i0.ɵɵelement(6, "formulario-auto-segurado", 11, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mat-expansion-panel", 8);
            i0.ɵɵtemplate(9, LibFormularioAutoComponent_mat_expansion_panel_header_9_Template, 4, 1, "mat-expansion-panel-header", 12);
            i0.ɵɵelement(10, "formulario-auto-veiculo", 11, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "mat-expansion-panel", 8);
            i0.ɵɵtemplate(13, LibFormularioAutoComponent_mat_expansion_panel_header_13_Template, 4, 0, "mat-expansion-panel-header", 12);
            i0.ɵɵelement(14, "formulario-auto-perfil-carro", 13, 2)(16, "formulario-auto-perfil-caminhao", 14, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "mat-expansion-panel", 8);
            i0.ɵɵtemplate(19, LibFormularioAutoComponent_mat_expansion_panel_header_19_Template, 4, 0, "mat-expansion-panel-header", 12);
            i0.ɵɵelement(20, "formulario-auto-seguro", 11, 4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(22, LibFormularioAutoComponent_div_22_Template, 10, 4, "div", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "div", 16);
            i0.ɵɵelement(24, "img", 17);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("hidden", ctx.hideAccordion);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", ctx.painelHab.segurado ? "" : "desabilitado")("expanded", true)("disabled", true);
            i0.ɵɵattribute("name", "mat-expansion-segurado");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.recalculo && ctx.exibirTitulo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.recalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("recalculo", ctx.recalculo)("listaCampo", ctx.listaCampo);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.painelHab.automovel ? "" : "desabilitado")("expanded", ctx.formularioValido == null ? null : ctx.formularioValido.segurado)("disabled", true);
            i0.ɵɵattribute("name", "mat-expansion-automovel");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.recalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("recalculo", ctx.recalculo)("listaCampo", ctx.listaCampo);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.painelHab.perfil ? "" : "desabilitado")("expanded", ctx.formularioValido == null ? null : ctx.formularioValido.automovel)("disabled", true);
            i0.ɵɵattribute("name", "mat-expansion-perfil");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.recalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("recalculo", ctx.recalculo)("listaCampo", ctx.listaCampo)("hidden", ctx.tipoVeiculo == "c");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("inputMask", ctx.inputMask)("recalculo", ctx.recalculo)("listaCampo", ctx.listaCampo)("hidden", ctx.tipoVeiculo != "c");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.painelHab.seguro ? "" : "desabilitado")("expanded", ctx.formularioValido == null ? null : ctx.formularioValido.perfil)("disabled", true);
            i0.ɵɵattribute("name", "mat-expansion-seguro");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.recalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("recalculo", ctx.recalculo)("listaCampo", ctx.listaCampo);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.recalculo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.nomeLoader);
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", "./assets/images/" + ctx.nomeLoader + ".gif", i0.ɵɵsanitizeUrl)("hidden", !ctx.hideAccordion);
        } }, dependencies: [i3.NgClass, i3.NgIf, i4.MatButton, i6$1.MatAccordion, i6$1.MatExpansionPanel, i6$1.MatExpansionPanelHeader, i6$1.MatExpansionPanelTitle, i10.MatTooltip, i8$1.InputMaskDirective, FormularioAutoSeguradoComponent, FormularioAutoVeiculoComponent, FormularioAutoPerfilCarroComponent, FormularioAutoPerfilCaminhaoComponent, FormularioAutoSeguroComponent], styles: [".container-form-auto[_ngcontent-%COMP%]{background-color:transparent}.container-form-auto[_ngcontent-%COMP%]   .title-form-auto[_ngcontent-%COMP%]{text-align:center;font-size:22px;text-transform:uppercase;letter-spacing:2px;font-weight:400;color:var(--color-dark);margin-top:.9em;width:100%}.container-form-auto[_ngcontent-%COMP%]   .subtitle-form-auto[_ngcontent-%COMP%]{padding:0 15px;margin-bottom:0;font-size:18px;color:var(--color-tertiary-first);text-transform:uppercase;margin-left:7px!important;line-height:22px;font-weight:500}.container-form-auto[_ngcontent-%COMP%]   .sem-titulo[_ngcontent-%COMP%]{height:64px;align-items:center}@media (max-width: 426px){.container-form-auto[_ngcontent-%COMP%]   .title-form-auto[_ngcontent-%COMP%]{font-size:16px;font-weight:500;margin:0;line-height:20px}.container-form-auto[_ngcontent-%COMP%]   .subtitle-form-auto[_ngcontent-%COMP%]{font-size:14px;font-weight:500}}.container-form-auto[_ngcontent-%COMP%]   .tem-titulo[_ngcontent-%COMP%]{padding-bottom:10px}.container-buttons-form-auto[_ngcontent-%COMP%]{display:flex;align-items:baseline;justify-content:center;background-color:transparent;padding-bottom:10px;gap:24px;margin:0 10px}@media (max-width: 480px){.container-buttons-form-auto[_ngcontent-%COMP%]{gap:8px}}.container-buttons-form-auto[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:40px;padding:10px;border-radius:3px}.container-buttons-form-auto[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{font-size:14px;line-height:normal}.container-buttons-form-auto[_ngcontent-%COMP%]   .btn-voltar[_ngcontent-%COMP%]{width:120px;background-color:transparent;border:1px solid #60616A}.container-buttons-form-auto[_ngcontent-%COMP%]   .btn-voltar[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{color:#60616a;font-weight:400;letter-spacing:normal}.container-buttons-form-auto[_ngcontent-%COMP%]   .btn-salvar[_ngcontent-%COMP%]{width:120px;background-color:transparent;border:1px solid var(--color-tertiary-first)}.container-buttons-form-auto[_ngcontent-%COMP%]   .btn-salvar[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{color:var(--color-tertiary-first);font-weight:400;letter-spacing:normal}.container-buttons-form-auto[_ngcontent-%COMP%]   .btn-proximo[_ngcontent-%COMP%]{width:164px;background-color:var(--color-tertiary-first)}.container-buttons-form-auto[_ngcontent-%COMP%]   .btn-proximo[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{color:#fefefe;font-weight:500;letter-spacing:.42px}.container-buttons-form-auto[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:none}  .container-buttons-form-auto button .mat-mdc-button-touch-target{height:40px}  .container-form-auto .mat-accordion{margin:16px 10px;width:1140px}  .container-form-auto .mat-accordion .mat-expansion-panel:not(.desabilitado) .mat-expansion-panel-content{height:auto!important;visibility:initial!important}  .container-form-auto .mat-accordion .mat-expansion-panel:not(.desabilitado) .mat-expansion-panel-content .mat-expansion-panel-body *{visibility:initial!important}  .container-form-auto .mat-select-value-text{font-weight:400;color:var(--color-dark)}  .container-form-auto .mat-select-value{color:#0000008a}  .container-form-auto .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}  .container-form-auto .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px;background:transparent!important}  .container-form-auto .mat-mdc-form-field-hint-wrapper,   .container-form-auto .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}  .container-form-auto .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}  .container-form-auto .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}  .container-form-auto .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px}  .container-form-auto .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}  .container-form-auto .mdc-text-field--disabled .mdc-line-ripple{display:none}  .container-form-auto .form-auto-step .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}  .container-form-auto .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}  .container-form-auto .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}  .container-form-auto .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,   .container-form-auto .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}  .container-form-auto .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}  .container-form-auto .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}  .container-form-auto .mat-mdc-select-trigger{font-size:14px}  .container-form-auto .mdc-text-field--filled{background-color:transparent!important;padding:0;height:38px}  .container-form-auto .mat-mdc-form-field-focus-overlay{background-color:transparent}  .container-form-auto .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}  .container-form-auto .mat-mdc-form-field-infix{min-height:38px}  .container-form-auto .mat-mdc-select-trigger{height:48px}  .container-form-auto .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}  .container-form-auto .mdc-floating-label{font-size:14px;color:var(--color-dark)}  .container-form-auto .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}  .container-form-auto .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}  .container-form-auto .mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}  .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}  .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--invalid):hover .mdc-line-ripple:before{border-bottom-color:#0000006b}  .container-form-auto .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}  .container-form-auto .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}  .container-form-auto .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}  .container-form-auto .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}  .container-form-auto .mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-checkmark-color: #fff;--mdc-checkbox-selected-focus-icon-color: var(--color-primary);--mdc-checkbox-selected-hover-icon-color: var(--color-primary);--mdc-checkbox-selected-icon-color: var(--color-primary);--mdc-checkbox-selected-pressed-icon-color: var(--color-primary);--mdc-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-selected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54)}  .container-form-auto .mat-mdc-checkbox.mat-accent .mdc-checkbox__ripple{background:var(--color-secundary)}#content-loader[_ngcontent-%COMP%]{display:block;float:left;width:100%}#content-loader[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:block}.loader-multi[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:calc(10% + 57px) auto 0 auto;width:180px;height:62px}.loader-corp[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:calc(10% + 57px) auto 0 auto;width:70px;height:50px}.loader-apice[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:calc(10% + 60px) auto 0 auto;width:164px;height:140px}  .mat-primary .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--color-primary)}  .mat-mdc-option .mdc-list-item__primary-text{font-size:14px!important}  .mdc-tooltip__surface{font-size:10px!important}  .mat-mdc-option .mat-pseudo-checkbox{display:none!important}  .mat-mdc-option-multiple .mat-pseudo-checkbox{display:block!important}@media (min-width: 1200px){  .selects-formulario-auto-veiculo .combustivel,   .selects-formulario-auto-veiculo .portas,   .selects-formulario-auto-veiculo .dispAntiFurto{margin-left:-16px!important;min-width:calc(100% + 32px)}}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibFormularioAutoComponent, [{
        type: Component,
        args: [{ selector: 'lib-formulario-auto', template: "<div [hidden]=\"hideAccordion\" id=\"form-auto\">\r\n  <div class=\"container-form-auto accordeons d-flex justify-content-center\">\r\n    <mat-accordion multi>\r\n\r\n      <mat-expansion-panel [hideToggle] [ngClass]=\"painelHab.segurado ? '' : 'desabilitado'\" [expanded]=\"true\" [disabled]=\"true\" [attr.name]=\"'mat-expansion-segurado'\">\r\n\r\n        <mat-expansion-panel-header  *ngIf=\"!recalculo && exibirTitulo\" class=\"d-flex justify-content-center\">\r\n          <h1 class=\"title-form-auto\">Formul\u00E1rio de {{titulosFormulario[tipoVeiculo]}}</h1>\r\n        </mat-expansion-panel-header>\r\n\r\n        <mat-panel-title *ngIf=\"!recalculo\" [ngClass]=\"exibirTitulo ? 'tem-titulo' : 'sem-titulo'\">\r\n          <h2 class=\"subtitle-form-auto\">Segurado</h2>\r\n        </mat-panel-title>\r\n\r\n        <formulario-auto-segurado [recalculo]=\"recalculo\" [listaCampo]=\"listaCampo\" #formSegurado></formulario-auto-segurado>\r\n\r\n      </mat-expansion-panel>\r\n\r\n      <mat-expansion-panel [hideToggle]  [ngClass]=\"painelHab.automovel ? '' : 'desabilitado'\" [expanded]=\"formularioValido?.segurado\" [disabled]=\"true\" [attr.name]=\"'mat-expansion-automovel'\">\r\n\r\n        <mat-expansion-panel-header *ngIf=\"!recalculo\">\r\n          <mat-panel-title >\r\n            <h2 class=\"subtitle-form-auto\">{{titulosFormulario[tipoVeiculo]}}</h2>\r\n          </mat-panel-title>\r\n        </mat-expansion-panel-header>\r\n\r\n        <formulario-auto-veiculo [recalculo]=\"recalculo\" [listaCampo]=\"listaCampo\" #formVeiculo></formulario-auto-veiculo>\r\n      </mat-expansion-panel>\r\n\r\n      <mat-expansion-panel [hideToggle] [ngClass]=\"painelHab.perfil ? '' : 'desabilitado'\" [expanded]=\"formularioValido?.automovel\" [disabled]=\"true\" [attr.name]=\"'mat-expansion-perfil'\">\r\n        <mat-expansion-panel-header *ngIf=\"!recalculo\">\r\n          <mat-panel-title>\r\n            <h2 class=\"subtitle-form-auto\">Perfil</h2>\r\n          </mat-panel-title>\r\n        </mat-expansion-panel-header>\r\n\r\n        <formulario-auto-perfil-carro [recalculo]=\"recalculo\" [listaCampo]=\"listaCampo\" [hidden]=\"tipoVeiculo == 'c'\" #formPerfilCarro></formulario-auto-perfil-carro>\r\n        <formulario-auto-perfil-caminhao [inputMask]=\"inputMask\" [recalculo]=\"recalculo\" [listaCampo]=\"listaCampo\" [hidden]=\"tipoVeiculo != 'c'\" #formPerfilCaminhao></formulario-auto-perfil-caminhao>\r\n      </mat-expansion-panel>\r\n\r\n      <mat-expansion-panel [hideToggle] [ngClass]=\"painelHab.seguro ? '' : 'desabilitado'\" [expanded]=\"formularioValido?.perfil\" [disabled]=\"true\" [attr.name]=\"'mat-expansion-seguro'\">\r\n        <mat-expansion-panel-header *ngIf=\"!recalculo\">\r\n          <mat-panel-title>\r\n            <h2 class=\"subtitle-form-auto\">Seguro</h2>\r\n          </mat-panel-title>\r\n        </mat-expansion-panel-header>\r\n        <formulario-auto-seguro [recalculo]=\"recalculo\" [listaCampo]=\"listaCampo\" #formSeguro></formulario-auto-seguro>\r\n      </mat-expansion-panel>\r\n\r\n    </mat-accordion>\r\n  </div>\r\n  <div class=\"container-buttons-form-auto\" *ngIf=\"!recalculo\">\r\n    <button name=\"btn-voltar\" mat-stroked-button class=\"btn-voltar\" (click)=\"matStepRoute('previous')\"\r\n    [matTooltip]=\"(draft?.status == undefined || draft?.status == 1) ? toolTipVoltarHome : 'VOLTAR PARA RESULTADOS'\" [matTooltipPosition]=\"'left'\">\r\n      <span class=\"text-btn\">VOLTAR</span>\r\n    </button>\r\n    <button name=\"btn-salvar\" mat-stroked-button class=\"btn-salvar\" (click)=\"salvar()\"\r\n    matTooltip=\"SALVAR C\u00C1LCULO\" [matTooltipPosition]=\"'right'\">\r\n      <span class=\"text-btn\">SALVAR</span>\r\n    </button>\r\n    <button name=\"btn-proximo\" mat-flat-button class=\"btn-proximo\" (click)=\"matStepRoute('next')\"\r\n      matTooltip=\"SELECIONAR SEGURADORAS\" [matTooltipPosition]=\"'right'\">\r\n      <span class=\"text-btn\">PR\u00D3XIMO</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div id=\"content-loader\" [ngClass]=\"nomeLoader\">\r\n  <img class=\"\" [src]=\"'./assets/images/' + nomeLoader + '.gif'\" [hidden]=\"!this.hideAccordion\" />\r\n</div>\r\n", styles: [".container-form-auto{background-color:transparent}.container-form-auto .title-form-auto{text-align:center;font-size:22px;text-transform:uppercase;letter-spacing:2px;font-weight:400;color:var(--color-dark);margin-top:.9em;width:100%}.container-form-auto .subtitle-form-auto{padding:0 15px;margin-bottom:0;font-size:18px;color:var(--color-tertiary-first);text-transform:uppercase;margin-left:7px!important;line-height:22px;font-weight:500}.container-form-auto .sem-titulo{height:64px;align-items:center}@media (max-width: 426px){.container-form-auto .title-form-auto{font-size:16px;font-weight:500;margin:0;line-height:20px}.container-form-auto .subtitle-form-auto{font-size:14px;font-weight:500}}.container-form-auto .tem-titulo{padding-bottom:10px}.container-buttons-form-auto{display:flex;align-items:baseline;justify-content:center;background-color:transparent;padding-bottom:10px;gap:24px;margin:0 10px}@media (max-width: 480px){.container-buttons-form-auto{gap:8px}}.container-buttons-form-auto button{height:40px;padding:10px;border-radius:3px}.container-buttons-form-auto button .text-btn{font-size:14px;line-height:normal}.container-buttons-form-auto .btn-voltar{width:120px;background-color:transparent;border:1px solid #60616A}.container-buttons-form-auto .btn-voltar .text-btn{color:#60616a;font-weight:400;letter-spacing:normal}.container-buttons-form-auto .btn-salvar{width:120px;background-color:transparent;border:1px solid var(--color-tertiary-first)}.container-buttons-form-auto .btn-salvar .text-btn{color:var(--color-tertiary-first);font-weight:400;letter-spacing:normal}.container-buttons-form-auto .btn-proximo{width:164px;background-color:var(--color-tertiary-first)}.container-buttons-form-auto .btn-proximo .text-btn{color:#fefefe;font-weight:500;letter-spacing:.42px}.container-buttons-form-auto button:focus{outline:none}::ng-deep .container-buttons-form-auto button .mat-mdc-button-touch-target{height:40px}::ng-deep .container-form-auto .mat-accordion{margin:16px 10px;width:1140px}::ng-deep .container-form-auto .mat-accordion .mat-expansion-panel:not(.desabilitado) .mat-expansion-panel-content{height:auto!important;visibility:initial!important}::ng-deep .container-form-auto .mat-accordion .mat-expansion-panel:not(.desabilitado) .mat-expansion-panel-content .mat-expansion-panel-body *{visibility:initial!important}::ng-deep .container-form-auto .mat-select-value-text{font-weight:400;color:var(--color-dark)}::ng-deep .container-form-auto .mat-select-value{color:#0000008a}::ng-deep .container-form-auto .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}::ng-deep .container-form-auto .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px;background:transparent!important}::ng-deep .container-form-auto .mat-mdc-form-field-hint-wrapper,::ng-deep .container-form-auto .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}::ng-deep .container-form-auto .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}::ng-deep .container-form-auto .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}::ng-deep .container-form-auto .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px}::ng-deep .container-form-auto .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}::ng-deep .container-form-auto .mdc-text-field--disabled .mdc-line-ripple{display:none}::ng-deep .container-form-auto .form-auto-step .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}::ng-deep .container-form-auto .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}::ng-deep .container-form-auto .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-form-auto .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,::ng-deep .container-form-auto .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-form-auto .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}::ng-deep .container-form-auto .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}::ng-deep .container-form-auto .mat-mdc-select-trigger{font-size:14px}::ng-deep .container-form-auto .mdc-text-field--filled{background-color:transparent!important;padding:0;height:38px}::ng-deep .container-form-auto .mat-mdc-form-field-focus-overlay{background-color:transparent}::ng-deep .container-form-auto .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}::ng-deep .container-form-auto .mat-mdc-form-field-infix{min-height:38px}::ng-deep .container-form-auto .mat-mdc-select-trigger{height:48px}::ng-deep .container-form-auto .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}::ng-deep .container-form-auto .mdc-floating-label{font-size:14px;color:var(--color-dark)}::ng-deep .container-form-auto .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}::ng-deep .container-form-auto .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form-auto .mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}::ng-deep .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--invalid):hover .mdc-line-ripple:before{border-bottom-color:#0000006b}::ng-deep .container-form-auto .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}::ng-deep .container-form-auto .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}::ng-deep .container-form-auto .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form-auto .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}::ng-deep .container-form-auto .mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-checkmark-color: #fff;--mdc-checkbox-selected-focus-icon-color: var(--color-primary);--mdc-checkbox-selected-hover-icon-color: var(--color-primary);--mdc-checkbox-selected-icon-color: var(--color-primary);--mdc-checkbox-selected-pressed-icon-color: var(--color-primary);--mdc-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-selected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54)}::ng-deep .container-form-auto .mat-mdc-checkbox.mat-accent .mdc-checkbox__ripple{background:var(--color-secundary)}#content-loader{display:block;float:left;width:100%}#content-loader img{display:block}.loader-multi img{margin:calc(10% + 57px) auto 0 auto;width:180px;height:62px}.loader-corp img{margin:calc(10% + 57px) auto 0 auto;width:70px;height:50px}.loader-apice img{margin:calc(10% + 60px) auto 0 auto;width:164px;height:140px}::ng-deep .mat-primary .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--color-primary)}::ng-deep .mat-mdc-option .mdc-list-item__primary-text{font-size:14px!important}::ng-deep .mdc-tooltip__surface{font-size:10px!important}::ng-deep .mat-mdc-option .mat-pseudo-checkbox{display:none!important}::ng-deep .mat-mdc-option-multiple .mat-pseudo-checkbox{display:block!important}@media (min-width: 1200px){::ng-deep .selects-formulario-auto-veiculo .combustivel,::ng-deep .selects-formulario-auto-veiculo .portas,::ng-deep .selects-formulario-auto-veiculo .dispAntiFurto{margin-left:-16px!important;min-width:calc(100% + 32px)}}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['api']
            }] }, { type: i0.ChangeDetectorRef }, { type: FormsService }, { type: IconsService }, { type: i4$2.Router }], { contentformSegurado: [{
            type: ViewChild,
            args: ['formSegurado']
        }], contentformVeiculo: [{
            type: ViewChild,
            args: ['formVeiculo']
        }], contentformPerfilCarro: [{
            type: ViewChild,
            args: ['formPerfilCarro']
        }], contentformPerfilCaminhao: [{
            type: ViewChild,
            args: ['formPerfilCaminhao']
        }], contentformSeguro: [{
            type: ViewChild,
            args: ['formSeguro']
        }], draft: [{
            type: Input
        }], exibirTitulo: [{
            type: Input
        }], nomeLoader: [{
            type: Input
        }], ramo: [{
            type: Input
        }], inputMask: [{
            type: Input
        }], changeSeguradoraSelectedEvent: [{
            type: Output
        }], changeTpCoberturaSelectedEvent: [{
            type: Output
        }], matStepRouteEvent: [{
            type: Output
        }], salvarEvent: [{
            type: Output
        }], buscaCotacoesEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LibFormularioAutoComponent, { className: "LibFormularioAutoComponent", filePath: "lib\\lib-formulario-auto.component.ts", lineNumber: 18 }); })();

class ModalCepModule {
    static ɵfac = function ModalCepModule_Factory(t) { return new (t || ModalCepModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ModalCepModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            provideNgxMask(),
        ], imports: [CommonModule,
            FormsModule,
            MatButtonModule,
            MatDialogModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatSelectModule,
            ReactiveFormsModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalCepModule, [{
        type: NgModule,
        args: [{
                declarations: [ModalCepComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    MatButtonModule,
                    MatDialogModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatInputModule,
                    MatSelectModule,
                    NgxMaskDirective,
                    NgxMaskPipe,
                    ReactiveFormsModule,
                ],
                exports: [ModalCepComponent],
                providers: [
                    provideNgxMask(),
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ModalCepModule, { declarations: [ModalCepComponent], imports: [CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        NgxMaskDirective,
        NgxMaskPipe,
        ReactiveFormsModule], exports: [ModalCepComponent] }); })();

class LibFormularioAutoModule {
    static ɵfac = function LibFormularioAutoModule_Factory(t) { return new (t || LibFormularioAutoModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LibFormularioAutoModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            provideNgxMask(),
            FormsService,
            IconsService,
        ], imports: [CdkAccordionModule,
            CommonModule,
            FormsModule,
            MatAutocompleteModule,
            MatButtonModule,
            MatCardModule,
            MatCheckboxModule,
            MatDialogModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatProgressSpinnerModule,
            MatSelectModule,
            MatSnackBarModule,
            MatTooltipModule,
            ModalCepModule,
            ReactiveFormsModule,
            InputMaskModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibFormularioAutoModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormularioAutoSeguradoComponent,
                    FormularioAutoVeiculoComponent,
                    FormularioAutoPerfilCarroComponent,
                    FormularioAutoPerfilCaminhaoComponent,
                    FormularioAutoSeguroComponent,
                    LibFormularioAutoComponent,
                ],
                imports: [
                    CdkAccordionModule,
                    CommonModule,
                    FormsModule,
                    MatAutocompleteModule,
                    MatButtonModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDialogModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatInputModule,
                    MatProgressSpinnerModule,
                    MatSelectModule,
                    MatSnackBarModule,
                    MatTooltipModule,
                    ModalCepModule,
                    NgxMaskDirective,
                    NgxMaskPipe,
                    ReactiveFormsModule,
                    NgxCurrencyDirective,
                    InputMaskModule
                ],
                exports: [
                    LibFormularioAutoComponent
                ],
                providers: [
                    provideNgxMask(),
                    FormsService,
                    IconsService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibFormularioAutoModule, { declarations: [FormularioAutoSeguradoComponent,
        FormularioAutoVeiculoComponent,
        FormularioAutoPerfilCarroComponent,
        FormularioAutoPerfilCaminhaoComponent,
        FormularioAutoSeguroComponent,
        LibFormularioAutoComponent], imports: [CdkAccordionModule,
        CommonModule,
        FormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        ModalCepModule,
        NgxMaskDirective,
        NgxMaskPipe,
        ReactiveFormsModule,
        NgxCurrencyDirective,
        InputMaskModule], exports: [LibFormularioAutoComponent] }); })();

/*
 * Public API Surface of formulario-auto
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibFormularioAutoComponent, LibFormularioAutoModule };
